export const hardcodedResources = {
  zh: {
    'opportunity_close.action': '关单',
    'opportunity_close.title': '关闭商机项目',
    'opportunity_close.subtitle': '关单后，该商机项目将不再显示在 OA 中。',
    'opportunity_close.remark': '关单备注',
    'opportunity_close.remark_placeholder': '请填写关单原因或补充说明',
    'opportunity_close.remark_required': '关单备注不能为空',
    'opportunity_close.confirm': '确认关单',
    'opportunity_close.success': '已提交 SAP 项目关闭请求',
    'opportunity_close.failed': '关闭项目失败',
    'opportunity_close.no_sap_code': '该商机尚未生成 SAP 项目编号',
    'opportunity_close.partial_warning': '关单已成功，但备注记录失败，请联系管理员',
    'opportunity_close.info_title': '关单信息',
    'opportunity_close.closed_by': '关单人',
    'opportunity_close.closed_on': '关单时间',
    'api.auth.provider.8f243339': '账号或密码错误',
    'api.auth.provider.df7d98cc': '登录失败',
    'api.auth.provider.serviceUnavailable': '认证服务暂时不可用，请稍后重试',
    'api.use.can.a9dd1e49':
      '[useCan] capability "{{v0}}" 未在 CAPABILITY_PRIVILEGE_MAP 注册，默认 allow。请在 use-can.ts 加映射。',
    'app.707cf2ac': '线索',
    'app.8de44d6e': '商机',
    'app.94022906': '中信保',
    'app.94fed782': '交付项目',
    'app.salesorder': '订单',
    'app.b61a1e83': '联系人',
    'app.contracts': '合同单',
    'app.contractTemplates': '合同模板',
    'app.d19594fe': '客户',
    'app.e11951f6': '报价单',
    'common.create_draft_failed': '保存草稿失败',
    'common.create_draft_saved': '已保存到草稿箱',
    'common.create_drafts': '草稿箱',
    'common.save_create_draft': '暂存',
    'components.activity.activitypanel.014da488': '活动 ({{v0}})',
    'components.activity.activitypanel.1b6b3ee7': '字段批注',
    'components.activity.activitypanel.1c3342ec': '回复',
    'components.activity.activitypanel.28e4e6f9': '活动',
    'components.activity.activitypanel.2a1ff916': '评论',
    'components.activity.activitypanel.2dd898a7': '用户',
    'components.activity.activitypanel.2e1907f0': '回复 @{{v0}}…',
    'components.activity.activitypanel.2e6e5f91': '回复失败',
    'components.activity.activitypanel.4688262e': '邮件',
    'components.activity.activitypanel.4692c439': '取消',
    'components.activity.activitypanel.4771d02a': '刚刚',
    'components.activity.activitypanel.5f9409a6': '暂无活动记录',
    'components.activity.activitypanel.6dcd89c2': '笔记',
    'components.activity.activitypanel.72ac8940': '任务',
    'components.activity.activitypanel.76365814': '通话',
    'components.activity.activitypanel.76f90518': '更多',
    'components.activity.activitypanel.77f33797': '展开',
    'components.activity.activitypanel.7e9082b9': '{{v0}} 天前',
    'components.activity.activitypanel.86ed5e7d': '发送',
    'components.activity.activitypanel.8d8e324c': '刷新',
    'components.activity.activitypanel.93967614': '会议',
    'components.activity.activitypanel.9789668a': '该字段暂无批注',
    'components.activity.activitypanel.a1201945': '任务内容 (第一行作为标题)',
    'components.activity.activitypanel.a7ea49c9': '{{v0}} 分钟前',
    'components.activity.activitypanel.aafe6fa2': '系统',
    'components.activity.activitypanel.abcd3ea2': ' · 字段: {{v0}}',
    'components.activity.activitypanel.aeac7026': '删除失败',
    'components.activity.activitypanel.b5e63ca3': '{{v0}} 小时前',
    'components.activity.activitypanel.b83acbc1': '{{v0}} 内容…',
    'components.activity.activitypanel.c03fde6f': '置顶',
    'components.activity.activitypanel.c1d301b4': '系统记录 ({{v0}})',
    'components.activity.activitypanel.c6211f8f': '发送失败',
    'components.activity.activitypanel.e11a5abb': '删除',
    'components.activity.activitypanel.e9a417ac': '内容不能为空',
    'components.activity.activitypanel.f34624c6': '系统记录',
    'components.activity.activitypanel.fd70b176': '字段:',
    'components.activity.activitypanel.read_only': '只读',
    'components.activity.fieldcommenticon.172a8220': '{{v0}} 条批注',
    'components.activity.fieldcommenticon.1d2b9f98': '字段批注 — {{v0}}',
    'components.activity.fieldcommenticon.26ddd607': '添加批注',
    'components.admincrudpage.129b37d5': '{{v0}} 必填',
    'components.admincrudpage.1417a090': '条',
    'components.admincrudpage.1a2c9d1e': '取消',
    'components.admincrudpage.31df53a6': '编辑',
    'components.admincrudpage.31fcda51': '共 {{v0}} 条',
    'components.admincrudpage.44943c2d': '删除失败',
    'components.admincrudpage.50f9534c': '保存失败',
    'components.admincrudpage.9f199bf7': '删除',
    'components.admincrudpage.a0a0ea31': '按关键字搜索',
    'components.admincrudpage.b013b4d4': '是',
    'components.admincrudpage.b4acc92f': '否',
    'components.admincrudpage.cda58363': '共',
    'components.admincrudpage.d3f1c527': '刷新',
    'components.admincrudpage.eee8b8b4': '操作',
    'components.attachment.categories.01279540': '需求',
    'components.attachment.categories.12504de1': '标书',
    'components.attachment.categories.138d6083': '个人履历',
    'components.attachment.categories.29fd4889': '方案',
    'components.attachment.categories.384598ed': '合同',
    'components.attachment.categories.3e1c4312': '其他',
    'components.attachment.categories.4b84ceb6': '企业宣讲',
    'components.attachment.categories.576df17c': '产品手册',
    'components.attachment.categories.5e8f1f3d': '公司介绍',
    'components.attachment.categories.6eec46f3': '客户介绍',
    'components.attachment.categories.70a7f7dd': '头像',
    'components.attachment.categories.84668ef4': '方案书',
    'components.attachment.categories.b0261104': '资质证书',
    'components.attachment.categories.dce38cbf': '名片',
    'components.attachment.categories.f7a669b1': '协议',
    'components.attachmentlist.052f9822': 'PowerPoint 演示 (.ppt)',
    'components.attachmentlist.05c546a9': '立即下载',
    'components.attachmentlist.0635039f': '加载预览失败',
    'components.attachmentlist.095e9359': '评论提交失败',
    'components.attachmentlist.0e3db995': '删除失败',
    'components.attachmentlist.12f8513b':
      '评论将自动归档到右侧"活动"时间轴；此评论关联到该附件，便于后续审计和追溯。',
    'components.attachmentlist.1c68c1e0': '该格式不支持预览, 点击查看详情',
    'components.attachmentlist.2410fefb': '正在加载预览...',
    'components.attachmentlist.27858f72': 'Word 文档 (.docx)',
    'components.attachmentlist.29cccdd9': '{{v0}} 文件',
    'components.attachmentlist.2e798da5': '的评论',
    'components.attachmentlist.32457deb': 'Word 文档 (.doc)',
    'components.attachmentlist.392fba2f': 'PowerPoint 演示 (.pptx)',
    'components.attachmentlist.4a353ea3': '个文件）',
    'components.attachmentlist.548335a6': '此格式暂不支持浏览器内预览，请下载后用对应软件打开。',
    'components.attachmentlist.5c6e3570': '对附件-{{v0}}-{{v1}}的评论',
    'components.attachmentlist.644d586b': '上传失败 {{v0}} 个',
    'components.attachmentlist.683a791f': '未知格式',
    'components.attachmentlist.6fe83bb3': '关闭',
    'components.attachmentlist.71ced9b4': '发表评论',
    'components.attachmentlist.754ad042': 'TAR 压缩包',
    'components.attachmentlist.79457e52': '对附件',
    'components.attachmentlist.7c7e8489': '上传成功 {{v0}} / 失败 {{v1}}',
    'components.attachmentlist.7fe9a9c7': 'Excel 表格 (.xls)',
    'components.attachmentlist.87ba29e8': '已删除',
    'components.attachmentlist.8816c7a7': '取消',
    'components.attachmentlist.92b86c26': '下载失败',
    'components.attachmentlist.9420b428': '正在上传...',
    'components.attachmentlist.99d7bdc0': 'ZIP 压缩包',
    'components.attachmentlist.9b9d6908': '下载',
    'components.attachmentlist.9df1e88b': '删除',
    'components.attachmentlist.a8865368': '确认删除？',
    'components.attachmentlist.a8a9800a': '{{v0}} 分类下暂无文件',
    'components.attachmentlist.a8d9badd': '评论',
    'components.attachmentlist.ae3e23a5': '.{{v0}} 文件',
    'components.attachmentlist.bb4d25f1': '可预览',
    'components.attachmentlist.c22fb256': '7Z 压缩包',
    'components.attachmentlist.c45edfe5': '在线预览',
    'components.attachmentlist.c5dee85b': '请填写评论内容',
    'components.attachmentlist.c8f11ff5': '已上传 {{v0}} 个文件 → {{v1}}',
    'components.attachmentlist.ca7d6281': '评论已添加到时间轴',
    'components.attachmentlist.cc19bcc5': '请输入对该附件的评论 / 反馈 / 修改建议...',
    'components.attachmentlist.cd51a27b': 'Excel 表格 (.xlsx)',
    'components.attachmentlist.d34f31bd': 'RAR 压缩包',
    'components.attachmentlist.ee3ca748': 'Word 文档渲染失败: {{v0}}',
    'components.attachmentlist.f23e42ab': '全部',
    'components.attachmentlist.f704202f': '预览',
    'components.attachmentlist.fc10e2cc': '取消（放弃这',
    'components.createdraftlist.actions': '操作',
    'components.createdraftlist.continue_edit': '继续编辑',
    'components.createdraftlist.delete_content': '删除后无法恢复，是否继续？',
    'components.createdraftlist.delete_success': '草稿已删除',
    'components.createdraftlist.delete_title': '删除草稿',
    'components.createdraftlist.empty_description': '点击新建页底部的“暂存”后会出现在这里。',
    'components.createdraftlist.empty_title': '暂无草稿',
    'components.createdraftlist.error': '失败原因',
    'components.createdraftlist.modifiedon': '更新时间',
    'components.createdraftlist.search': '搜索草稿',
    'components.createdraftlist.source': '来源',
    'components.createdraftlist.source_failed': '创建失败自动保存',
    'components.createdraftlist.source_manual': '手动暂存',
    'components.createdraftlist.subtitle': '共 {{v0}} 条草稿',
    'components.createdraftlist.title': '草稿标题',
    'components.entitylookup.44b8f1f6': '无匹配',
    'components.entitylookup.60330e73': '请选择或搜索',
    'components.exportbutton.e45f482a': '导出失败',
    'components.fullnamepreview.df723bc9': '请先填写 姓 与 名',
    'components.languageswitcher.aa336229': '简体中文',
    'components.languageswitcher.c1b0f4d2': '切换语言',
    'components.roleavatarswitcher.08d325f3': '当前属性',
    'components.roleavatarswitcher.16f0f25a': '海外用户',
    'components.roleavatarswitcher.39f48843': '国内用户',
    'components.roleavatarswitcher.4c1b0b4e': '修改登录密码',
    'components.roleavatarswitcher.4f30b6b7': '密码已修改',
    'components.roleavatarswitcher.5aa12dc8': '新密码至少 8 位',
    'components.roleavatarswitcher.5ab42f91': '姓名',
    'components.roleavatarswitcher.5c7ed106': '账号',
    'components.roleavatarswitcher.61b2d2d4': '用户属性',
    'components.roleavatarswitcher.6d2ea9a6': '界面语言',
    'components.roleavatarswitcher.75f2cba9': '请输入新密码',
    'components.roleavatarswitcher.7d77d073': '默认货币',
    'components.roleavatarswitcher.7f6173b9': '新密码',
    'components.roleavatarswitcher.87c1d6f7': '角色',
    'components.roleavatarswitcher.88e84432': '请输入当前密码',
    'components.roleavatarswitcher.8cbf162d':
      '国内/海外属性可在头像菜单下方切换；切换后会同步更新界面语言。',
    'components.roleavatarswitcher.91dbb767': '业务部门',
    'components.roleavatarswitcher.9d8c7e31': '个人中心',
    'components.roleavatarswitcher.a7f4c2d0': '个人设置',
    'components.roleavatarswitcher.b62cb8b4': '保存密码',
    'components.roleavatarswitcher.c53254c8': '确认新密码',
    'components.roleavatarswitcher.c53cec6e': '请再次输入新密码',
    'components.roleavatarswitcher.e0a98aa3': '当前密码',
    'components.roleavatarswitcher.f020f65a': '密码修改失败',
    'components.roleavatarswitcher.fab8c53c': '两次输入的新密码不一致',
    'components.multientitychecklist.4c2f97ed': '已选',
    'components.multientitychecklist.5ece769c': '暂无数据',
    'components.multientitychecklist.69184c16': '搜索名称...',
    'components.multientitychecklist.a4bb060d': '当前过滤外:',
    'components.multientitychecklist.a68761b6': '清空',
    'components.multientitychecklist.b195cfe4': '无匹配',
    'components.multientitylookup.6698fd0b': '搜索并选择多个...',
    'components.multientitylookup.80f289c4': '无匹配',
    'components.multipresalessubgrid.00ea88d7': '添加用户',
    'components.multipresalessubgrid.054f7181': '无匹配用户，输入关键字搜索',
    'components.multipresalessubgrid.087a7cfe': '该用户立即获得本商机的 read + quote_create 权限',
    'components.multipresalessubgrid.1294eabc': '添加后立即生效',
    'components.multipresalessubgrid.1bd1158a': '(可选)',
    'components.multipresalessubgrid.20116f0c':
      '增加销售技术支持用户后，该用户自动获得本商机的读取权限和报价单创建权限',
    'components.multipresalessubgrid.2cabf945': '刷新',
    'components.multipresalessubgrid.2cc2b4af': '移除失败：{{v0}}',
    'components.multipresalessubgrid.2f231f3a': '已移除',
    'components.multipresalessubgrid.2f80117f':
      '该用户立即可以查看本商机详情并创建报价单。请确认人选无误。',
    'components.multipresalessubgrid.375795da': '共',
    'components.multipresalessubgrid.4c52b063': '移除后该用户将失去本商机的访问权限',
    'components.multipresalessubgrid.54b39975': '位',
    'components.multipresalessubgrid.6f7c8822': '取消',
    'components.multipresalessubgrid.9a79f896': '添加失败：{{v0}}',
    'components.multipresalessubgrid.afaec564': '未知错误',
    'components.multipresalessubgrid.b658a1fb': '添加',
    'components.multipresalessubgrid.c10f6e36': '暂无销售技术支持用户',
    'components.multipresalessubgrid.c5a8e98d': '请选择用户',
    'components.multipresalessubgrid.d104670c': '操作',
    'components.multipresalessubgrid.ddc95272': '移除',
    'components.multipresalessubgrid.e421d84d': '添加销售技术支持用户',
    'components.multipresalessubgrid.f6a38533': '确认移除？',
    'components.multipresalessubgrid.fa27e84f': '搜索用户姓名 / 邮箱',
    'components.multipresalessubgrid.fffbb8a4':
      '已添加销售技术支持用户（已自动授权 read + quote_create）',
    'components.notificationbell.09896576': '通知中心',
    'components.notificationbell.6e6a5318': '全部已读',
    'components.notificationbell.efe7b36b': '暂无通知',
    'components.pricelookup.32631649': '有效期：',
    'components.pricelookup.5431fe18': '找到 {{v0}} 条匹配，已标记 best',
    'components.pricelookup.6e5060e6': '提交查询以获取价格',
    'components.pricelookup.7501f849': '提示：留空字段不参与过滤；命中分数 = 匹配字段数',
    'components.pricelookup.7b82def6': '未知错误',
    'components.pricelookup.7fc7a83f': '命中分',
    'components.pricelookup.8bb22a17': '毛利率',
    'components.pricelookup.9df8132e': '永久',
    'components.pricelookup.a6b1d076': '目录价',
    'components.pricelookup.aa7a09e6': '选择子分类',
    'components.pricelookup.ba589739': '授权价',
    'components.pricelookup.bcbba170': '来源',
    'components.pricelookup.c08b43c7': '(海外 / overseas)',
    'components.pricelookup.ce219cb5': '查询失败：{{v0}}',
    'components.pricelookup.e0b11d12': '折扣价',
    'components.pricelookup.ef2f013a': '未找到匹配价格 — 检查 subclass/country 或时段',
    'components.pricelookup.f79bd6a9': '(未命名)',
    'components.quickcreate.134a0258': '客户',
    'components.quickcreate.29fe7ff8': '已创建 {{v0}}',
    'components.quickcreate.4c4f8cef': '{{v0}} 必填',
    'components.quickcreate.565b8f45': '联系人',
    'components.quickcreate.66dd37f8': '为必填项 ·\n              完整字段请在创建后于详情页编辑',
    'components.quickcreate.80ec98b9': '新建{{v0}}',
    'components.quickcreate.94e3228a': '潜在客户',
    'components.quickcreate.ab7a04d2': '创建并打开',
    'components.quickcreate.b926d920': '商机',
    'components.quickcreate.b92eb156': '带',
    'components.quickcreate.d8c044c6': '取消',
    'components.quickcreate.e743f5f8': '报价单',
    'components.quickcreate.f2c95e85': '创建失败',
    'components.salesforecastsubgrid.06bb4411': '按产品大类 / 子分类 / 频段 / 数量预测销售机会',
    'components.salesforecastsubgrid.0f39e8bd': '新增预测',
    'components.salesforecastsubgrid.117a9e04': '单价',
    'components.salesforecastsubgrid.1a8a79a3': '新增',
    'components.salesforecastsubgrid.1f295ca5': '(可选)',
    'components.salesforecastsubgrid.218410fc': '子分类',
    'components.salesforecastsubgrid.21bc6c8b': '已删除',
    'components.salesforecastsubgrid.269af719': '海外市场部商机必须至少有 1 条 Sales Forecast',
    'components.salesforecastsubgrid.2b52b5c4': '刷新',
    'components.salesforecastsubgrid.2e5073ef': '请先选大类',
    'components.salesforecastsubgrid.318dad42':
      '填写后会自动计算行收入,并汇总到商机的预计收入 (手册 §3.2)',
    'components.salesforecastsubgrid.48f4ac77': '已更新',
    'components.salesforecastsubgrid.4bcc0770': '编辑 Sales Forecast',
    'components.salesforecastsubgrid.4dd192ab': '预计单价',
    'components.salesforecastsubgrid.50a2c8a5': '数量',
    'components.salesforecastsubgrid.56ac279b': '暂无 Sales Forecast',
    'components.salesforecastsubgrid.6b8c78d4': '频段',
    'components.salesforecastsubgrid.6cd6d2ed': '已新增',
    'components.salesforecastsubgrid.7187485d': '删除失败：{{v0}}',
    'components.salesforecastsubgrid.71d3f13a': '操作',
    'components.salesforecastsubgrid.7593d687': '选择子分类',
    'components.salesforecastsubgrid.82531980':
      '提交审批前请添加产品分类与预计数量。Overseas BU opportunities require ≥1 forecast row before submit.',
    'components.salesforecastsubgrid.82c56534': '请选择产品大类',
    'components.salesforecastsubgrid.8364c59e': '新增 Sales Forecast',
    'components.salesforecastsubgrid.83f79f54': '共',
    'components.salesforecastsubgrid.84ed6d3a': '条',
    'components.salesforecastsubgrid.8558bfac': '选择大类',
    'components.salesforecastsubgrid.87e90293': '备注',
    'components.salesforecastsubgrid.col_status': '状态',
    'components.salesforecastsubgrid.col_probability': '概率',
    'components.salesforecastsubgrid.col_order_timing': '订单时间',
    'components.salesforecastsubgrid.col_product_comments': '产品备注',
    'components.salesforecastsubgrid.status_ongoing': '进行中',
    'components.salesforecastsubgrid.status_closed_po': '已关闭 - 收到PO',
    'components.salesforecastsubgrid.status_closed_lost': '已关闭 - 丢单',
    'components.salesforecastsubgrid.status_deleted': '已删除 - 录入错误',
    'components.salesforecastsubgrid.placeholder_status': '选择状态',
    'components.salesforecastsubgrid.placeholder_probability': '选择概率',
    'components.salesforecastsubgrid.placeholder_order_timing': '选择订单时间',
    'components.salesforecastsubgrid.placeholder_band_select_sub_first': '请先选择子类',
    'components.salesforecastsubgrid.placeholder_band_no_bands': '该子类无关联频段',
    'components.salesforecastsubgrid.96ae7c7a': '保存失败：{{v0}}',
    'components.salesforecastsubgrid.9e66f163': '预计数量',
    'components.salesforecastsubgrid.ac8daf5c': '请选择子分类',
    'components.salesforecastsubgrid.c541642c': '产品大类',
    'components.salesforecastsubgrid.c8e9d2ac': '保存',
    'components.salesforecastsubgrid.cc525d7a': '未知错误',
    'components.salesforecastsubgrid.d4aa77f7': '行总价',
    'components.salesforecastsubgrid.d8c46128': '取消',
    'components.salesforecastsubgrid.da9fde38': '确认删除？',
    'components.salesforecastsubgrid.f09bf02f': '编辑',
    'components.salesforecastsubgrid.f2614234': '删除',
    'components.salesforecastsubgrid.fbebea52': '请填数量',
    'components.salesforecastsubgrid.totalRevenue': '总价',
    'components.ui.emptystate.aee82bb7': '暂无数据',
    'dynamic.deeplinkRedirecting': '正在跳转到 {{entity}}{{suffix}}...',
    'dynamic.deeplinkUnknownEntity': '未知的实体类型: {{entity}}',
    'pages.account.accountcreatemodal.054d9992': '例: N30',
    'pages.account.accountcreatemodal.05e1cf71': '语言代码',
    'pages.account.accountcreatemodal.086fcd81': '联系人姓',
    'pages.account.accountcreatemodal.10386d01':
      'SAP 系统使用的客户语言代码 (如 ZH/EN/JA), 区别于通讯偏好',
    'pages.account.accountcreatemodal.111b9320': '频段',
    'pages.account.accountcreatemodal.138a6eb0': '主要联系人电话',
    'pages.account.accountcreatemodal.142b6d23': '联系人名',
    'pages.account.accountcreatemodal.15c590f1': '未知',
    'pages.account.accountcreatemodal.1651cc2e': '价目表',
    'pages.account.accountcreatemodal.1679bdfa': '上级客户',
    'pages.account.accountcreatemodal.20bcfde8': '详情',
    'pages.account.accountcreatemodal.22158bc9':
      '该值会同步保存为客户的「主要电话」(account.telephone1) — 详情页 客户信息 中显示',
    'pages.account.accountcreatemodal.2237066f': '员工人数',
    'pages.account.accountcreatemodal.23213926': '网站',
    'pages.account.accountcreatemodal.23b31c51': '客户联系方式',
    'pages.account.accountcreatemodal.2b119f7d':
      '客户已创建, 但联系人创建/绑定失败: {{v0}} — 请到客户详情页手动新建联系人',
    'pages.account.accountcreatemodal.2b557047':
      '💡 同步到 SAP 时必须满足的字段, 见"概要"tab; 此处补充 SAP 专属属性',
    'pages.account.accountcreatemodal.parent_account_placeholder': '请选择或搜索上级客户',
    'pages.account.accountcreatemodal.sales_office_placeholder': '请选择或搜索销售办公室',
    'pages.account.accountcreatemodal.priceListDisabled': '创建客户后自动分配价目表',
    'pages.account.accountcreatemodal.ship_to_account_placeholder': '请选择或搜索送货客户',
    'pages.account.accountcreatemodal.invoice_account_placeholder': '请选择或搜索发票客户',
    'pages.account.accountcreatemodal.2b6a0afd': '国家区号必填',
    'pages.account.accountcreatemodal.2e22cf77': '国家代码必填',
    'pages.account.accountcreatemodal.2ee91687': '— 未保存',
    'pages.account.accountcreatemodal.3075b21e':
      'ZSDIF004.ZREFE — 客户介绍人姓名 (中信保/抽佣报表用)',
    'pages.account.accountcreatemodal.32556db7': '签约公司必填',
    'pages.account.accountcreatemodal.34ecc64b': '描述',
    'pages.account.accountcreatemodal.358d3e18': '签约公司',
    'pages.account.accountcreatemodal.387b6cc6': '传真',
    'pages.account.accountcreatemodal.3992ceaa': '联系人全名',
    'pages.account.accountcreatemodal.3b4352e7': '基本信息',
    'pages.account.accountcreatemodal.3bf5e346': '销售模式必填',
    'pages.account.accountcreatemodal.3bf86e51': '概要',
    'pages.account.accountcreatemodal.3cbd1d86': '介绍人比例 (%)',
    'pages.account.accountcreatemodal.3e266e5a': 'SAP 客户扩展',
    'pages.account.accountcreatemodal.40e3a821': '客户介绍、合作背景等',
    'pages.account.accountcreatemodal.447876be': '主要联系人电话必填',
    'pages.account.accountcreatemodal.4a31228f': '邮箱格式不正确',
    'pages.account.accountcreatemodal.4d0a6588': '附件',
    'pages.account.accountcreatemodal.4de28365': '(SAP 同步后自动)',
    'pages.account.accountcreatemodal.4f5f7ddb': '客户 · Account',
    'pages.account.accountcreatemodal.4faaf2e3': '关联商机失败 ({{v0}} 个), 可在详情页手动关联',
    'pages.account.accountcreatemodal.4fd8bde8': '货币',
    'pages.account.accountcreatemodal.50ef489f': '客户分类必填',
    'pages.account.accountcreatemodal.5133c121': '销售办公室',
    'pages.account.accountcreatemodal.5141059d': '法定代表人',
    'pages.account.accountcreatemodal.535e79bf': '创建并打开',
    'pages.account.accountcreatemodal.546dad2a': '移除',
    'pages.account.accountcreatemodal.5a58be55': '客户所属部门必填',
    'pages.account.accountcreatemodal.5c9d7e4a': '介绍人',
    'pages.account.accountcreatemodal.631fe0f1': '公司信息',
    'pages.account.accountcreatemodal.63d21408': '客户总账组',
    'pages.account.accountcreatemodal.63f4f0a9': '所属母公司客户',
    'pages.account.accountcreatemodal.64702bd8': '创建失败: {{v0}}',
    'pages.account.accountcreatemodal.66caf8ec': '联系人职务',
    'pages.account.accountcreatemodal.ownership_public': '公共事业',
    'pages.account.accountcreatemodal.ownership_private': '私人公司',
    'pages.account.accountcreatemodal.ownership_subsidiary': '子公司',
    'pages.account.accountcreatemodal.ownership_other': '其他',
    'pages.account.accountcreatemodal.68292149':
      '附件: 成功 {{v0}} / 失败 {{v1}}, 失败的可在详情页重传',
    'pages.account.accountcreatemodal.7462bde8': '发票客户',
    'pages.account.accountcreatemodal.74fdb74d': '街道 2',
    'pages.account.accountcreatemodal.7f6de2eb': '已创建客户 {{v0}}',
    'pages.account.accountcreatemodal.7f9e6f50': '市/县',
    'pages.account.accountcreatemodal.817891b1': '点击或拖拽上传',
    'pages.account.accountcreatemodal.8422aa40': '国家/地区必填',
    'pages.account.accountcreatemodal.857756e1': '国家区号',
    'pages.account.accountcreatemodal.860c38ca': '街道 1',
    'pages.account.accountcreatemodal.8872c163': '搜索商机名称...',
    'pages.account.accountcreatemodal.8aeec920': '客户所属部门',
    'pages.account.accountcreatemodal.923ebef1': '所有权',
    'pages.account.accountcreatemodal.92a9bb06': '联系人名必填',
    'pages.account.accountcreatemodal.947964f3': '请检查必填字段',
    'pages.account.accountcreatemodal.9551c4db': '待上传 — 创建客户时自动提交',
    'pages.account.accountcreatemodal.9c8363c7': '国家/地区',
    'pages.account.accountcreatemodal.a0760676': '客户地址信息',
    'pages.account.accountcreatemodal.a3f55288': '行业',
    'pages.account.accountcreatemodal.a6650858': '由 联系人姓 + 联系人名 自动拼接',
    'pages.account.accountcreatemodal.a98218f3': 'SAP 必填字段',
    'pages.account.accountcreatemodal.ab6b8692': '省/直辖市/自治区',
    'pages.account.accountcreatemodal.ac7a1e0d': 'ZSDIF004.ZREBL — 介绍人比例 0-100',
    'pages.account.accountcreatemodal.acda9c03': '客户简称',
    'pages.account.accountcreatemodal.ae5150c8': '公司邮箱',
    'pages.account.accountcreatemodal.af8bb269': '取消',
    'pages.account.accountcreatemodal.b0897c60': '例: B41, B42',
    'pages.account.accountcreatemodal.b0c74a83': '送货客户',
    'pages.account.accountcreatemodal.b1438c2a': '客户分类',
    'pages.account.accountcreatemodal.b2ec5d7c':
      '💡 选填 — 选择该客户参与的商机, 创建后会自动把这些商机的"客户" 设为该客户\n                (customerid). 也可以在客户详情页 商机 tab 之后再关联.',
    'pages.account.accountcreatemodal.b66620ae': '已创建联系人 {{v0}}',
    'pages.account.accountcreatemodal.b792506e': '已上传 {{v0}} 个附件',
    'pages.account.accountcreatemodal.bef84603': '主要联系人 (新建)',
    'pages.account.accountcreatemodal.primary_contact': '主要联系人',
    'pages.account.accountcreatemodal.bf5c2e00': '客户编号',
    'pages.account.accountcreatemodal.c2ad3e70': '已关联 {{v0}} 个商机',
    'pages.account.accountcreatemodal.c2ec3557': '{{v0}} 超过 10MB 上限',
    'pages.account.accountcreatemodal.c33de2cc': '未知错误',
    'pages.account.accountcreatemodal.duplicate_account': '客户已存在',
    'pages.account.accountcreatemodal.duplicate_record': '记录已存在',
    'pages.account.accountcreatemodal.c3893a9a': '客户名称',
    'pages.account.accountcreatemodal.c38e673e': '备注',
    'pages.account.accountcreatemodal.c41d34fa': '关联商机: 成功 {{v0}} / 失败 {{v1}}',
    'pages.account.accountcreatemodal.c4873189': '联系人邮箱',
    'pages.account.accountcreatemodal.c4c823e5': '税分类',
    'pages.account.accountcreatemodal.c552da02': '付款条件',
    'pages.account.accountcreatemodal.c5d2aea2': '例: CFO / 采购经理',
    'pages.account.accountcreatemodal.c5f4cca3': '客户名称必填',
    'pages.account.accountcreatemodal.c841e7ad': '关联商机',
    'pages.account.accountcreatemodal.ca1f4565': '银行账户',
    'pages.account.accountcreatemodal.cb2f69c7': '科目分配组必填',
    'pages.account.accountcreatemodal.cbcfd022': '业务信息',
    'pages.account.accountcreatemodal.ccbba4af': '国家代码',
    'pages.account.accountcreatemodal.country.iso2_label': '国家代码:',
    'pages.account.accountcreatemodal.country.continent_label': '所属洲:',
    'pages.account.accountcreatemodal.country.phonecode_hint':
      '已根据所选国家/地区自动关联, 无需单独输入',
    'pages.account.accountcreatemodal.country.phonecode_placeholder': '请先选择国家/地区',
    'pages.account.accountcreatemodal.country.phonecode_no_dict': '已自动关联 (字典无匹配记录)',
    'pages.account.accountcreatemodal.freqband_required': '频段必选 (可多选)',
    'pages.account.accountcreatemodal.freqband_placeholder': '请选择频段 (可多选)',
    'pages.account.accountcreatemodal.freqband_tooltip': '从产品频段字典选择, 多频段客户可勾选多项',
    // D365 Summary 对齐 — 新增/调整必填字段提示与标签
    'pages.account.accountcreatemodal.language_required': '语言代码必填',
    'pages.account.accountcreatemodal.currency_required': '货币必填',
    'pages.account.accountcreatemodal.stateprovince_required': '省/州必填',
    'pages.account.accountcreatemodal.main_phone_label': '主要电话',
    'pages.account.accountcreatemodal.main_phone_required': '主要电话必填',
    'pages.account.accountcreatemodal.taxcode_label': '税号',
    'pages.account.accountcreatemodal.taxcode_tooltip': '选填: 税务登记号/统一社会信用代码等',
    'pages.account.accountcreatemodal.industry_required': '行业必选',
    'pages.account.accountcreatemodal.country_placeholder': '请选择国家/地区',
    'pages.account.accountcreatemodal.country.address_autosync_hint':
      '已根据基本信息的国家/地区自动同步, 无需重复填写',
    'pages.account.accountcreatemodal.d59aec34':
      '💡 创建客户时同步新建一个联系人, 自动绑定为主要联系人 + 所属客户. 该联系人会出现在\n                联系人 模块.',
    'pages.account.accountcreatemodal.d5c0b3f2': '商机',
    'pages.account.accountcreatemodal.d6dffc81': '邮政编码',
    'pages.account.accountcreatemodal.d75a9fe7':
      '💡 文件先暂存在前端, 创建客户成功后会自动批量上传 (营业执照 / 合同 / 资料 等).\n                单文件 ≤ 10MB.',
    'pages.account.accountcreatemodal.d84c9441': '信用额度',
    'pages.account.accountcreatemodal.deab07f9': '新建客户',
    'pages.account.accountcreatemodal.e109fa01': '联系人姓必填',
    'pages.account.accountcreatemodal.e9c1f273':
      '附件上传失败 ({{v0}} 个), 可在客户详情页"附件"tab 重新上传',
    'pages.account.accountcreatemodal.efe9dc1d': '例: 50',
    'pages.account.accountcreatemodal.f637e2d3': '例: Bai Wei',
    'pages.account.accountcreatemodal.fd3c98c7': '销售模式',
    'pages.account.accountdetailpage.01459302': 'SAP 同步失败',
    'pages.account.accountdetailpage.04724602': '详情',
    'pages.account.accountdetailpage.08824d4e': '修改时间',
    'pages.account.accountdetailpage.0b0d2aac': '主要联系人电话',
    'pages.account.accountdetailpage.0ebd10e6': '已赢单',
    'pages.account.accountdetailpage.10c29a20': '进行中',
    'pages.account.accountdetailpage.12b68dc8': '已取消提交',
    'pages.account.accountdetailpage.1c772ba2': '未知',
    'pages.account.accountdetailpage.2704cbd9': '未提交',
    'pages.account.accountdetailpage.4e866b85': '可能性',
    'pages.account.accountdetailpage.5a1a0148': '取消提交失败',
    'pages.account.accountdetailpage.62f818ec': '商机',
    'pages.account.accountdetailpage.7faeac7a': '已输单',
    'pages.account.accountdetailpage.7ff3c5f2':
      '客户审核中，提交期间字段锁定（取消提交后可继续编辑）',
    'pages.account.accountdetailpage.80253b36': 'SAP 客户字段',
    'pages.account.accountdetailpage.sap_required_customer_fields': 'SAP 必填客户字段',
    'pages.account.accountdetailpage.country_derived': '已自动联动国家区号和语言代码',
    'pages.account.accountdetailpage.delete_btn': '删除',
    'pages.account.accountdetailpage.delete_confirm_title': '确认删除',
    'pages.account.accountdetailpage.delete_confirm_desc': '删除后不可恢复，确定要删除该客户吗？',
    'pages.account.accountdetailpage.delete_confirm_ok': '确定删除',
    'pages.account.accountdetailpage.delete_confirm_cancel': '取消',
    'pages.account.accountdetailpage.delete_success': '客户已删除',
    'pages.account.accountdetailpage.delete_failed': '删除失败',
    'pages.account.accountdetailpage.8595449b': '(未命名)',
    'pages.account.accountdetailpage.88217e52': '无',
    'pages.account.accountdetailpage.90745255': '商机名称',
    'pages.account.accountdetailpage.94edc43a': '编号',
    'pages.account.accountdetailpage.999df343': '预估金额',
    'pages.account.accountdetailpage.a21900cb': '已入队 SAP 同步 (job={{v0}})',
    'pages.account.accountdetailpage.b86627df': '已批准',
    'pages.account.accountdetailpage.bbff8d52': '创建商机',
    'pages.account.accountdetailpage.bf01382e': '提交失败',
    'pages.account.accountdetailpage.c21288c4': '已提交',
    'pages.account.accountdetailpage.c501a462': '联系人',
    'pages.account.accountdetailpage.c6b59259': '审核中',
    'pages.account.accountdetailpage.caab5a09': '该客户暂无商机',
    'pages.account.accountdetailpage.e9069ebc': 'SAP语言代码',
    'pages.account.accountdetailpage.ea7dfa47': '负责人:',
    'pages.account.accountdetailpage.f35d5a7c': '状态',
    'pages.account.accountlistpage.17b0a102': '北京酷能科技有限公司',
    'pages.account.accountlistpage.b3b56e47': '深圳佰才邦技术有限公司',
    'pages.account.accountlistpage.cb128e3a': '北京佰才邦技术集团股份有限公司',
    'pages.account.accountlistpage.d8399a86': '南京佰联信息技术有限公司',
    'pages.account.accountlistpage.dacd50db': '江西佰才智慧科技有限公司',
    'pages.account.accountlistpage.e02f33ca': '江苏邦电通信科技有限公司',
    'pages.account.accountlistpage.fdfcb8b3': '江西佰才邦技术有限公司',
    'pages.admin.adminuserspage.01112768': '操作',
    'pages.admin.adminuserspage.06b6ea06': '用户',
    'pages.admin.adminuserspage.0ea0db04': '共',
    'pages.admin.adminuserspage.12a61341': '禁用',
    'pages.admin.adminuserspage.184aa36f': '角色管理 — {{v0}}',
    'pages.admin.adminuserspage.19687226': '刷新',
    'pages.admin.adminuserspage.1f9ac7d0': '共 {{v0}} 用户',
    'pages.admin.adminuserspage.2230b375': '批量分配角色 (',
    'pages.admin.adminuserspage.246e580d': '(未命名)',
    'pages.admin.adminuserspage.24f969ee': '撤销失败',
    'pages.admin.adminuserspage.255237ca': '无角色',
    'pages.admin.adminuserspage.2e477ecb': '搜索 姓名 / 域名 / 邮箱',
    'pages.admin.adminuserspage.3ab20da5': '已{{v0}}',
    'pages.admin.adminuserspage.3fd3da56': '搜索角色',
    'pages.admin.adminuserspage.5e543ce4': '启用',
    'pages.admin.adminuserspage.7aef16ae': '状态',
    'pages.admin.adminuserspage.8916ca8a': '分配失败',
    'pages.admin.adminuserspage.8c99ec9f': '{{v0}} 将被{{v1}}',
    'pages.admin.adminuserspage.90a80c76': '禁用，无法登录',
    'pages.admin.adminuserspage.9e0f6563': '已撤销',
    'pages.admin.adminuserspage.a85b3556': '角色',
    'pages.admin.adminuserspage.bc86ba7c': '分配',
    'pages.admin.adminuserspage.cc6bb5c7': '操作失败',
    'pages.admin.adminuserspage.da4d04c1': '启用，可以登录',
    'pages.admin.adminuserspage.dbf9e4de': '该用户暂无角色',
    'pages.admin.adminuserspage.e7af6578': '已分配',
    'pages.admin.adminuserspage.f6651e17': '新建用户',
    'pages.admin.adminuserspage.delete.btn': '删除',
    'pages.admin.adminuserspage.delete.title': '确认删除用户 "{{v0}}"?',
    'pages.admin.adminuserspage.delete.body': '此操作将硬删除用户、角色绑定与登录凭据, 不可恢复.',
    'pages.admin.adminuserspage.delete.warn':
      '若用户有关联业务数据 (客户/Lead/商机/...), 会被拒绝并提示先转移数据. 建议优先使用"禁用".',
    'pages.admin.adminuserspage.delete.ok': '确认删除',
    'pages.admin.adminuserspage.delete.success': '已删除用户',
    'pages.admin.adminuserspage.delete.fail': '删除失败',
    'pages.admin.adminuserspage.reset': '重置',
    'pages.admin.adminuserspage.resetPasswordDescription':
      '重置后用户的失败登录计数和锁定状态都会清空; 该用户应立即用新密码登录并自行修改.',
    'pages.admin.adminuserspage.resetPasswordFailed': '重置失败',
    'pages.admin.adminuserspage.resetPasswordPlaceholder': '留空使用默认 Crest@2026',
    'pages.admin.adminuserspage.resetPasswordSuccess': '已重置 {{v0}} 的密码为: {{v1}}',
    'pages.admin.adminuserspage.resetPasswordTitle': '重置密码 — {{v0}}',
    'pages.admin.agentconfigpage.37b01c16': '其他',
    'pages.admin.agentconfigpage.8f266297': '运营中心',
    'pages.admin.agentconfigpage.f07ef5d0': '系统设置',
    'pages.admin.agentconfigpage.ffa74ffc': '销售中心',
    'pages.admin.appcenterpage.0a1b4864': 'Phase 4 (9-12 月)',
    'pages.admin.appcenterpage.0da6eb4c': 'Phase 5 (12+ 月)',
    'pages.admin.appcenterpage.1c44ff4e': '数据',
    'pages.admin.appcenterpage.277db141': '规划中',
    'pages.admin.appcenterpage.4c4c3d19': '已上线',
    'pages.admin.appcenterpage.567ff3c1': '内部',
    'pages.admin.appcenterpage.5a761676': '办公',
    'pages.admin.appcenterpage.5a82ca6b': '治理',
    'pages.admin.appcenterpage.6af9d645': '移动',
    'pages.admin.appcenterpage.70c5be29': '核心',
    'pages.admin.appcenterpage.865ddfe8': 'Phase 3 (6-9 月)',
    'pages.admin.appcenterpage.9b3cfe76': '生产力',
    'pages.admin.appcenterpage.a0409176': '内测',
    'pages.admin.appcenterpage.b4747a9c': '协作',
    'pages.admin.appcenterpage.cb64714b': '运营',
    'pages.admin.appcenterpage.e26f3471': 'Phase 2 (3-6 月)',
    'pages.admin.appcenterpage.ff778dc6': '集成',
    'pages.admin.auditlogpage.19528a7f': '按事件（最近 7 天）',
    'pages.admin.auditlogpage.3df01b3f': '事件类型 (如 crm.account.updated)',
    'pages.admin.auditlogpage.3f69daf0': '实体',
    'pages.admin.auditlogpage.41fa603b': '共 {{v0}} 条',
    'pages.admin.auditlogpage.4f9249cb': '实体 ID (UUID)',
    'pages.admin.auditlogpage.60c79690': '改动字段',
    'pages.admin.auditlogpage.61e64833': '按实体（最近 7 天）',
    'pages.admin.auditlogpage.7b61a3fd': '结果',
    'pages.admin.auditlogpage.85a232f3': '无数据',
    'pages.admin.auditlogpage.9221d699': '刷新',
    'pages.admin.auditlogpage.9438cf9a': '时间',
    'pages.admin.auditlogpage.bcc23db9': '事件',
    'pages.admin.auditlogpage.c2706623': '操作人',
    'pages.admin.auditlogpage.system_actor': '系统',
    'pages.admin.auditlogpage.e082e176': '操作',
    'pages.admin.auditlogpage.f2a9b278': '全局审计日志',
    'pages.admin.auditlogpage.f7de5d40': '条',
    'pages.admin.auditlogpage.actor': '搜索操作人',
    'pages.admin.auditlogpage.after': '操作后证据',
    'pages.admin.auditlogpage.before': '操作前证据',
    'pages.admin.auditlogpage.detail': '查看',
    'pages.admin.auditlogpage.detail_failed': '无法加载审计详情',
    'pages.admin.auditlogpage.detail_failed_help':
      '请关闭详情后重试；若持续失败，请按请求 ID 联系管理员。',
    'pages.admin.auditlogpage.detail_title': '审计证据详情',
    'pages.admin.auditlogpage.entity': '搜索实体',
    'pages.admin.auditlogpage.export': '导出当前结果',
    'pages.admin.auditlogpage.export_failed': '导出失败，请检查筛选条件或稍后重试。',
    'pages.admin.auditlogpage.load_failed': '无法加载审计日志',
    'pages.admin.auditlogpage.load_failed_help':
      '审计服务暂时不可用，请重试；业务管理员可检查 API 和数据库状态。',
    'pages.admin.auditlogpage.request': '请求',
    'pages.admin.auditlogpage.request_id': '请求 ID',
    'pages.admin.auditlogpage.correlation_id': '关联 ID',
    'pages.admin.auditlogpage.retry': '重新加载',
    'pages.admin.auditlogpage.source': '来源',
    'pages.admin.auditlogpage.target': '操作对象',
    'pages.admin.bulkassignrolesmodal.03658706': '批量角色分配',
    'pages.admin.bulkassignrolesmodal.0973e5a1': 'replace 模式下可空 (= 清空所有角色)',
    'pages.admin.bulkassignrolesmodal.0b01769f': '请至少选 1 个角色',
    'pages.admin.bulkassignrolesmodal.0dd11ea2': '把所选角色加给所选用户 (已有则跳过)',
    'pages.admin.bulkassignrolesmodal.18cee0d0': '请选择模式',
    'pages.admin.bulkassignrolesmodal.30bc4611': '影响范围:',
    'pages.admin.bulkassignrolesmodal.396c4e8e': '请先在用户列表中勾选用户',
    'pages.admin.bulkassignrolesmodal.3985ead8': '关联',
    'pages.admin.bulkassignrolesmodal.429f2829': '目标用户',
    'pages.admin.bulkassignrolesmodal.43e5e8b5': '选择 1 或多个角色',
    'pages.admin.bulkassignrolesmodal.53864891': '个',
    'pages.admin.bulkassignrolesmodal.559be071': '批量操作失败: {{v0}}',
    'pages.admin.bulkassignrolesmodal.5607a12c': '执行',
    'pages.admin.bulkassignrolesmodal.5f223241': '操作',
    'pages.admin.bulkassignrolesmodal.63f5a997':
      '⚠️ 用所选角色替换所选用户的全部角色 (旧角色全部清除)',
    'pages.admin.bulkassignrolesmodal.64a36cdb': '加载角色列表失败',
    'pages.admin.bulkassignrolesmodal.66b1390e': '从所选用户移除所选角色',
    'pages.admin.bulkassignrolesmodal.6c510d70': '已选 {{v0}} 个用户',
    'pages.admin.bulkassignrolesmodal.8e2d53b3': '批量{{v0}}完成 — 影响 {{v1}} 条，跳过 {{v2}} 条',
    'pages.admin.bulkassignrolesmodal.97e3fd32':
      '⚠️ 此模式会先清空所选用户的全部角色，再分配新角色 — 不可逆，请确认',
    'pages.admin.bulkassignrolesmodal.999246c3': '次',
    'pages.admin.bulkassignrolesmodal.9c57daed': '… 还有',
    'pages.admin.bulkassignrolesmodal.9ef082a0': '未知错误',
    'pages.admin.bulkassignrolesmodal.a412165c': '用户 ×',
    'pages.admin.bulkassignrolesmodal.ceef8c45': '角色 =',
    'pages.admin.bulkassignrolesmodal.d5362acd': '取消',
    'pages.admin.bulkassignrolesmodal.fdd82f9a': '撤销',
    'pages.admin.butreepage.0358fd8b': '保存',
    'pages.admin.butreepage.0b8cdb69': '(可选) 例: 海外大区',
    'pages.admin.butreepage.0e87cb03': ' · 选中: ',
    'pages.admin.butreepage.27ccad61': '删除失败：{{v0}}',
    'pages.admin.butreepage.2e46e1d7': '编辑企业组织',
    'pages.admin.butreepage.30ff1bc3': '删除此组织？',
    'pages.admin.butreepage.37a55e33': '上级组织: {{v0}}',
    'pages.admin.butreepage.498dc9fe': '取消',
    'pages.admin.butreepage.4ca71995': '按部门名 / 事业部搜索',
    'pages.admin.butreepage.57de3c65': '此操作不可撤销',
    'pages.admin.butreepage.57e40395': '新建企业组织',
    'pages.admin.butreepage.5d44cb3f': '不可删除 — 有 {{v0}} 用户 + {{v1}} 个子组织',
    'pages.admin.butreepage.62383842': '例: 海外销售部',
    'pages.admin.butreepage.63747a2a': '用户',
    'pages.admin.butreepage.642ff02a': '已选:',
    'pages.admin.butreepage.6728fc7e': '已保存',
    'pages.admin.butreepage.693aaa67': '已禁用',
    'pages.admin.butreepage.6f5aaaf9': '添加子组织',
    'pages.admin.butreepage.782038e5': '请填部门名',
    'pages.admin.butreepage.83ff334a': '暂无企业组织数据',
    'pages.admin.butreepage.85f815ae': '含子部门',
    'pages.admin.butreepage.88ea321c': '删除',
    'pages.admin.butreepage.9898034d': '(可选) 部门邮箱',
    'pages.admin.butreepage.9e98e306': '(可选) 财务系统对接',
    'pages.admin.butreepage.a23f572c': '编辑',
    'pages.admin.butreepage.a28c2e74': '未知错误',
    'pages.admin.butreepage.aae952bb': '已创建企业组织',
    'pages.admin.butreepage.c65bc733': '取消选中',
    'pages.admin.butreepage.cc2215e9': '创建',
    'pages.admin.butreepage.d2376308': '已删除',
    'pages.admin.butreepage.d2e8ff50': '修改组织详情',
    'pages.admin.butreepage.dd64fab5': '全部收起',
    'pages.admin.butreepage.e57094c9': '保存失败：{{v0}}',
    'pages.admin.butreepage.e774bae3': '个部门 ·',
    'pages.admin.butreepage.ebc76f6b': '刷新',
    'pages.admin.butreepage.f204a62b': '全部展开',
    'pages.admin.butreepage.f82dfdfb': '新建根组织',
    'pages.admin.butreepage.fc045536': '将创建为根级组织',
    'pages.admin.butreepage.purge_disabled': '清理已禁用组织',
    'pages.admin.butreepage.purge_disabled_confirm_desc':
      '会删除已禁用且没有启用子组织或启用用户引用的组织，并清理禁用用户的旧归属；此操作不可撤销。',
    'pages.admin.butreepage.purge_disabled_confirm_ok': '确认清理',
    'pages.admin.butreepage.purge_disabled_confirm_title': '清理所有可安全删除的已禁用组织？',
    'pages.admin.butreepage.purge_disabled_failed': '清理失败：{{v0}}',
    'pages.admin.butreepage.purge_disabled_none': '没有可删除的已禁用组织',
    'pages.admin.butreepage.purge_disabled_partial':
      '已删除 {{v0}} 个已禁用组织，{{v1}} 个仍被业务数据引用已跳过',
    'pages.admin.butreepage.purge_disabled_skipped':
      '{{v0}} 个已禁用组织仍被业务数据引用，已跳过未删除',
    'pages.admin.butreepage.purge_disabled_success': '已删除 {{v0}} 个已禁用组织',
    'pages.admin.createrolemodal.205229d8': '⚠️ 慎用 — 绕过行级过滤，看所有客户/商机数据',
    'pages.admin.createrolemodal.2408649d': '查看全部数据',
    'pages.admin.createrolemodal.27646332': '该角色的职责说明',
    'pages.admin.createrolemodal.2be34631': '请选择类型',
    'pages.admin.createrolemodal.4b6a039f': '通用权限策略',
    'pages.admin.createrolemodal.5c7d2e34': '已创建角色 {{v0}}',
    'pages.admin.createrolemodal.6d90294d': '新菜单默认可见',
    'pages.admin.createrolemodal.6df541db': '取消',
    'pages.admin.createrolemodal.7275e549': '请填角色名',
    'pages.admin.createrolemodal.75b719b2': '未知错误',
    'pages.admin.createrolemodal.7c94d3ed':
      '系统标识符，建议英文/拼音 (例: SalesManager, OverseasReviewer)',
    'pages.admin.createrolemodal.7cfa7655': '例: SalesManager',
    'pages.admin.createrolemodal.aa7700a6': 'UI 中展示的中文名 (留空则用 name)',
    'pages.admin.createrolemodal.becbf2a8': '不超过 100 字符',
    'pages.admin.createrolemodal.bf56ba39': '创建后请到角色详情配置菜单权限和 App 访问',
    'pages.admin.createrolemodal.c7e088de': '创建',
    'pages.admin.createrolemodal.cb382e1c': '创建失败: {{v0}}',
    'pages.admin.createrolemodal.d491493d': '例: 销售经理',
    'pages.admin.createrolemodal.ee6e430f':
      '关闭后新增菜单需手动勾选才对该角色显示 (denylist 模式)',
    'pages.admin.createrolemodal.fdf94d37': '新建角色',
    'pages.admin.createusermodal.003cac72': '建议: Crest@2026 (默认演示密码)',
    'pages.admin.createusermodal.02203f53': '创建',
    'pages.admin.createusermodal.0977723f': '创建失败: {{v0}}',
    'pages.admin.createusermodal.0d9a67f3': '例: 张三',
    'pages.admin.createusermodal.1029a3bf': '(可选) 通讯邮箱',
    'pages.admin.createusermodal.21febb7a': '未知错误',
    'pages.admin.createusermodal.2385b10d': '带',
    'pages.admin.createusermodal.312aa610': '取消',
    'pages.admin.createusermodal.34778a61': '请填姓名',
    'pages.admin.createusermodal.55bb6f98':
      '留空则用户暂无密码，需通过其他方式重置；建议提供并要求用户首次登录修改',
    'pages.admin.createusermodal.74fe3875': '字典加载失败 (BU 或角色)',
    'pages.admin.createusermodal.8b8211a3': '例: zhangsan@baicells.com',
    'pages.admin.createusermodal.9155ed1f': '新建用户',
    'pages.admin.createusermodal.923cbde8': '(可选) 至少 8 位',
    'pages.admin.createusermodal.960ff639': '(可选) 选择 1 个或多个角色',
    'pages.admin.createusermodal.af259b5f': '先选最小可用角色集；后续可通过角色管理页面调整',
    'pages.admin.createusermodal.b5d272ae': '(可选) 选择部门',
    'pages.admin.createusermodal.cc45e1bd': '已创建用户 {{v0}}',
    'pages.admin.createusermodal.e0789d1e': '请填登录账号',
    'pages.admin.createusermodal.e48adac7': '为必填项 ·\n          可选填初始密码与角色',
    'pages.admin.createusermodal.e4f8ac79':
      '用户登录用账号 — 通常为 email 形式 (zhangsan@baicells.com)',
    'pages.admin.notifyhistorypage.06d9d163': '客户审核提交',
    'pages.admin.notifyhistorypage.08b75843':
      '模拟触发指定业务功能的通知。会按 iws_mailconfig 配置的收件人发送一封测试邮件， 若额外指定\n          Recipient 则附加发送。',
    'pages.admin.notifyhistorypage.0ca96d3d': '商机过百万审批通过',
    'pages.admin.notifyhistorypage.21fc280a': '刷新',
    'pages.admin.notifyhistorypage.3158a551': '条',
    'pages.admin.notifyhistorypage.47cf6374': '收件人',
    'pages.admin.notifyhistorypage.4adf2228': '额外收件人 (可选)：',
    'pages.admin.notifyhistorypage.512ab8b8': '海外潜在客户创建',
    'pages.admin.notifyhistorypage.569c721d': '失败',
    'pages.admin.notifyhistorypage.5f429edf': '中信保审批通过',
    'pages.admin.notifyhistorypage.88da907b': '无配置',
    'pages.admin.notifyhistorypage.8a133be4': '全部',
    'pages.admin.notifyhistorypage.90c09034': '按业务功能：',
    'pages.admin.notifyhistorypage.9aeab22f':
      '按业务功能 + iws_mailconfig 配置的收件人发送的所有通知历史（M19 持久化到 PG）。\n          可以按业务功能过滤；超出 200 条的查询自动走 DB。',
    'pages.admin.notifyhistorypage.smtp_disabled_title': '未检测到可用 SMTP — 通知仅记录日志',
    'pages.admin.notifyhistorypage.smtp_disabled_desc':
      '当前未找到启用且验证成功的邮箱配置。下方历史记录的通知不会真实发出邮件, 仅落 PG；请在邮箱配置中保存并测试通过一个 SMTP 账号后启用真实发送。',
    'pages.admin.notifyhistorypage.smtp_unhealthy_title': 'SMTP 已启用但健康检查未通过',
    'pages.admin.notifyhistorypage.smtp_unhealthy_desc':
      'SMTP 连接失败或认证错误, 后续邮件大概率不会送达. 请检查 SMTP 配置 + 服务器网络.',
    'pages.admin.notifyhistorypage.smtp_ok_title': 'SMTP 已启用且健康 — 通知会真实发送邮件',
    'pages.admin.notifyhistorypage.a6b97298': '取消',
    'pages.admin.notifyhistorypage.ad9c0394': '潜在客户创建',
    'pages.admin.notifyhistorypage.bce9502b': '共 {{v0}} 条',
    'pages.admin.notifyhistorypage.c34c6ae4': '业务功能',
    'pages.admin.notifyhistorypage.c9da7c7c': '测试发送失败',
    'pages.admin.notifyhistorypage.d43f2815': '成功',
    'pages.admin.notifyhistorypage.f00b33af': '主题',
    'pages.admin.notifyhistorypage.f8304a0f': '业务功能：',
    'pages.admin.notifyhistorypage.f8a13e81': '客户审核通过',
    'pages.admin.notifyhistorypage.fcc756e6': '商机赢单',
    'pages.admin.roledetaildrawer.015b4e1a': '新菜单默认可见',
    'pages.admin.roledetaildrawer.03b44829': '已保存 — 新增 {{v0}}，移除 {{v1}}，共 {{v2}} 个 App',
    'pages.admin.roledetaildrawer.0a5f8e01': '保存失败：{{v0}}',
    'pages.admin.roledetaildrawer.24676144': '加载中…',
    'pages.admin.roledetaildrawer.3f0f6ece': '暂无 sitemap 节点',
    'pages.admin.roledetaildrawer.3f6426b6': '系统标识符 — 通常无需修改',
    'pages.admin.roledetaildrawer.44670a40': '角色类型',
    'pages.admin.roledetaildrawer.5223e794': '未知错误',
    'pages.admin.roledetaildrawer.5a9914a5': '位（仅显示前 100）',
    'pages.admin.roledetaildrawer.634fb4d7':
      '开启后该角色绕过 4 档深度过滤，可看所有客户/商机数据；不影响新建/编辑权限',
    'pages.admin.roledetaildrawer.7c1a4c3c':
      '勾选父节点会自动勾选所有子节点；这里的设置会立即生效到所有该角色的用户',
    'pages.admin.roledetaildrawer.7c798529': '该角色无成员',
    'pages.admin.roledetaildrawer.7e86b2f1':
      '已保存 — 新增 {{v0}} 项，移除 {{v1}} 项，共 {{v2}} 项可见',
    'pages.admin.roledetaildrawer.86a879fb': '通用',
    'pages.admin.roledetaildrawer.89e51c36': '勾选该角色可见的菜单项',
    'pages.admin.roledetaildrawer.8b062df8':
      "App 是顶层导航容器；进入 App 后菜单还需 'menu permission' 单独勾选",
    'pages.admin.roledetaildrawer.8c00d4e1': '角色名',
    'pages.admin.roledetaildrawer.8d9f844d': '🔒 内置',
    'pages.admin.roledetaildrawer.8eb2e7af': '通用权限策略',
    'pages.admin.roledetaildrawer.9f71a7e5': '关闭后新增菜单需手动勾选才对该角色显示',
    'pages.admin.roledetaildrawer.a436e5ce': '描述',
    'pages.admin.roledetaildrawer.a43c7b9b': '勾选该角色可访问的 App',
    'pages.admin.roledetaildrawer.ae15ecb9': '菜单权限',
    'pages.admin.roledetaildrawer.b59b85ec': '查看全部数据 (绕过行级过滤)',
    'pages.admin.roledetaildrawer.ccdeb106': '成员 (',
    'pages.admin.roledetaildrawer.cf4015a0': '留空则使用角色名',
    'pages.admin.roledetaildrawer.d98101bb': '慎用',
    'pages.admin.roledetaildrawer.dca3e62f': '… 还有',
    'pages.admin.roledetaildrawer.e2c12cee': '内置角色 — 系统初始化创建，可改描述但不可删除/重命名',
    'pages.admin.roledetaildrawer.ea54592a': '个成员',
    'pages.admin.roledetaildrawer.f4dfefe7': '已保存',
    'pages.admin.roledetaildrawer.fa85b8aa': '该角色的职责说明 (业务方可见)',
    'pages.admin.roledetaildrawer.fc0f31d5': '加载角色详情失败',
    'pages.admin.roledetaildrawer.member_add': '添加成员',
    'pages.admin.roledetaildrawer.member_added': '成员已添加',
    'pages.admin.roledetaildrawer.member_cancel': '取消',
    'pages.admin.roledetaildrawer.member_remove': '移除',
    'pages.admin.roledetaildrawer.member_remove_confirm': '确认从该角色移除此成员？',
    'pages.admin.roledetaildrawer.member_removed': '成员已移除',
    'pages.admin.roledetaildrawer.member_save_failed': '成员更新失败：{{v0}}',
    'pages.admin.roledetaildrawer.member_select_placeholder': '选择要加入该角色的用户',
    'pages.admin.roledetaildrawer.menu_count_apps': '涉及 App',
    'pages.admin.roledetaildrawer.menu_count_missing': '未勾选菜单',
    'pages.admin.roledetaildrawer.menu_count_missing_short': '未选 {{v0}}',
    'pages.admin.roledetaildrawer.menu_count_selected': '已勾选菜单',
    'pages.admin.roledetaildrawer.menu_count_selected_short': '已选 {{v0}}',
    'pages.admin.roledetaildrawer.menu_count_title': '菜单权限数量',
    'pages.admin.roledetaildrawer.menu_count_total': '全部菜单',
    'pages.admin.roledetaildrawer.menu_count_total_short': '共 {{v0}}',
    'pages.admin.settingshubpage.105502cb': '中信保审批人员',
    'pages.admin.settingshubpage.12cdd3ff': '潜在客户来源',
    'pages.admin.settingshubpage.132b450f': '小类-频段映射',
    'pages.admin.settingshubpage.1d5e3b2e': '币种',
    'pages.admin.settingshubpage.2164eced': '国家代码',
    'pages.admin.settingshubpage.311c3b16': '语言代码',
    'pages.admin.settingshubpage.34acc0ad': '编号规则配置',
    'pages.admin.settingshubpage.4669cfc0': '业务部门 / BU',
    'pages.admin.settingshubpage.577506ab': '产品大类',
    'pages.admin.settingshubpage.752ca5fc': '产品组',
    'pages.admin.settingshubpage.79315b52': '共享客户',
    'pages.admin.settingshubpage.9d369ec6': '国家区号',
    'pages.admin.settingshubpage.a1e1d6cc': 'POC 审核员',
    'pages.admin.settingshubpage.a86d79bc': '频段配置',
    'pages.admin.settingshubpage.b2bb4f90': '收件人配置',
    'pages.admin.settingshubpage.ca12754f': '审批设置',
    'pages.admin.settingshubpage.d62a1fab': '产品小类',
    'pages.admin.settingshubpage.d9ab26b3': '部件类型',
    'pages.admin.settingshubpage.fc383dc0': '销售办事处',
    'pages.admin.settingspages.0156374f': '频段配置',
    'pages.admin.settingspages.0622dd1c': '海外潜在客户创建',
    'pages.admin.settingspages.0a333a99': '货币符号',
    'pages.admin.settingspages.108eed87': '组织架构 — BU 树形结构（影响行级权限范围）',
    'pages.admin.settingspages.10b59e6d': '中信保审批人员',
    'pages.admin.settingspages.194253e1': '商机赢单',
    'pages.admin.settingspages.1b89a64f': '国家名称',
    'pages.admin.settingspages.1f562b10': '编号规则配置',
    'pages.admin.settingspages.20e89d32':
      '业务功能 (1=lead_created, 2=lead_created_overseas, 3=account_submitted, 4=account_approved, 5=opportunity_won, 6=opp_over_1m_approved, 7=sinosure_approved)',
    'pages.admin.settingspages.2828de48': '带宽 (MHz)',
    'pages.admin.settingspages.2d47de0f': '产品组',
    'pages.admin.settingspages.3172a218':
      '给某用户在指定时间段授予某客户的额外查看/操作权限 (M32 销售技术支持共享逻辑同源)',
    'pages.admin.settingspages.3d5bd117': '产品小类',
    'pages.admin.settingspages.3f8c9ad8': '收件人邮箱 (多个用 ; 分隔)',
    'pages.admin.settingspages.3f9e749d': '审批人域名 (邮箱)',
    'pages.admin.settingspages.4135c27b': '潜在客户来源',
    'pages.admin.settingspages.41f8a067': '销售办事处',
    'pages.admin.settingspages.4272c594': '收件人配置',
    'pages.admin.settingspages.4380ba69': '语言字典 — 联系人/客户的「首选语言」字段使用',
    'pages.admin.settingspages.43bb00cc': '名称',
    'pages.admin.settingspages.47a45a31': '电话区号',
    'pages.admin.settingspages.4def1f40': '国家',
    'pages.admin.settingspages.4ef82317': '语言代码',
    'pages.admin.settingspages.50582ca6': '目录价',
    'pages.admin.settingspages.51357f4e': '国家代码 (ISO 2 字母)',
    'pages.admin.settingspages.51edfc00':
      '国内/海外报价的底价表（手册 §8.8）— 5-tuple 复合键：型号 / 频段 / 国家 / 等级 / 数量段。Sale Price 低于授权价时触发 BAP 红色 banner',
    'pages.admin.settingspages.55959526': '币种名称',
    'pages.admin.settingspages.5c5621a6':
      '按业务功能配置邮件通知收件人（手册 §8.5）— 例如「潜在客户创建邮件提醒」、「商机金额超 100 万元审批通过提醒」',
    'pages.admin.settingspages.602fb9a6': '签约公司代码',
    'pages.admin.settingspages.6417939c':
      '产品分类第 2 级 (隶属于 Group) — 例: Base Station / CPE / Antenna',
    'pages.admin.settingspages.682c4f04': '业务部门 (BU)',
    'pages.admin.settingspages.6aee8c1c': '小类-频段映射',
    'pages.admin.settingspages.709b7562': '兑换美金汇率',
    'pages.admin.settingspages.71820169': '中信保审批通过',
    'pages.admin.settingspages.76b08c86': '毛利率',
    'pages.admin.settingspages.7d7c8ad9': '审批设置',
    'pages.admin.settingspages.7f03e150': '国家区号配置',
    'pages.admin.settingspages.7fa2c0d8': '产品分类第 3 级 (隶属于 Class) — 含型号系列 + 物料编号',
    'pages.admin.settingspages.82ae612f': '币种配置',
    'pages.admin.settingspages.88f2163b': '型号',
    'pages.admin.settingspages.8ffb1141': '配置无线电频段的下界/上界/带宽（手册 §8.2）',
    'pages.admin.settingspages.938d062a': '毛利率 (%)',
    'pages.admin.settingspages.958918b2':
      '中信保 4-stage BPF 各节点的审批人配置 — 与通用审批设置分开维护',
    'pages.admin.settingspages.97c7718e': '国际长途区号字典（手册 §8.3）',
    'pages.admin.settingspages.9a0a8f57': '签约公司',
    'pages.admin.settingspages.9c0ef365':
      '产品分类 hierarchy 第 1 级 — Group → Class → Sub Class → Subclass-Band',
    'pages.admin.settingspages.9dfefea9': '客户审核通过',
    'pages.admin.settingspages.9ef60ad6': '客户审核提交',
    'pages.admin.settingspages.approver_user': '审批人员',
    'pages.admin.settingspages.approver_user_placeholder': '请选择审批人员',
    'pages.admin.settingspages.business_unit': '业务部门',
    'pages.admin.settingspages.business_unit_placeholder': '请选择业务部门（不选则作为全局配置）',
    'pages.admin.settingspages.a32a76bd': '下界 (MHz)',
    'pages.admin.settingspages.a3fef110': '产品大类',
    'pages.admin.settingspages.a86dc52c': '国内/海外销售办事处的地理位置 + 主管 + 联系方式',
    'pages.admin.settingspages.abd7122c':
      '客户编号 / 商机编号等业务对象编号生成规则的 key-value 字典',
    'pages.admin.settingspages.ae8da9b0': 'POC 申请审核员',
    'pages.admin.settingspages.b2146fb7': '潜在客户创建',
    'pages.admin.settingspages.b2929da0': '区域',
    'pages.admin.settingspages.b31898e0': 'ISO 代码',
    'pages.admin.settingspages.b5702552': '部件类型',
    'pages.admin.settingspages.b9c4116a': '币种 (ISO)',
    'pages.admin.settingspages.c6f3a224': '备注',
    'pages.admin.settingspages.cc5d3ba9':
      'Sub Class × Frequency Band 多对多映射 — 决定某型号在哪些频段可销售',
    'pages.admin.settingspages.cd921b9e':
      'USD 为基准货币，默认汇率 1.0；其他币种汇率均表示兑换美金汇率。',
    'pages.admin.settingspages.cfdd8cf6': '审批人域名',
    'pages.admin.settingspages.d425f256':
      '按业务部门 × 单据类型配置审批人员（手册 §8.6）— 完全数据驱动，禁止代码硬编码人名',
    'pages.admin.settingspages.d6400b24': '商机过百万审批通过',
    'pages.admin.settingspages.e62e1539':
      'Lead 表单中「来源」字段的可选值字典 (例: 展会、口碑、官网、合作伙伴)',
    'pages.admin.settingspages.e6b3ed0d': '成本价',
    'pages.admin.settingspages.ee73246e': '共享客户',
    'pages.admin.settingspages.f0181941': '频段',
    'pages.admin.settingspages.f10f1c27':
      '商机 POC 阶段「样机测试申请」的审核人员路由 (按角色 + 国家)',
    'pages.admin.settingspages.f32090d8': '国家代码',
    'pages.admin.settingspages.f68a0af9': 'ISO 代码 (3 字母)',
    'pages.admin.settingspages.fa81088f': '审批类型',
    'pages.admin.settingspages.fb4d5736': '配置名称',
    'pages.admin.settingspages.fc11c89f': '上界 (MHz)',
    'pages.admin.settingspages.fd2a28fd': '报价底表',
    'pages.admin.settingspages.fe7c7f48':
      'ISO 国家字典 (英文名 + 中文名 + 大洲) — 商机/客户的「国家」lookup 数据来源',
    'pages.admin.settingspages.fffc01f7': '物料部件类型字典 (例: 整机 / 配件 / 软件 / 服务)',
    'pages.contact.contactcreatemodal.0e20c83c': '城市',
    'pages.contact.contactcreatemodal.171b3a10': '姓',
    'pages.contact.contactcreatemodal.175b03a7': '联系人 · Contact',
    'pages.contact.contactcreatemodal.190b1bf0': '传真',
    'pages.contact.contactcreatemodal.19b17913': 'Mr. / 先生',
    'pages.contact.contactcreatemodal.1d844402':
      '💡 文件先暂存在前端, 创建联系人成功后会自动批量上传 (名片 / 资料 / 合同 等). 单文件\n                ≤ 10MB.',
    'pages.contact.contactcreatemodal.2676d51a': '日本語 (Japanese)',
    'pages.contact.contactcreatemodal.27064dc7': '已创建联系人 {{v0}}',
    'pages.contact.contactcreatemodal.2e9d20c4': '关联商机',
    'pages.contact.contactcreatemodal.2fa2527a': 'Dr. / 博士',
    'pages.contact.contactcreatemodal.3593cfbc': '{{v0}} 超过 10MB 上限',
    'pages.contact.contactcreatemodal.3796483b': '街道 1',
    'pages.contact.contactcreatemodal.39f0eb1f': 'Ms. / 女士',
    'pages.contact.contactcreatemodal.4525d882': '点击或拖拽上传',
    'pages.contact.contactcreatemodal.4710e6fe': '省/州',
    'pages.contact.contactcreatemodal.4a2acb61': '详情',
    'pages.contact.contactcreatemodal.514d1d8a': '电话',
    'pages.contact.contactcreatemodal.55e50d33': 'OA 系统同步时附带的备注信息',
    'pages.contact.contactcreatemodal.56a7e79f': '— 未保存',
    'pages.contact.contactcreatemodal.5a808713': '名必填',
    'pages.contact.contactcreatemodal.5b2b750a': '首选联络方式',
    'pages.contact.contactcreatemodal.5b433f7c': '邮箱',
    'pages.contact.contactcreatemodal.email_required': '邮箱必填',
    'pages.contact.contactcreatemodal.5c1230e6': '街道 2',
    'pages.contact.contactcreatemodal.63357f5e': '备用电话 1',
    'pages.contact.contactcreatemodal.whatsapp': 'WhatsApp',
    'pages.contact.contactcreatemodal.6d038c8b':
      '支持自定义文本 (D365 该字段是 free text), 也可从常用值快选',
    'pages.contact.contactcreatemodal.6de2389c': '称谓',
    'pages.contact.contactcreatemodal.71bd6a25': '生日',
    'pages.contact.contactcreatemodal.734cc1a1': '手机必填',
    'pages.contact.contactcreatemodal.75473371': '国家/地区',
    'pages.contact.contactcreatemodal.762f60a6': '手机',
    'pages.contact.contactcreatemodal.784b1f00': '附件',
    'pages.contact.contactcreatemodal.7f4690de': '已上传 {{v0}} 个附件',
    'pages.contact.contactcreatemodal.82a5fba0': '关联商机失败 ({{v0}} 个), 可在详情页手动关联',
    'pages.contact.contactcreatemodal.8404a896': '备用电话 2',
    'pages.contact.contactcreatemodal.8ea80f3c': '首选语言',
    'pages.contact.contactcreatemodal.8ee83fea': '基本信息',
    'pages.contact.contactcreatemodal.93509403': '所属客户',
    'pages.contact.contactcreatemodal.97d9e791': '新建联系人',
    'pages.contact.contactcreatemodal.983f6b84': '已关联 {{v0}} 个商机',
    'pages.contact.contactcreatemodal.9b3edf39': 'Prof. / 教授',
    'pages.contact.contactcreatemodal.9ccf0f41': '联系方式',
    'pages.contact.contactcreatemodal.9d2a15aa': '繁体中文 (Chinese, Traditional)',
    'pages.contact.contactcreatemodal.a632bcd6': '创建并打开',
    'pages.contact.contactcreatemodal.a81f656a': '待上传 — 创建联系人时自动提交',
    'pages.contact.contactcreatemodal.ae98773d': '部门',
    'pages.contact.contactcreatemodal.b4020d5f': 'Mrs. / 太太',
    'pages.contact.contactcreatemodal.b900a4dc': '由 姓 + 名 自动拼接，提交时使用',
    'pages.contact.contactcreatemodal.bb0d64d8': '中间名',
    'pages.contact.contactcreatemodal.bb50abe3':
      '💡 选择该联系人参与的商机, 创建后会自动把这些商机的"主联系人" 设为该联系人\n                (parentcontactid).',
    'pages.contact.contactcreatemodal.bc6ffc9b': '商机',
    'pages.contact.contactcreatemodal.bd40f910': '请检查必填字段',
    'pages.contact.contactcreatemodal.c0f153ab': '搜索商机名称...',
    'pages.contact.contactcreatemodal.c5495119': '所属客户必填',
    'pages.contact.contactcreatemodal.cb913f86': '备用邮箱 1',
    'pages.contact.contactcreatemodal.cd8d2b35': '(未命名)',
    'pages.contact.contactcreatemodal.d0240b5f': '未知错误',
    'pages.contact.contactcreatemodal.d1183207': '邮编',
    'pages.contact.contactcreatemodal.d501967a': '姓必填',
    'pages.contact.contactcreatemodal.d6cf9136': 'OA 备注',
    'pages.contact.contactcreatemodal.d98ddff5': '邮箱格式不正确',
    'pages.contact.contactcreatemodal.dcefc2a2': '概要',
    'pages.contact.contactcreatemodal.e2bafa4a': '创建失败: {{v0}}',
    'pages.contact.contactcreatemodal.e64d0385': '描述',
    'pages.contact.contactcreatemodal.eb11a205':
      '附件上传失败 ({{v0}} 个), 可在详情页"附件"tab 重新上传',
    'pages.contact.contactcreatemodal.efb1e28d': '备用邮箱 2',
    'pages.contact.contactcreatemodal.f1571e69': '简体中文 (Chinese, Simplified)',
    'pages.contact.contactcreatemodal.f4bd874f': '移除',
    'pages.contact.contactcreatemodal.f69ac344': '国家/地区',
    'pages.contact.contactcreatemodal.f8dc21a6': '关联商机: 成功 {{v0}} / 失败 {{v1}}',
    'pages.contact.contactcreatemodal.fd122da3':
      '附件: 成功 {{v0}} / 失败 {{v1}}, 失败的可在详情页重传',
    'pages.contact.contactcreatemodal.fdf16f78': '职务',
    'pages.contact.contactcreatemodal.fe5d66d7': '名',
    'pages.contact.contactcreatemodal.feccfca3': '取消',
    'pages.contact.contactdetailpage.0a1b096a': '该联系人暂无商机',
    'pages.contact.contactdetailpage.20821314': '其他联系方式',
    'pages.contact.contactdetailpage.2e702f5d': '个人资料',
    'pages.contact.contactdetailpage.327b9bc8': '手机号码',
    'pages.contact.contactdetailpage.address': '地址',
    'pages.contact.contactdetailpage.contactDetails': '联系方式',
    'pages.contact.contactdetailpage.contactInformation': '联系人信息',
    'pages.contact.contactdetailpage.3828ea66': '签约:',
    'pages.contact.contactdetailpage.55a20107': '负责人:',
    'pages.contact.contactdetailpage.5ecfc254': '联络偏好',
    'pages.contact.contactdetailpage.5f61b450': '商机',
    'pages.contact.contactdetailpage.6670144a': '营销',
    'pages.contact.contactdetailpage.74072685': '修改时间',
    'pages.contact.contactdetailpage.95e09dc8': '备注',
    'pages.contact.contactdetailpage.96b6fcab': '所属客户',
    'pages.contact.contactdetailpage.a8c030aa': '(未命名)',
    'pages.contact.contactdetailpage.a9e98947': '详情',
    'pages.contact.contactdetailpage.bb76f918': '系统信息',
    'pages.contact.contactdetailpage.d6bc9f52': '未关联客户',
    'pages.contact.contactdetailpage.e5f62e95': '编号',
    'pages.contact.contactdetailpage.ed7b9be4': '更新于',
    'pages.contact.contactdetailpage.eefc1e5b': '预估金额',
    'pages.dashboard.salesdashboardpage.015167db': '{{v0}} 天',
    'pages.dashboard.salesdashboardpage.03e04ef4': '保密协议',
    'pages.dashboard.salesdashboardpage.0549baa8': '负责人',
    'pages.dashboard.salesdashboardpage.138e8a6d': '样机申请',
    'pages.dashboard.salesdashboardpage.17b1be16': '本月输单金额：',
    'pages.dashboard.salesdashboardpage.1f9900f4': '阶段',
    'pages.dashboard.salesdashboardpage.2280c058': '商机名称',
    'pages.dashboard.salesdashboardpage.26afb3e7': '无 active 商机',
    'pages.dashboard.salesdashboardpage.44b5aaa1': '加权金额',
    'pages.dashboard.salesdashboardpage.66cc98c4': '预估金额',
    'pages.dashboard.salesdashboardpage.875476f1': '样机测试',
    'pages.dashboard.salesdashboardpage.8d482e1f': '商机关闭',
    'pages.dashboard.salesdashboardpage.9242d441': '客户',
    'pages.dashboard.salesdashboardpage.94d2d7a1': '— 每阶段历史平均/最大停留时长',
    'pages.dashboard.salesdashboardpage.a10e3f87': '商务谈判',
    'pages.dashboard.salesdashboardpage.a40e76cd': '项目立项',
    'pages.dashboard.salesdashboardpage.a4707969': '平均停留 (天)',
    'pages.dashboard.salesdashboardpage.aa7bf199': '个',
    'pages.dashboard.salesdashboardpage.b492891f':
      '💡 平均停留 > 60 天的阶段标红，提示需要业务关注（拖单风险）',
    'pages.dashboard.salesdashboardpage.ba6df84c': '— 建议跟进客户回访，分析输单原因',
    'pages.dashboard.salesdashboardpage.c25f1684': '可能性',
    'pages.dashboard.salesdashboardpage.c4302da5': '最大停留 (天)',
    'pages.dashboard.salesdashboardpage.cafc67d0': '需求收集',
    'pages.dashboard.salesdashboardpage.e81b6e57': '(未命名)',
    'pages.dashboard.salesdashboardpage.f955b8f6': '样本数',
    'pages.dashboard.salesdashboardpage.published_opportunities': '已发布商机',
    'pages.dashboard.salesdashboardpage.no_published_opportunities': '暂无已发布商机',
    'pages.dashboard.salesdashboardpage.published': '已发布',
    'pages.dashboard.salesdashboardpage.overdue_opportunities': '过期商机',
    'pages.dashboard.salesdashboardpage.no_overdue_opportunities': '暂无过期商机',
    'pages.dashboard.salesdashboardpage.opportunity': '商机名称',
    'pages.dashboard.salesdashboardpage.account': '客户',
    'pages.dashboard.salesdashboardpage.owner': '负责人',
    'pages.dashboard.salesdashboardpage.estimated_close_date': '预计结束日期',
    'pages.dashboard.salesdashboardpage.overdue': '已逾期',
    'pages.dashboard.salesdashboardpage.status': '状态',
    'pages.dashboard.salesdashboardpage.unnamed_opportunity': '未命名商机',
    'pages.dashboard.salesdashboardpage.total': '共 {{v0}} 条',
    'pages.analytics.dataanalysispage.accountId': '客户ID',
    'pages.analytics.dataanalysispage.accountName': '客户名称',
    'pages.analytics.dataanalysispage.accountNumber': '客户编号',
    'pages.analytics.dataanalysispage.activeFilters': '当前条件:',
    'pages.analytics.dataanalysispage.activeAmount': '进行中商机金额',
    'pages.analytics.dataanalysispage.activeOpportunities': '进行中商机',
    'pages.analytics.dataanalysispage.address': '地址',
    'pages.analytics.dataanalysispage.amount': '金额',
    'pages.analytics.dataanalysispage.clearFilters': '清空条件',
    'pages.analytics.dataanalysispage.comprehensivePlaceholder':
      '综合分析将汇总客户与商机的关键有效性指标。',
    'pages.analytics.dataanalysispage.comprehensiveEmpty': '暂无综合分析数据',
    'pages.analytics.dataanalysispage.comprehensiveSubtitle': '{{v0}}视图 · 共 {{v1}} 个负责人',
    'pages.analytics.dataanalysispage.comprehensiveTitle': '综合分析',
    'pages.analytics.dataanalysispage.completeness': '完整度',
    'pages.analytics.dataanalysispage.contacts': '联系人',
    'pages.analytics.dataanalysispage.customerTitle': '客户分析',
    'pages.analytics.dataanalysispage.domestic': '国内',
    'pages.analytics.dataanalysispage.email': '邮箱',
    'pages.analytics.dataanalysispage.empty': '暂无客户有效性数据',
    'pages.analytics.dataanalysispage.mobilePhone': '移动电话',
    'pages.analytics.dataanalysispage.missingContacts': '无联系人',
    'pages.analytics.dataanalysispage.missingAddress': '缺失地址',
    'pages.analytics.dataanalysispage.missingEmail': '缺失邮箱',
    'pages.analytics.dataanalysispage.missingMobilePhone': '缺失移动电话',
    'pages.analytics.dataanalysispage.missingTelephone1': '缺失固定电话',
    'pages.analytics.dataanalysispage.no': '无',
    'pages.analytics.dataanalysispage.opportunities': '商机',
    'pages.analytics.dataanalysispage.opportunityEmpty': '暂无商机分析数据',
    'pages.analytics.dataanalysispage.opportunityLost': '输单',
    'pages.analytics.dataanalysispage.opportunityName': '商机名称',
    'pages.analytics.dataanalysispage.opportunityNumber': '商机编号',
    'pages.analytics.dataanalysispage.opportunityOpen': '进行中',
    'pages.analytics.dataanalysispage.opportunityPlaceholder':
      '商机分析将展示商机数据完整性、阶段分布和关键缺口。',
    'pages.analytics.dataanalysispage.opportunitySearchPlaceholder': '搜索商机编号 / 名称',
    'pages.analytics.dataanalysispage.opportunityStatus': '商机状态',
    'pages.analytics.dataanalysispage.opportunitySubtitle': '{{v0}}视图 · 共 {{v1}} 个商机',
    'pages.analytics.dataanalysispage.opportunityTitle': '商机分析',
    'pages.analytics.dataanalysispage.opportunityWon': '赢单',
    'pages.analytics.dataanalysispage.overseas': '海外',
    'pages.analytics.dataanalysispage.owner': '负责人',
    'pages.analytics.dataanalysispage.ownerCount': '负责人数',
    'pages.analytics.dataanalysispage.ownerFilterPlaceholder': '按负责人过滤',
    'pages.analytics.dataanalysispage.probability': '可能性(%)',
    'pages.analytics.dataanalysispage.refresh': '刷新',
    'pages.analytics.dataanalysispage.searchPlaceholder': '搜索客户名称 / 编号',
    'pages.analytics.dataanalysispage.statusFilterPlaceholder': '按商机状态过滤',
    'pages.analytics.dataanalysispage.subtitle': '{{v0}}视图 · 共 {{v1}} 个客户',
    'pages.analytics.dataanalysispage.estimatedCloseDate': '预计关闭日期',
    'pages.analytics.dataanalysispage.telephone1': '固定电话',
    'pages.analytics.dataanalysispage.title': '数据分析',
    'pages.analytics.dataanalysispage.totalAccounts': '客户总数',
    'pages.analytics.dataanalysispage.totalRows': '共 {{v0}} 条',
    'pages.analytics.dataanalysispage.withAddress': '有地址',
    'pages.analytics.dataanalysispage.withContacts': '有联系人',
    'pages.analytics.dataanalysispage.withEmail': '有邮箱',
    'pages.analytics.dataanalysispage.withMobilePhone': '有移动电话',
    'pages.analytics.dataanalysispage.withOpportunities': '有关联商机',
    'pages.analytics.dataanalysispage.withTelephone1': '有固定电话',
    'pages.analytics.dataanalysispage.withoutFilter': '无{{v0}}',
    'pages.analytics.dataanalysispage.wonAmount': '赢单金额',
    'pages.analytics.dataanalysispage.wonOpportunities': '赢单商机',
    'pages.analytics.dataanalysispage.yes': '有',
    'pages.deeplinkpage.533d50b9': '缺少 entity 参数 — 期望 ?entity=opportunity&id=<uuid>',
    'pages.deeplinkpage.a844a562': '无效的深链参数',
    'pages.deeplinkpage.d4e322de': '请联系系统管理员检查链接来源',
    'pages.delivery.deliverydetailpage.267cac52': '地区',
    'pages.delivery.deliverydetailpage.643f9ee9': '成本',
    'pages.delivery.deliverydetailpage.70156f0f': '备注',
    'pages.delivery.deliverydetailpage.bd98b79f': '预算',
    'pages.delivery.deliverydetailpage.edb9b7b5': '成本 / 备注',
    'pages.delivery.deliverydetailpage.feb07435': '阶段:',
    'pages.entity.entitylistpage.statecode_active': '激活',
    'pages.entity.entitylistpage.statecode_inactive': '停用',
    'pages.entity.entitylistpage.statecode_closed': '已关闭',
    'pages.entity.entitylistpage.audit_not_submitted': '未提交',
    'pages.entity.entitylistpage.audit_in_review': '审核中',
    'pages.entity.entitylistpage.audit_approved': '已审核',
    'pages.entity.entitydetailpage.18813bed': '(未命名)',
    'pages.entity.entitydetailpage.21b60411': '暂无数据',
    'pages.entity.entitydetailpage.23c9d7de': '只读字段（系统维护）',
    'pages.entity.entitydetailpage.2b2e82f9': '返回',
    'pages.entity.entitydetailpage.2f339511': '必填字段不能为空：{{v0}}',
    'pages.entity.entitydetailpage.2f3f1afe': '打开活动面板',
    'pages.entity.entitydetailpage.309ecf70': '只读字段（业务规则锁定）',
    'pages.entity.entitydetailpage.59b71d53': '未修改任何字段',
    'pages.entity.entitydetailpage.81fa706c': '只读字段（业务规则锁定，由系统自动生成/同步）',
    'pages.entity.entitydetailpage.887d3072': '保存失败',
    'pages.entity.entitydetailpage.895ffb82': '该记录已锁定，所有字段不可编辑',
    'pages.entity.entitydetailpage.8a937f19': '收起活动面板',
    'pages.entity.entitydetailpage.9cb4dac9': '只读字段（联动展示，请到对应录入点修改）',
    'pages.entity.entitydetailpage.b78aaa9a': '已保存 {{v0}} 个字段',
    'pages.entity.entitydetailpage.c3db33f5': '{{v0}} 个必填字段',
    'pages.entity.entitydetailpage.c4e45c5d':
      '未配置 picker — 请到 picker.service.ts 注册该 target',
    'pages.entity.entitydetailpage.d721ff7d': '请选择',
    'pages.entity.entitydetailpage.e3a4828d': '只读字段（D365 IsValidForUpdate=false）',
    'pages.entity.entitydetailpage.f77865c9': '必填',
    'pages.entity.relatedtable.02acb50f': '共',
    'pages.entity.relatedtable.110a75f0': '暂无关联记录',
    'pages.entity.relatedtable.3c39becf': '刷新',
    'pages.entity.relatedtable.90081763': '条',
    'pages.entity.relatedtable.bf1fa984': '共 {{v0}} 条',
    'pages.inbox.inboxpage.141b5bf9': '取消',
    'pages.inbox.inboxpage.351bfb52': '未识别的实体：{{v0}}',
    'pages.inbox.inboxpage.3e106440': '无任务',
    'pages.inbox.inboxpage.416de046': '取消全选',
    'pages.inbox.inboxpage.427469aa': '查看',
    'pages.inbox.inboxpage.4af3b93b': '查看关联记录详情',
    'pages.inbox.inboxpage.5ffe754c': '已{{v0}}',
    'pages.inbox.inboxpage.6b4043ee': '(未命名任务)',
    'pages.inbox.inboxpage.71c83bd2': '拒绝',
    'pages.inbox.inboxpage.7707c516': '创建于',
    'pages.inbox.inboxpage.7bd05d43': '总数',
    'pages.inbox.inboxpage.7d675703': '此操作不可撤销，请确认',
    'pages.inbox.inboxpage.89615a11': '全选',
    'pages.inbox.inboxpage.967c40c6': '处理失败',
    'pages.inbox.inboxpage.a7a14971': '任务详情',
    'pages.inbox.inboxpage.ad0817e1': '批量处理失败',
    'pages.inbox.inboxpage.adf20619': '批准',
    'pages.inbox.inboxpage.dc80a70f': '批量{{v0}} {{v1}} 个任务？',
    'pages.inbox.inboxpage.deleted_target_cancelled': '审批对象已被删除，待办已自动取消',
    'pages.inbox.inboxpage.ed8cb1fa': '已选',
    'pages.inbox.inboxpage.f1c3fd08': '批量{{v0}} 完成：成功 {{v1}}，失败 {{v2}}',
    'pages.inbox.inboxpage.f6c58473': '刷新',
    'pages.inbox.inboxpage.notification_tab_title': '消息通知',
    'pages.inbox.inboxpage.f6cfa783': '请先勾选任务',
    'pages.inbox.inboxpage.pending_filter_account': '客户待审',
    'pages.inbox.inboxpage.pending_filter_all': '全部待审',
    'pages.inbox.inboxpage.pending_filter_opportunity': '商机待审',
    'pages.inbox.inboxpage.pending_filter_poc': 'POC申请待审',
    'pages.inbox.inboxpage.target_detail_forbidden':
      '当前没有权限查看审批对象详情，但仍可处理该审批',
    'pages.inbox.inboxpage.unavailable_target_cancelled':
      '审批对象不存在或当前无法访问，待办已自动取消',
    'pages.integration.integrationlogpage.08da3e0a': '失败',
    'pages.integration.integrationlogpage.125f8111': '时间',
    'pages.integration.integrationlogpage.1e443b0c': '系统',
    'pages.integration.integrationlogpage.226e4d3c': '该日志没有 entityId，无法手工 retry',
    'pages.integration.integrationlogpage.2f55b506': '耗时',
    'pages.integration.integrationlogpage.4c4cde56': '结果',
    'pages.integration.integrationlogpage.58c2db8a': 'retry 失败',
    'pages.integration.integrationlogpage.61eb9b87': '成功',
    'pages.integration.integrationlogpage.64e77a0e': '错误',
    'pages.integration.integrationlogpage.66d47dad': '尝试',
    'pages.integration.integrationlogpage.69a93b6d': '操作',
    'pages.integration.integrationlogpage.8880f75e': '刷新',
    'pages.integration.integrationlogpage.9146bdac': '集成日志',
    'pages.integration.integrationlogpage.a0b23b1a': '条',
    'pages.integration.integrationlogpage.b652a6a1': '实体',
    'pages.integration.integrationlogpage.bf5a39ca': '共 {{v0}} 条',
    'pages.integration.integrationlogpage.direction.title': '接口方向',
    'pages.integration.integrationlogpage.direction.outbound': '出接口',
    'pages.integration.integrationlogpage.direction.inbound': '入接口',
    'pages.integration.integrationlogpage.direction.outboundDesc':
      '出接口：CREST 主动调用外部系统接口，例如 SAP、OA、钉钉等。',
    'pages.integration.integrationlogpage.direction.inboundDesc':
      '入接口：外部系统调用 CREST 接口，或由外部系统数据拉取/同步进入 CREST。',
    'pages.integration.integrationlogpage.business.type': '业务类型',
    'pages.integration.integrationlogpage.business.object': '业务对象',
    'pages.integration.integrationlogpage.business.material': '物料查询',
    'pages.integration.integrationlogpage.business.accountSync': '客户同步',
    'pages.integration.integrationlogpage.business.approval': '审批集成',
    'pages.integration.integrationlogpage.business.orgSync': '组织同步',
    'pages.integration.integrationlogpage.business.interfaceCall': '接口调用',
    'pages.integration.integrationlogpage.business.sapMaterial': 'SAP 物料主数据',
    'pages.integration.integrationlogpage.business.dingtalkOrg': '钉钉组织架构',
    'pages.integration.integrationlogpage.d55cee17': 'SAP 队列状态',
    'pages.integration.integrationlogpage.e2f4f25d': '重试中',
    'pages.integration.integrationlogpage.ec50273c': '重试',
    'pages.integration.integrationlogpage.ef81d8d7': '已入队 (job={{v0}})',
    'pages.lead.leadcreatemodal.1bdb2e39': '客户分组',
    'pages.lead.leadcreatemodal.28e7beca':
      '项目背景 / 客户需求 — Lead Qualify 转化时会自动 carry-over 到客户.描述',
    'pages.lead.leadcreatemodal.2c37493c': '国家/地区',
    'pages.lead.leadcreatemodal.3bb200a4': '已上传 {{v0}} 个附件',
    'pages.lead.leadcreatemodal.3d66bf14': '公司',
    'pages.lead.leadcreatemodal.3ee9c6d8': '客户名称必填',
    'pages.lead.leadcreatemodal.40e56463': '省/直辖市/自治区',
    'pages.lead.leadcreatemodal.47fc8148': '市/县',
    'pages.lead.leadcreatemodal.48cc9f54': '商务电话',
    'pages.lead.leadcreatemodal.4abdab44': '联系人',
    'pages.lead.leadcreatemodal.4ea42305': '待上传 — 创建线索时自动提交',
    'pages.lead.leadcreatemodal.4fda7684': '移除',
    'pages.lead.leadcreatemodal.506f79b6': '描述',
    'pages.lead.leadcreatemodal.5073b0fc': '新建线索',
    'pages.lead.leadcreatemodal.51b90ac2': '客户名称',
    'pages.lead.leadcreatemodal.5524b99e': '— 未保存',
    'pages.lead.leadcreatemodal.56a54e2c': '移动电话',
    'pages.lead.leadcreatemodal.57ff3d46': '街道 1',
    'pages.lead.leadcreatemodal.5a593f72': '客户预算',
    'pages.lead.leadcreatemodal.5a96ddea': '邮箱格式不正确',
    'pages.lead.leadcreatemodal.62c3c818': '创建并打开',
    'pages.lead.leadcreatemodal.63f6a905': '国家区号',
    'pages.lead.leadcreatemodal.6619b484': '取消',
    'pages.lead.leadcreatemodal.66e71f6d': '{{v0}} 超过 10MB 上限',
    'pages.lead.leadcreatemodal.673c8316': '点击或拖拽上传',
    'pages.lead.leadcreatemodal.6c102440': '员工人数',
    'pages.lead.leadcreatemodal.7e59b733': '客户分类',
    'pages.lead.leadcreatemodal.807a63b8': '名必填',
    'pages.lead.leadcreatemodal.817fc5bc': '预计成交日期',
    'pages.lead.leadcreatemodal.857c1fc2': '创建失败: {{v0}}',
    'pages.lead.leadcreatemodal.88dcaa36': '国家代码',
    'pages.lead.leadcreatemodal.8904d671': '线索名称',
    'pages.lead.leadcreatemodal.8b099f9d': '销售模式必填',
    'pages.lead.leadcreatemodal.908ac344': '概要',
    'pages.lead.leadcreatemodal.913c2551': '详情',
    'pages.lead.leadcreatemodal.92b5e249': '网站',
    'pages.lead.leadcreatemodal.99ee878c': '意向产品',
    'pages.lead.leadcreatemodal.9b03d025': '职务',
    'pages.lead.leadcreatemodal.9b66b273': '项目背景',
    'pages.lead.leadcreatemodal.9cdfbf16': '请检查必填字段',
    'pages.lead.leadcreatemodal.a0b9c552': '姓',
    'pages.lead.leadcreatemodal.a7aae82c': '客户分类必填',
    'pages.lead.leadcreatemodal.a7b5033d': '附件',
    'pages.lead.leadcreatemodal.a9f4f9ed': '品牌',
    'pages.lead.leadcreatemodal.aa380778': '附件上传失败 ({{v0}} 个), 可在详情页"附件"tab 重新上传',
    'pages.lead.leadcreatemodal.ae4ae720': '国家区号必填',
    'pages.lead.leadcreatemodal.b04f3273': '线索名称必填',
    'pages.lead.leadcreatemodal.b2784509': '商机信息',
    'pages.lead.leadcreatemodal.b47e4d38': '线索 · Sales Insights',
    'pages.lead.leadcreatemodal.b4b03b03': '项目背景、客户需求、痛点等',
    'pages.lead.leadcreatemodal.b69d58a6': '附件: 成功 {{v0}} / 失败 {{v1}}, 失败的可在详情页重传',
    'pages.lead.leadcreatemodal.c3bd8404': '邮政编码',
    'pages.lead.leadcreatemodal.c45f3a76': '名',
    'pages.lead.leadcreatemodal.c473f5c8': '销售模式',
    'pages.lead.leadcreatemodal.c6f947f4': '已创建线索 {{v0}}{{v1}}',
    'pages.lead.leadcreatemodal.d1880555': '未知错误',
    'pages.lead.leadcreatemodal.d5e15f49': '姓必填',
    'pages.lead.leadcreatemodal.e4caf088': '电子邮件',
    'pages.lead.leadcreatemodal.e7ed059f': '由 姓 + 名 自动拼接，提交时使用',
    'pages.lead.leadcreatemodal.ec9aac7a': '预计收入',
    'pages.lead.leadcreatemodal.ed25fe98': '线索来源',
    'pages.lead.leadcreatemodal.f3823141':
      '💡 文件先暂存在前端, 创建线索成功后会自动批量上传 (名片 / 公司资料 / 项目背景\n                等). 单文件 ≤ 10MB.',
    'pages.lead.leadcreatemodal.f53bf832': '国家代码必填',
    'pages.lead.leaddetailpage.1c2c0745': '客户',
    'pages.lead.leaddetailpage.3128cc14': '联系方式',
    'pages.lead.leaddetailpage.339f9d6a': '意向产品',
    'pages.lead.leaddetailpage.38cdc0c4': '联系人 {{v0}}',
    'pages.lead.leaddetailpage.3b636c6e': '摘要',
    'pages.lead.leaddetailpage.3e417b97': '基于主题/预算创建商机，自动启动 BPF 流程',
    'pages.lead.leaddetailpage.3f57fea1': '基于姓名/邮箱创建联系人，自动绑定为客户的主联系人',
    'pages.lead.leaddetailpage.45162815': '地址',
    'pages.lead.leaddetailpage.46ad76a2': '商机预估',
    'pages.lead.leaddetailpage.591abb1b': '⚠️ Lead 一旦 Qualified 后所有字段将锁定（手册业务规则）',
    'pages.lead.leaddetailpage.5d22f4ba': '国家代码',
    'pages.lead.leaddetailpage.64074368': '品牌',
    'pages.lead.leaddetailpage.7b7827a4': '客户 {{v0}}',
    'pages.lead.leaddetailpage.8b7a8db9': '基于公司名称创建客户主数据',
    'pages.lead.leaddetailpage.8cd51ba6': '商机信息',
    'pages.lead.leaddetailpage.8ee80859': '转化客户',
    'pages.lead.leaddetailpage.940b52e1': '该 Lead 已 Qualified，所有字段锁定（手册业务规则）',
    'pages.lead.leaddetailpage.9ed075e2': '预估收入',
    'pages.lead.leaddetailpage.a907efcd': '取消',
    'pages.lead.leaddetailpage.ab6b6484': '转化失败',
    'pages.lead.leaddetailpage.acfb6610': '该 Lead 已 Disqualified，仅供查看',
    'pages.lead.leaddetailpage.ad6bd656': '项目背景',
    'pages.lead.leaddetailpage.b77a52d6': '基本信息',
    'pages.lead.leaddetailpage.c30cf2b0': '已转化：{{v0}}',
    'pages.lead.leaddetailpage.c783981a': '详细信息',
    'pages.lead.leaddetailpage.d0f17e2c': '转化结果',
    'pages.lead.leaddetailpage.d640385b': '转化商机',
    'pages.lead.leaddetailpage.dcfc32c6': '公司',
    'pages.lead.leaddetailpage.dda4bc4b':
      '请选择要创建的目标实体（项目背景将自动 carry-over 到客户描述）：',
    'pages.lead.leaddetailpage.df9c5eb3': '该潜在客户尚未转化',
    'pages.lead.leaddetailpage.converted_contacts_count': '转化联系人数',
    'pages.lead.leaddetailpage.converted_contacts_title': '转化出的联系人',
    'pages.lead.leaddetailpage.eb078d7d': '商机 {{v0}}',
    'pages.lead.leaddetailpage.f4c9a387': '商机',
    'pages.lead.leaddetailpage.f84e74ff': '系统信息',
    'pages.operations.operationsdashboardpage.06fde89e': 'M+3 起 (对接 MES)',
    'pages.operations.operationsdashboardpage.09fb2d23': 'M+2 (对接 iws_deliverproject)',
    'pages.operations.operationsdashboardpage.6fc51fb7': 'M+3 起 (对接 SAP IM)',
    'pages.operations.operationsdashboardpage.92d2fe23': 'M+3 起 (对接 SAP MM)',
    'pages.operations.operationsdashboardpage.95029e19': 'M+1 (复用 Sales Dashboard)',
    'pages.operations.operationsdashboardpage.bd2855ba': '建设中',
    'pages.operations.operationsdashboardpage.ea37940c': '规划中',
    'pages.operations.operationsdashboardpage.f7353913': 'M+3 起 (对接 Jira / GitLab)',
    'pages.opportunity.opportunitycreatemodal.031c743c': '客户分类必填',
    'pages.opportunity.opportunitycreatemodal.03e4387c': '请检查必填字段',
    'pages.opportunity.opportunitycreatemodal.041b03fc': '国家/地区必填',
    'pages.opportunity.opportunitycreatemodal.select_customer_first': '请先选择客户',
    'pages.opportunity.opportunitycreatemodal.account_placeholder': '请选择或搜索客户',
    'pages.opportunity.opportunitycreatemodal.contact_placeholder': '请选择或搜索联系人',
    'pages.opportunity.opportunitycreatemodal.sales_support_placeholder':
      '请选择或搜索销售技术支持人员',
    'pages.opportunity.opportunitycreatemodal.service_pm_placeholder': '请选择或搜索服务 PM',
    'pages.opportunity.opportunitycreatemodal.043c4bb2': '项目类型',
    'pages.opportunity.opportunitycreatemodal.05db6417': '主要买家',
    'pages.opportunity.opportunitycreatemodal.086f00ea': '货币必填',
    'pages.opportunity.opportunitycreatemodal.09bae6df': '预计签约时间',
    'pages.opportunity.opportunitycreatemodal.0f198fc0': '项目信息',
    'pages.opportunity.opportunitycreatemodal.11e87292': '投标 / 合伙人',
    'pages.opportunity.opportunitycreatemodal.18049d88': '创建并打开',
    'pages.opportunity.opportunitycreatemodal.18daca9b': '销售技术支持',
    'pages.opportunity.opportunitycreatemodal.1b6c7bd2': '签约公司',
    'pages.opportunity.opportunitycreatemodal.1d94adfb': '项目时间线',
    'pages.opportunity.opportunitycreatemodal.1e7f8753':
      '附件: 成功 {{v0}} / 失败 {{v1}}, 失败的可在详情页重传',
    'pages.opportunity.opportunitycreatemodal.1ff172b9': '项目优先级',
    'pages.opportunity.opportunitycreatemodal.22de5bd3': '联系方式必填',
    'pages.opportunity.opportunitycreatemodal.230a16f3': '预算金额',
    'pages.opportunity.opportunitycreatemodal.23bd03ad':
      '附件上传失败 ({{v0}} 个), 可在商机详情页"附件"tab 重新上传',
    'pages.opportunity.opportunitycreatemodal.2703a5c1': '预计签约日期必填',
    'pages.opportunity.opportunitycreatemodal.2a4256ce': '可能性(%)',
    'pages.opportunity.opportunitycreatemodal.2cbfce14': '销售模式',
    'pages.opportunity.opportunitycreatemodal.300da871': '销售预测金额',
    'pages.opportunity.opportunitycreatemodal.3149cace': '说明',
    'pages.opportunity.opportunitycreatemodal.35c4f7ac': '海外大区映射 + 商机编码生成依赖此字段',
    'pages.opportunity.opportunitycreatemodal.37af947d': '签约公司必填',
    'pages.opportunity.opportunitycreatemodal.3ad04bc0': '项目状态',
    'pages.opportunity.opportunitycreatemodal.3ad85452': '地理',
    'pages.opportunity.opportunitycreatemodal.3f63ee65': '客户',
    'pages.opportunity.opportunitycreatemodal.41363cb3': '商机 · Opportunity · Sales Hub',
    'pages.opportunity.opportunitycreatemodal.44509753': '财务信息',
    'pages.opportunity.opportunitycreatemodal.4613644d': '个文件）',
    'pages.opportunity.opportunitycreatemodal.46a8d839': '选择文档归属',
    'pages.opportunity.opportunitycreatemodal.4967857d': '应用场景必填',
    'pages.opportunity.opportunitycreatemodal.4ebdcd82': '联系方式',
    'pages.opportunity.opportunitycreatemodal.510c75e6': '默认 RMB，可在打开后切换为 USD / EUR 等',
    'pages.opportunity.opportunitycreatemodal.5c92f090': '商机名称',
    'pages.opportunity.opportunitycreatemodal.5cd06b91': '取消',
    'pages.opportunity.opportunitycreatemodal.63ec756f': '姓名 / 职务',
    'pages.opportunity.opportunitycreatemodal.6acfd33f': '项目类型必填',
    'pages.opportunity.opportunitycreatemodal.6c0f51c5': '销售模式必填',
    'pages.opportunity.opportunitycreatemodal.72ba1207': '电话 / 邮箱 / 微信',
    'pages.opportunity.opportunitycreatemodal.72ce7c46': '概要',
    'pages.opportunity.opportunitycreatemodal.74390355': '正在进行',
    'pages.opportunity.opportunitycreatemodal.77e74ae6': '创建后自动上传；可点击下拉调整归属或移除',
    'pages.opportunity.opportunitycreatemodal.78a62d03': '预计结束日期',
    'pages.opportunity.opportunitycreatemodal.7be85174': '项目优先级必填',
    'pages.opportunity.opportunitycreatemodal.7f051d2a':
      '💡 推荐用 Activity (右侧栏) 替代此字段, 支持线程 + AI 概要',
    'pages.opportunity.opportunitycreatemodal.80d90ab5': '项目背景',
    'pages.opportunity.opportunitycreatemodal.813de902': '项目所属省份',
    'pages.opportunity.opportunitycreatemodal.839ba8a7': '后续可由销售预测子网格自动汇总',
    'pages.opportunity.opportunitycreatemodal.861dcf62': '取消（放弃这',
    'pages.opportunity.opportunitycreatemodal.87acb0a8': '基本信息',
    'pages.opportunity.opportunitycreatemodal.88011993': '附件',
    'pages.opportunity.opportunitycreatemodal.8955fbeb':
      '项目状态: ...&#10;支持需求: ...&#10;风险: ...',
    'pages.opportunity.opportunitycreatemodal.8d06d914':
      '支持多文件批量；创建商机后自动上传；单文件 ≤ 10MB',
    'pages.opportunity.opportunitycreatemodal.8d69e675': '成单概率必填',
    'pages.opportunity.opportunitycreatemodal.91385c3b': '已创建商机 {{v0}}',
    'pages.opportunity.opportunitycreatemodal.92ce726e': '是否有合作伙伴参与',
    'pages.opportunity.opportunitycreatemodal.92f5a55a': '状态描述',
    'pages.opportunity.opportunitycreatemodal.93896b12': '已上传 {{v0}} 个附件',
    'pages.opportunity.opportunitycreatemodal.94a9978a': '预计收入',
    'pages.opportunity.opportunitycreatemodal.95181120': '货币',
    'pages.opportunity.opportunitycreatemodal.954bbb01': '客户预算必填',
    'pages.opportunity.opportunitycreatemodal.97afdc8e': '最终用户',
    'pages.opportunity.opportunitycreatemodal.986a345a': '创建失败: {{v0}}',
    'pages.opportunity.opportunitycreatemodal.opp.create_with_forecast_success':
      '已创建商机 {{v0}}，并保存 {{v1}} 条销售预测',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_create_failed':
      '销售预测保存失败，商机未创建，已为你暂存草稿。原因: {{v0}}',
    'pages.opportunity.opportunitycreatemodal.9aeb5110': '待上传',
    'pages.opportunity.opportunitycreatemodal.9b82c3f9': '是否涉及招标',
    'pages.opportunity.opportunitycreatemodal.9c4a3467':
      'ZPSIF009.ZXMJE — 立项推送 SAP 时用此金额, 不是预计收入',
    'pages.opportunity.probabilityTips.10.real': '已拜访客户，确认该商机真实存在',
    'pages.opportunity.probabilityTips.25.responsiblePeople':
      '已对接项目负责人，了解项目时间计划和目标规模',
    'pages.opportunity.probabilityTips.50.decisionMaker':
      '已见到决策人，理解赢单关键因素，且预算已确认',
    'pages.opportunity.probabilityTips.50.competitors':
      '已了解竞争对手信息，包括产品规格、价格、付款条件等',
    'pages.opportunity.probabilityTips.50.technicalRequirement':
      '已获得客户对技术需求的确认，且需求与 Baicells 方案匹配',
    'pages.opportunity.probabilityTips.75.trialSuccess': 'POC / 试点成功，并已获得客户确认',
    'pages.opportunity.probabilityTips.75.commercialOffering': '商务方案满足客户预期',
    'pages.opportunity.probabilityTips.90.contractReview': '合同条款和条件正在审核，基本已达成一致',
    'pages.opportunity.probabilityTips.100.contractSigned': '合同已签署，并已收到首付款（如适用）',
    'pages.opportunity.opportunitycreatemodal.a31b60d0': '客户必填',
    'pages.opportunity.opportunitycreatemodal.a4e78b48': '预算确认状态必填',
    'pages.opportunity.opportunitycreatemodal.a542a0ce': '品牌',
    'pages.opportunity.opportunitycreatemodal.a5acad4a': '— 未保存',
    'pages.opportunity.opportunitycreatemodal.a6979ccb': '项目规模',
    'pages.opportunity.opportunitycreatemodal.a85ebbb9': '当前为 国内模式 — 仅显示省份选择',
    'pages.opportunity.opportunitycreatemodal.ab0f691a':
      '当前为 海外模式 — 仅显示国家选择 (海外商机自动按 5 段规则拼接主题)',
    'pages.opportunity.opportunitycreatemodal.ab6dae2c': '联系人',
    'pages.opportunity.opportunitycreatemodal.b028d616':
      '手册 §3.2 销售周报源 — 每周更新「项目状态/支持需求/风险」三段',
    'pages.opportunity.opportunitycreatemodal.b23e5207': '客户分类',
    'pages.opportunity.opportunitycreatemodal.b3967cb9': '详情',
    'pages.opportunity.opportunitycreatemodal.b52c6181': '移除',
    'pages.opportunity.opportunitycreatemodal.b939e5d3': '项目细节',
    'pages.opportunity.opportunitycreatemodal.b9cb0314': '项目背景、客户需求、痛点等',
    'pages.opportunity.opportunitycreatemodal.bc8b9962': '主要买家必填',
    'pages.opportunity.opportunitycreatemodal.bef7038d': '预计收入必填',
    'pages.opportunity.opportunitycreatemodal.bfbe2f15': '未知错误',
    'pages.opportunity.opportunitycreatemodal.c18aeac9':
      '个文件待添加，请选择归属类别\n          （所有文件将归到同一类别，添加后可在列表里逐条调整）：',
    'pages.opportunity.opportunitycreatemodal.c3dfbd6a': '新建商机',
    'pages.opportunity.opportunitycreatemodal.c659f59d': '商机名称必填',
    'pages.opportunity.opportunitycreatemodal.c902bd03': '销售技术支持必填',
    'pages.opportunity.opportunitycreatemodal.ca23d7e6': '商机的对接联系人（来自客户下的联系人）',
    'pages.opportunity.opportunitycreatemodal.ca36c91d':
      '若从 Lead Qualify 转化, 会从 lead.description 自动 carry-over',
    'pages.opportunity.opportunitycreatemodal.cfc77d20': '国家/地区',
    'pages.opportunity.opportunitycreatemodal.d128188c': '国内商机省份必填',
    'pages.opportunity.opportunitycreatemodal.d20c9575': '应用场合',
    'pages.opportunity.opportunitycreatemodal.d32aee7f': '商机来源',
    'pages.opportunity.opportunitycreatemodal.d7d6c66b': '点击或拖拽文件到此 — 上传时选择归属',
    'pages.opportunity.opportunitycreatemodal.dbf0109a': '商机的服务项目经理（可选）',
    'pages.opportunity.opportunitycreatemodal.dfc942e4': '服务PM',
    'pages.opportunity.opportunitycreatemodal.e8c14868': '共',
    'pages.opportunity.opportunitycreatemodal.f2d7b8bd': '项目状态必填',
    'pages.opportunity.opportunitycreatemodal.fb518628': '销售信息',
    'pages.opportunity.opportunitycreatemodal.feebfbe9': '个文件',
    'pages.opportunity.opportunitycreatemodal.ff24b05a': '联系人必填',
    'pages.opportunity.opportunitycreatemodal.opp.account_tooltip':
      '选定客户后, 国家/地区 / 销售模式 / 签约公司 / 货币 / 客户分类 自动从客户继承; 客户分类仍可在下方覆盖',
    'pages.opportunity.opportunitycreatemodal.opp.marketseg_tooltip':
      '默认从所选客户继承, 也可针对当前商机单独调整',
    'pages.opportunity.opportunitycreatemodal.opp.decision_maker_label': '决策人',
    'pages.opportunity.opportunitycreatemodal.opp.decision_maker_required': '决策人必填',
    'pages.opportunity.opportunitycreatemodal.opp.decision_maker_placeholder':
      '请输入决策人姓名 / 职位 / 联系方式',
    'pages.opportunity.opportunitycreatemodal.opp.yes': '是',
    'pages.opportunity.opportunitycreatemodal.opp.no': '否',
    'pages.opportunity.opportunitycreatemodal.opp.background_required': '项目背景必填',
    'pages.opportunity.opportunitycreatemodal.opp.leadsource_required': '商机来源必填',
    'pages.opportunity.opportunitycreatemodal.opp.status_reason_label': '状态原因',
    'pages.opportunity.opportunitycreatemodal.opp.status_reason_required': '状态原因必选',
    'pages.opportunity.opportunitycreatemodal.opp.status_reason_in_progress': '进行中',
    'pages.opportunity.opportunitycreatemodal.opp.status_reason_on_hold': '搁置',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_tab': '销售预测',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_section_title': '销售预测明细',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_section_hint':
      '商机创建成功后会自动批量保存到「销售预测」子网格; 海外市场部建议至少录入 1 行',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_add_row': '新增一行预测',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_edit_row': '编辑预测',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_empty':
      '尚未录入销售预测, 点击右上角「新增一行预测」',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_class': '大类',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_subclass': '子类',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_band': '频段',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_qty': '数量',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_unit_price': '单价',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_revenue': '预计收入',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_total_price': '总价',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_total_price_placeholder':
      '根据数量和单价自动计算',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_comments': '备注',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_status': '状态',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_probability': '概率',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_order_timing': '订单时间',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_product_comments': '产品备注',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_status_placeholder': '选择状态',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_probability_placeholder': '选择概率',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_order_timing_placeholder':
      '选择订单时间',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_product_comments_placeholder':
      '输入产品备注',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_subclass_first': '请先选择子类',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_no_bands': '该子类无关联频段',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_status_ongoing': '进行中',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_status_closed_po': '已关闭 - 收到PO',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_status_closed_lost': '已关闭 - 丢单',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_status_deleted': '已删除 - 录入错误',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_class_required': '请选择大类',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_subclass_required': '请选择子类',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_qty_required': '请输入数量',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_subclass_disabled': '请先选择大类',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_class_placeholder': '请选择产品大类',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_subclass_placeholder': '请选择产品子类',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_band_placeholder': '可选',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_qty_placeholder': '请输入预计数量',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_unit_price_placeholder':
      '可选 (用于自动算预计收入)',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_comments_placeholder': '可选',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_save_btn': '保存到列表',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_count_summary': '已暂存 {{v0}} 行',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_total_amount': '预计总金额',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_batch_success':
      '销售预测已批量入库 ({{v0}} 行)',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_batch_partial':
      '销售预测部分入库成功: {{v0}} 行成功 / {{v1}} 行失败',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_batch_failed':
      '销售预测全部入库失败 ({{v0}} 行)',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_auto_saved':
      '已自动保存未提交的销售预测行',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_unsaved_error':
      '销售预测填写不完整，请先完成或清空: {{v0}}',
    'pages.opportunity.opportunitydetailpage.0327b416': '取消',
    'pages.opportunity.opportunitydetailpage.04ef7602': '国家代码',
    'pages.opportunity.opportunitydetailpage.1149cd5e': '海外',
    'pages.opportunity.opportunitydetailpage.121c5894': '团队 / 阶段 / 标志',
    'pages.opportunity.opportunitydetailpage.1676875b': '{{v0}} 天',
    'pages.opportunity.opportunitydetailpage.1de24c9a': '已开启 {{v0}}',
    'pages.opportunity.opportunitydetailpage.31b372e4': '样机{{v0}}失败',
    'pages.opportunity.opportunitydetailpage.32db6524': '{{v0}} 分钟',
    'pages.opportunity.opportunitydetailpage.3dbef334': '操作失败',
    'pages.opportunity.opportunitydetailpage.40fcbc48': '如：竞对价格更低 / 客户预算不足',
    'pages.opportunity.opportunitydetailpage.4330440d': '{{v0}} 小时',
    'pages.opportunity.opportunitydetailpage.476c5438':
      '该商机未启动 BPF（旧数据 / 直接 SQL 创建）',
    'pages.opportunity.opportunitydetailpage.47ed29df': '已立项审批通过',
    'pages.opportunity.opportunitydetailpage.52ce1ccd': '预测金额',
    'pages.opportunity.opportunitydetailpage.5d9066a1':
      '样机流程：申请 → 审核 → 完成；触发邮件 + OA 双通知',
    'pages.opportunity.opportunitydetailpage.6084f401': '负责人',
    'pages.opportunity.opportunitydetailpage.67791459': '系统信息',
    'pages.opportunity.opportunitydetailpage.67d5e10c': '业务详情',
    'pages.opportunity.opportunitydetailpage.693aee6c':
      '标记 iws_projectapproved=true，允许 BPF 推进至下一阶段',
    'pages.opportunity.opportunitydetailpage.6cad28f4': '{{v0}} 月',
    'pages.opportunity.opportunitydetailpage.6e037130': '🎉 已标记赢单',
    'pages.opportunity.opportunitydetailpage.70965927': '预计签约',
    'pages.opportunity.opportunitydetailpage.7ac9837a': '· 截止',
    'pages.opportunity.opportunitydetailpage.84a0c30b': '立项审批失败',
    'pages.opportunity.opportunitydetailpage.85c29c9a': '客户',
    'pages.opportunity.opportunitydetailpage.8e0e101e': '提交后通知 OA 审核',
    'pages.opportunity.opportunitydetailpage.8ff613bc': '样机{{v0}}完成',
    'pages.opportunity.opportunitydetailpage.9bb57e81': '基本信息',
    'pages.opportunity.opportunitydetailpage.a158491e': '可能性',
    'pages.opportunity.opportunitydetailpage.a94ee3e4': '立项审批通过',
    'pages.opportunity.opportunitydetailpage.b37feac7': '已经在该阶段，请点击未来阶段以推进',
    'pages.opportunity.opportunitydetailpage.b5f674f9': '已标记输单',
    'pages.opportunity.opportunitydetailpage.ba4511a9': '金额 / 时间',
    'pages.opportunity.opportunitydetailpage.cd38882c': '完成于',
    'pages.opportunity.opportunitydetailpage.d3bbf417': '将商机标记为最终成交（statecode=Won）',
    'pages.opportunity.opportunitydetailpage.e4ebdafc': '点击推进至此阶段',
    'pages.opportunity.opportunitydetailpage.f1db8e93': '阶段:',
    'pages.opportunity.opportunitydetailpage.f5176dd3': '申请日期',
    'pages.opportunity.opportunitydetailpage.f71663cd': 'TOP 5 商机',
    'pages.opportunity.opportunitydetailpage.submit.btn': '提交',
    'pages.opportunity.opportunitydetailpage.submit.title': '提交立项审核?',
    'pages.opportunity.opportunitydetailpage.submit.desc':
      '将商机提交至上级审核 (iws_audit_status 0→1), 派单给商机审核人并推 OA 待办',
    'pages.opportunity.opportunitydetailpage.submit.ok_text': '提交',
    'pages.opportunity.opportunitydetailpage.submit.ok': '已提交立项审核',
    'pages.opportunity.opportunitydetailpage.submit.fail': '提交失败',
    'pages.opportunity.opportunitydetailpage.cancel_submission.btn': '取消提交',
    'pages.opportunity.opportunitydetailpage.cancel_submission.ok': '已取消提交',
    'pages.opportunity.opportunitydetailpage.cancel_submission.fail': '取消提交失败',
    'pages.opportunity.opportunitydetailpage.publish.btn': '发布商机',
    'pages.opportunity.opportunitydetailpage.publish.title': '发布商机？',
    'pages.opportunity.opportunitydetailpage.publish.desc':
      '发布后，国内销售人员可以在销售看板中查看此商机，但不能编辑。',
    'pages.opportunity.opportunitydetailpage.publish.ok_text': '确认发布',
    'pages.opportunity.opportunitydetailpage.publish.ok': '商机已发布',
    'pages.opportunity.opportunitydetailpage.publish.fail': '发布失败',
    'pages.opportunity.opportunitydetailpage.publish.overdue_disabled': '过期商机不能发布',
    'pages.opportunity.opportunitydetailpage.publish.closed_disabled': '已关闭商机不能发布',
    'pages.opportunity.opportunitydetailpage.unpublish.btn': '撤回发布',
    'pages.opportunity.opportunitydetailpage.unpublish.title': '撤回商机发布？',
    'pages.opportunity.opportunitydetailpage.unpublish.desc':
      '撤回后，仅原有权限范围内的用户可以继续查看此商机。',
    'pages.opportunity.opportunitydetailpage.unpublish.ok_text': '确认撤回',
    'pages.opportunity.opportunitydetailpage.unpublish.ok': '已撤回发布',
    'pages.opportunity.opportunitydetailpage.unpublish.fail': '撤回发布失败',
    'pages.opportunity.opportunitydetailpage.sap_sync.idle': '未同步SAP',
    'pages.opportunity.opportunitydetailpage.sap_sync.retry': '同步SAP',
    'pages.opportunity.opportunitydetailpage.sap_sync.syncing': '同步SAP中',
    'pages.opportunity.opportunitydetailpage.sap_sync.done': '同步SAP完成',
    'pages.opportunity.opportunitydetailpage.sap_sync.start.ok': '已发起 SAP 立项同步',
    'pages.opportunity.opportunitydetailpage.sap_sync.start.fail': '发起 SAP 立项失败',
    'pages.opportunity.opportunitydetailpage.poc.awaiting_inbox': '· OA 审批流程处理中',
    'pages.opportunity.opportunitydetailpage.poc.button_locked_until_stage':
      '商机推进到「POC 申请」阶段后才能打开此弹窗; 弹窗内可选「申请 POC」或「跳过 POC」',
    'pages.opportunity.opportunitydetailpage.poc.button_locked_status':
      'POC 流程已发起, 请查看审批或 OA 进度',
    'pages.opportunity.opportunitydetailpage.poc.preapproval_required':
      '请先点击 POC Apply 提交 POC 审批',
    'pages.opportunity.opportunitydetailpage.poc.preapproval_pending':
      'POC 审批处理中，审批通过后将自动发起 OA POC 流程',
    'pages.opportunity.opportunitydetailpage.poc.preapproval_rejected':
      'CREST POC 审批已拒绝，请重新推进或联系审批人处理',
    'pages.opportunity.opportunitydetailpage.poc.preapproval_pending_short': '· CREST POC 审批中',
    'pages.opportunity.pocactionmodal.title': 'POC 测试 — 申请或跳过',
    'pages.opportunity.pocactionmodal.cancel': '取消',
    'pages.opportunity.pocactionmodal.ok_apply': '提交 POC 审批',
    'pages.opportunity.pocactionmodal.ok_skip': '跳过 POC, 进入商务谈判',
    'pages.opportunity.pocactionmodal.intro_title': 'POC 测试为可选阶段',
    'pages.opportunity.pocactionmodal.intro_desc':
      '如客户有 POC 测试需求, 请提交申请走审批; 如无 POC 需求, 可直接跳过, BPF 将跨过「POC 测试」阶段进入「商务谈判」.',
    'pages.opportunity.pocactionmodal.opt_apply': '申请 POC 测试',
    'pages.opportunity.pocactionmodal.opt_apply_desc':
      '提交后先发起 CREST POC 审批, 审批通过后系统再自动发起 OA POC 流程.',
    'pages.opportunity.pocactionmodal.apply_notify_title': '提交后发起 POC 审批',
    'pages.opportunity.pocactionmodal.apply_notify_desc':
      '仅选择「申请 POC 测试」时会发起 POC 审批; 选择「跳过 POC」不会发起审批或通知 OA.',
    'pages.opportunity.pocactionmodal.opt_skip': '跳过 POC',
    'pages.opportunity.pocactionmodal.opt_skip_desc':
      '不申请 POC, BPF 直接跨过「POC 测试」阶段, 推进到「商务谈判」. 跳过后无法在本商机再次发起 POC 申请.',
    'pages.opportunity.pocactionmodal.deadline_label': 'POC 期望完成日期 (可选)',
    'pages.opportunity.pocactionmodal.deadline_placeholder': '选择期望完成日期',
    'pages.opportunity.pocactionmodal.remark_label': '备注 (可选)',
    'pages.opportunity.pocactionmodal.remark_placeholder': '补充 POC 配置/需求说明',
    'pages.opportunity.pocactionmodal.skip_warn_title': '确认跳过 POC',
    'pages.opportunity.pocactionmodal.skip_warn_desc':
      '提交后商机将直接进入「商务谈判」阶段, 跨过 POC 测试. 此操作可撤销但需联系管理员重置 BPF.',
    'pages.opportunity.pocactionmodal.apply_ok':
      '已提交 POC 审批, 审批通过后将自动发起 OA POC 流程',
    'pages.opportunity.pocactionmodal.apply_success_title': 'POC 审批已提交',
    'pages.opportunity.pocactionmodal.apply_success_desc':
      '审批通过后，系统会自动发起 OA POC 流程。',
    'pages.opportunity.pocactionmodal.apply_error_title': 'POC 审批提交失败',
    'pages.opportunity.pocactionmodal.success_ok': '知道了',
    'pages.opportunity.pocactionmodal.skip_ok': '已跳过 POC, 商机进入「商务谈判」',
    'pages.opportunity.pocactionmodal.error': '操作失败',
    'pages.opportunity.opportunitydetailpage.bpf.rollback_blocked':
      '商机一旦推进就锁定, 不支持回退到更早阶段',
    'pages.opportunity.opportunitydetailpage.bpf.advance_blocked_unapproved':
      '商机尚未审批通过, 无法推进 BPF 阶段; 请先「提交立项审核」并等待审批通过, 通过后可跨多阶段跳转',
    'pages.opportunity.stageadvancemodal.02a754fd': '请选择',
    'pages.opportunity.stageadvancemodal.0480878c': '推进失败：{{v0}}',
    'pages.opportunity.stageadvancemodal.0eedb546':
      '💡 提示：「主要进展 / 风险与求助 / 决策链」等过程记录请使用右侧',
    'pages.opportunity.stageadvancemodal.36532716': '未知错误',
    'pages.opportunity.stageadvancemodal.4d5007f4': '选择日期',
    'pages.opportunity.stageadvancemodal.poc.yes': '是',
    'pages.opportunity.stageadvancemodal.poc.no': '否',
    'pages.opportunity.stageadvancemodal.504f02ee': '逐条添加，便于团队协作追溯（M40 已就绪）',
    'pages.opportunity.stageadvancemodal.a7aa4a94': '✓ 当前阶段无额外必填字段 — 可直接推进',
    'pages.opportunity.stageadvancemodal.a954b51e': '已推进到 {{v0}}',
    'pages.opportunity.stageadvancemodal.becc9ba5': '活动面板',
    'pages.opportunity.stageadvancemodal.c9912179': '下一阶段预计结束日期不能早于今天',
    'pages.opportunity.stageadvancemodal.d2288c73':
      '💡 D365 业务规则（手册 §3.5）：必须为下一阶段设定预计完成日期才能推进',
    'pages.opportunity.stageadvancemodal.d3d94dc9': '请填写：{{v0}}',
    'pages.opportunity.stageadvancemodal.dd6f0a00': '未配置 picker target',
    'pages.opportunity.stageadvancemodal.f5968d9c': '(元数据未加载)',
    'pages.pricing.pricingpages.02ef634d': '目录价 (USD)',
    'pages.pricing.pricingpages.0a99c718': '毛利率',
    'pages.pricing.pricingpages.0bc172ab': '失效',
    'pages.pricing.pricingpages.1568d874': '授权底线 — 报价低于此价需审批',
    'pages.pricing.pricingpages.18defa4c': '省份',
    'pages.pricing.pricingpages.1931bd67': '无匹配的国内底价记录',
    'pages.pricing.pricingpages.1d998702': '无匹配的海外底价记录',
    'pages.pricing.pricingpages.26420e68': '频段',
    'pages.pricing.pricingpages.3b55111f': '型号',
    'pages.pricing.pricingpages.3e2aae21': '生效日期',
    'pages.pricing.pricingpages.5ae00389': '条价格记录',
    'pages.pricing.pricingpages.5ccdb26d': '名称',
    'pages.pricing.pricingpages.73cfe830': '海外报价底表',
    'pages.pricing.pricingpages.7785ef82': '刷新',
    'pages.pricing.pricingpages.7f42a267': '生效期',
    'pages.pricing.pricingpages.83613fa3': '国家',
    'pages.pricing.pricingpages.85a38efe': '条 · 按国家 / 货币\n            (USD)',
    'pages.pricing.pricingpages.86156536': '关联底价',
    'pages.pricing.pricingpages.9229bd37': '成本价 🔒',
    'pages.pricing.pricingpages.a574d9e8': '通用价格底表',
    'pages.pricing.pricingpages.a7c2abe6': '国内报价底表',
    'pages.pricing.pricingpages.b2952938': '目录价',
    'pages.pricing.pricingpages.bd00b6d7': '销售价',
    'pages.pricing.pricingpages.bd2de7d8': '无限期',
    'pages.pricing.pricingpages.cad5863b': '条 · 按省份 × 子类\n            5-tuple 复合',
    'pages.pricing.pricingpages.cb34b4f0': '无匹配的价格记录',
    'pages.pricing.pricingpages.cbad5dee': '生效中',
    'pages.pricing.pricingpages.df8b2f04': '关联型号',
    'pages.pricing.pricingpages.e1b1e8ad': '红线价 🚨',
    'pages.pricing.pricingpages.e8d11724': '字段级安全可控 — 仅授权角色可见',
    'pages.pricing.pricingpages.fd23f9d4': '产品子类',
    'pages.quote.quotecreatemodal.008009d8': '已创建报价单 {{v0}}',
    'pages.quote.quotecreatemodal.0101ccbe': '报价名称必填',
    'pages.quote.quotecreatemodal.0b35046c': '运费条款',
    'pages.quote.quotecreatemodal.0b63e91f': '生效日期必填',
    'pages.quote.quotecreatemodal.149c1be0':
      '勾选时走海外报价 BPF (Drafting → Freight Quote → Double Check → Overseas VP)',
    'pages.quote.quotecreatemodal.181cb14c': '城市',
    'pages.quote.quotecreatemodal.19ed6cb1': '折扣金额',
    'pages.quote.quotecreatemodal.1a713759': '签约公司',
    'pages.quote.quotecreatemodal.200105d0': '— 未保存',
    'pages.quote.quotecreatemodal.24ad2d75': '报价单 · Quote ·',
    'pages.quote.quotecreatemodal.29d6fdad': '街道',
    'pages.quote.quotecreatemodal.3fd1bf19': '过期日期',
    'pages.quote.quotecreatemodal.456bbb91': '授权金额 (BAP 红线)',
    'pages.quote.quotecreatemodal.47a6f980': '价格表',
    'pages.quote.quotecreatemodal.4bbb6d6d': '附件',
    'pages.quote.quotecreatemodal.4e1325fb': '描述 / 条款',
    'pages.quote.quotecreatemodal.4fe74945': '未知错误',
    'pages.quote.quotecreatemodal.52c2c490': '商机直创',
    'pages.quote.quotecreatemodal.586105da': '创建并打开',
    'pages.quote.quotecreatemodal.591437d8': '请检查必填字段',
    'pages.quote.quotecreatemodal.5d94d51b': '客户',
    'pages.quote.quotecreatemodal.5e2aef0b': '联系人姓名',
    'pages.quote.quotecreatemodal.5f82641f': '海外业务',
    'pages.quote.quotecreatemodal.63e39cad': '物流 & 运费',
    'pages.quote.quotecreatemodal.6bc09fc5': '国家',
    'pages.quote.quotecreatemodal.743016c1': '取消',
    'pages.quote.quotecreatemodal.780e76ce': '报价名称',
    'pages.quote.quotecreatemodal.7f287eab': '新建报价单',
    'pages.quote.quotecreatemodal.88dca3ae':
      '💡 创建后在报价详情页通过 BOQ 同步产品行 + 附件 tab 上传',
    'pages.quote.quotecreatemodal.9ce163af': '折扣百分比 %',
    'pages.quote.quotecreatemodal.9e34deca': '详情',
    'pages.quote.quotecreatemodal.a5df2048': '账单地址',
    'pages.quote.quotecreatemodal.b1740255': '关联商机',
    'pages.quote.quotecreatemodal.b711b561': '选定价目级别 (Price List), 影响产品行项目默认价',
    'pages.quote.quotecreatemodal.bca8fd69': '失效日期',
    'pages.quote.quotecreatemodal.be6fb7aa': '价格 & 折扣',
    'pages.quote.quotecreatemodal.c297f473': '创建失败: {{v0}}',
    'pages.quote.quotecreatemodal.c7b34093': '{{v0}} - 报价',
    'pages.quote.quotecreatemodal.ca5f50fd': '付款条件',
    'pages.quote.quotecreatemodal.d0f7465f': '货币',
    'pages.quote.quotecreatemodal.d1bf470f': '概要',
    'pages.quote.quotecreatemodal.d5a9a711': '付款方式 / 交付条款 / 售后条款 / 其他说明...',
    'pages.quote.quotecreatemodal.db45d7a7': '客户必填',
    'pages.quote.quotecreatemodal.e1fae0b6': '运输方式',
    'pages.quote.quotecreatemodal.e47865ad': '时效',
    'pages.quote.quotecreatemodal.e4fe27d9': '报价 Terms & Conditions — 创建后可在详情页编辑',
    'pages.quote.quotecreatemodal.eaac39e6': '签约公司必填',
    'pages.quote.quotecreatemodal.ee5d9aec': '生效日期',
    'pages.quote.quotecreatemodal.f1a59137': '基本信息',
    'pages.quote.quotecreatemodal.fad34eaa': '运费金额',
    'pages.quote.quotedetailpage.state_vs_bpf_tooltip':
      '此为 D365「单据状态」(草稿 / 激活 / 赢单 / 丢单), 与 BPF 流程阶段是两个独立维度. BPF 推进到「价格审核」时, 单据状态可能仍为「草稿」, 直到手动激活/赢单触发状态切换. 请以 BPF 进度条为实际工作流位置.',
    'pages.quote.quotedetailpage.0d262424': '小计',
    'pages.quote.quotedetailpage.0d6ffb87': '已从 BOQ 同步 {{v0}} 行{{v1}}',
    'pages.quote.quotedetailpage.1d6bad47': '{{v0}} 月',
    'pages.quote.quotedetailpage.228215ef': '条款 / 备注',
    'pages.quote.quotedetailpage.28eebe6c': 'PDF 生成失败',
    'pages.quote.quotedetailpage.2b753d6b': '已自动推进到 {{v0}}',
    'pages.quote.quotedetailpage.3183a88a': '返回商机列表',
    'pages.quote.quotedetailpage.43f84e7d': '数量',
    'pages.quote.quotedetailpage.458e9c60': '编号',
    'pages.quote.quotedetailpage.47b7c08f':
      '模拟从外部 BOQ 网站拉回 3-5 个随机 Baicells 5G 产品；30%\n                            概率单价低于授权价 → 触发 BAP banner',
    'pages.quote.quotedetailpage.4ac12af7': '条款',
    'pages.quote.quotedetailpage.57c46603': '关联商机请点击概要中的"关联商机"链接跳转到商机详情。',
    'pages.quote.quotedetailpage.57c9a08b': '取消',
    'pages.quote.quotedetailpage.5bbea251': '关联商机',
    'pages.quote.quotedetailpage.63aad8b2': '该报价未启动 BPF（旧数据 / 直接 SQL 创建）',
    'pages.quote.quotedetailpage.6750108d':
      'BOQ Website (Mock) — 真实场景将打开外部 BOQ 选购系统。点击下方 "Refresh from BOQ" 模拟拉回所选产品。',
    'pages.quote.quotedetailpage.67eb4511': '描述',
    'pages.quote.quotedetailpage.6950b19e': '海外报价流程（旧）',
    'pages.quote.quotedetailpage.7442bfe3': '{{v0}} 小时',
    'pages.quote.quotedetailpage.83c474bc': '北美市场，无 VAT',
    'pages.quote.quotedetailpage.89450afb': '激活失败',
    'pages.quote.quotedetailpage.96fba303': '推送失败',
    'pages.quote.quotedetailpage.97e5b019': 'BOQ 同步失败',
    'pages.quote.quotedetailpage.9a9f122e': '单价',
    'pages.quote.quotedetailpage.aa3a4697': '产品',
    'pages.quote.quotedetailpage.b2d5598e': '自动推进失败',
    'pages.quote.quotedetailpage.b502912d': '海外其它市场',
    'pages.quote.quotedetailpage.bapWarningsSuffix': ' (其中 {{count}} 行触发 BAP 警告)',
    'pages.quote.quotedetailpage.be769473': '{{v0}} 分钟',
    'pages.quote.quotedetailpage.c46ed399': '{{v0}} 天',
    'pages.quote.quotedetailpage.c665d6c3': '海外报价流程（新）',
    'pages.quote.quotedetailpage.c7093d85':
      '该报价暂无产品行项目 — 点击 BOQ Website 选购品后再 Refresh from BOQ',
    'pages.quote.quotedetailpage.ce3ae1c7': '完成于',
    'pages.quote.quotedetailpage.cfa50868': 'Baicells China (中文)',
    'pages.quote.quotedetailpage.d0b373e3': '国内市场，含 VAT 13%',
    'pages.quote.quotedetailpage.e5bb0ba0': '国内报价流程',
    'pages.quote.quotedetailpage.ed97db61': '推进失败',
    'pages.quote.quotedetailpage.f4d0c250': '已推进到 {{v0}}',
    'pages.quote.quotedetailpage.f62b8ba2': '报价已激活',
    'pages.sales.weeklyreportpage.12f03af7': '本时段无销售周报',
    'pages.sales.weeklyreportpage.1d091eea': '快速选',
    'pages.sales.weeklyreportpage.22c50231': '手册 §3.2 — 此页聚合所有标记为',
    'pages.sales.weeklyreportpage.28a9e388': '销售周报',
    'pages.sales.weeklyreportpage.48e1b1df': '上月',
    'pages.sales.weeklyreportpage.5878920a': '上周',
    'pages.sales.weeklyreportpage.67dd1767': '试试其他关键词',
    'pages.sales.weeklyreportpage.7d0bda83': '加载销售周报失败',
    'pages.sales.weeklyreportpage.8428f9b8': '展开',
    'pages.sales.weeklyreportpage.8a2c25b1':
      '销售员需在商机详情页右侧 Activity 栏添加 note 类型 + weekly-update 标签',
    'pages.sales.weeklyreportpage.9789196b': '刷新',
    'pages.sales.weeklyreportpage.b0e5bd0e': '+ 标签',
    'pages.sales.weeklyreportpage.b9d85025': '本月',
    'pages.sales.weeklyreportpage.bab04a8c': '条更新 ·',
    'pages.sales.weeklyreportpage.c1e942d1': '位销售员 ·',
    'pages.sales.weeklyreportpage.c72e44ab': '未找到销售员 "{{v0}}"',
    'pages.sales.weeklyreportpage.d045d393':
      '的笔记类活动 (商机时间线 / 项目状态 / 风险), 由销售员每周更新。 推荐到对应商机详情页的\n          Activity 右侧栏新建',
    'pages.sales.weeklyreportpage.d5f2b687': '(未知)',
    'pages.sales.weeklyreportpage.d87de868': '条更新',
    'pages.sales.weeklyreportpage.da054840': '本周',
    'pages.sales.weeklyreportpage.e29107f4': '按销售员过滤',
    'pages.sinosure.sinosurecreatemodal.04940c69': '已拒绝',
    'pages.sinosure.sinosurecreatemodal.04defe01': '申请名称必填',
    'pages.sinosure.sinosurecreatemodal.0530b2c8': '概要',
    'pages.sinosure.sinosurecreatemodal.0625e320': '申请信息',
    'pages.sinosure.sinosurecreatemodal.09235a3a': '附件',
    'pages.sinosure.sinosurecreatemodal.0edfe979': '风险状态',
    'pages.sinosure.sinosurecreatemodal.106cec16': '财务信息',
    'pages.sinosure.sinosurecreatemodal.19930d1f': '币种',
    'pages.sinosure.sinosurecreatemodal.214b7a60': '— 未保存',
    'pages.sinosure.sinosurecreatemodal.2ca856c8': '创建并打开',
    'pages.sinosure.sinosurecreatemodal.2e72a882': '待受理',
    'pages.sinosure.sinosurecreatemodal.35688ef0': '未知错误',
    'pages.sinosure.sinosurecreatemodal.357cc44f': '申请备注',
    'pages.sinosure.sinosurecreatemodal.38ef6afc': '低',
    'pages.sinosure.sinosurecreatemodal.3a35a8f8': '已创建中信保 {{v0}}',
    'pages.sinosure.sinosurecreatemodal.3b5b346a': '备注',
    'pages.sinosure.sinosurecreatemodal.47b3ed3e': '申请名称',
    'pages.sinosure.sinosurecreatemodal.4b8f0771': '高',
    'pages.sinosure.sinosurecreatemodal.4fbd23a2': '创建失败: {{v0}}',
    'pages.sinosure.sinosurecreatemodal.605ca80d': '北京佰才邦技术集团股份有限公司',
    'pages.sinosure.sinosurecreatemodal.62ebed32': '关联报价',
    'pages.sinosure.sinosurecreatemodal.63b04175': '签约公司',
    'pages.sinosure.sinosurecreatemodal.748debe6': '百分比, 例 0.85% 填 0.0085',
    'pages.sinosure.sinosurecreatemodal.7659f734': '风险与受理',
    'pages.sinosure.sinosurecreatemodal.7745f37e': '信用额度必填',
    'pages.sinosure.sinosurecreatemodal.776a8002': '中信保 · Sinosure · 海外信用保险',
    'pages.sinosure.sinosurecreatemodal.7ce15c1c': '中',
    'pages.sinosure.sinosurecreatemodal.8729db71': '深圳佰才邦技术有限公司',
    'pages.sinosure.sinosurecreatemodal.8a818141': '信用费率',
    'pages.sinosure.sinosurecreatemodal.8cf57b46': '保险有效期',
    'pages.sinosure.sinosurecreatemodal.99a90b8a': '基本信息',
    'pages.sinosure.sinosurecreatemodal.9aaa3db9': '取消',
    'pages.sinosure.sinosurecreatemodal.9b4680f6': '授信期 (月)',
    'pages.sinosure.sinosurecreatemodal.9f4ad722': '已受理',
    'pages.sinosure.sinosurecreatemodal.a3c12030': '申请日期',
    'pages.sinosure.sinosurecreatemodal.a4a744fc': '生效日期',
    'pages.sinosure.sinosurecreatemodal.a9f2cbe2': '申请日期必填',
    'pages.sinosure.sinosurecreatemodal.acee8b7d': '关联商机',
    'pages.sinosure.sinosurecreatemodal.bda7c31a': '受理状态',
    'pages.sinosure.sinosurecreatemodal.bee3205a': '月',
    'pages.sinosure.sinosurecreatemodal.c3053387': '保费',
    'pages.sinosure.sinosurecreatemodal.cc4b29ac': '到期日期',
    'pages.sinosure.sinosurecreatemodal.d53a27c1': '付款条件',
    'pages.sinosure.sinosurecreatemodal.de4c11f1': '详情',
    'pages.sinosure.sinosurecreatemodal.e25b3f19': '客户',
    'pages.sinosure.sinosurecreatemodal.e30806f2': '请检查必填字段',
    'pages.sinosure.sinosurecreatemodal.e73cdcf7':
      '💡 创建后在中信保详情页"附件"tab 上传申请材料 / 财务报表 / 评级证明',
    'pages.sinosure.sinosurecreatemodal.ee734c07': '低 / 中 / 高 风险评估',
    'pages.sinosure.sinosurecreatemodal.ef9dbb22': '信用额度',
    'pages.sinosure.sinosurecreatemodal.f51b988d': '客户必填',
    'pages.sinosure.sinosurecreatemodal.f6eb3731': '新建中信保',
    'pages.sinosure.sinosuredetailpage.37c03bad': '财务',
    'pages.sinosure.sinosuredetailpage.40623c2d': '该中信保未启动 BPF',
    'pages.sinosure.sinosuredetailpage.5c2516a6': '推进失败',
    'pages.sinosure.sinosuredetailpage.602d57dc': '{{v0}} 分钟',
    'pages.sinosure.sinosuredetailpage.6818603e': '完成于',
    'pages.sinosure.sinosuredetailpage.7331544a': '已推进到 {{v0}}',
    'pages.sinosure.sinosuredetailpage.7f997f32': '信用额度',
    'pages.sinosure.sinosuredetailpage.97826dd5': '批复金额',
    'pages.sinosure.sinosuredetailpage.ab849957': '{{v0}} 月',
    'pages.sinosure.sinosuredetailpage.bb7b038c': '{{v0}} 天',
    'pages.sinosure.sinosuredetailpage.d26ee839': '{{v0}} 小时',
    'pages.sinosure.sinosuredetailpage.e46ceafe': '财务信息',
    'pages.welcomepage.0025c1af': '条',
    'pages.welcomepage.18b4a6c2': 'M0 阶段（工程基础）',
    'pages.welcomepage.1d9193c6': 'App + Sitemap + AdminScope（3 App\n              体系）',
    'pages.welcomepage.3bc33906': 'Identity Module + JWT + 4 档深度权限',
    'pages.welcomepage.41711f61': '下一步：M1 后端基础设施',
    'pages.welcomepage.43f2439e': 'Baicells D365 复刻 — Welcome',
    'pages.welcomepage.6136eb7d': 'M0 阶段',
    'pages.welcomepage.6e770e76': 'Prisma db pull → 70 表 type-safe\n              client',
    'pages.welcomepage.71420b89': '业务数据行',
    'pages.welcomepage.7b0f421c': 'API 端点',
    'pages.welcomepage.7f4a8867': '🎉 M0 启动成功',
    'pages.welcomepage.98bdff0b': 'Monorepo 工程骨架已就绪。这是 v5 计划中的',
    'pages.welcomepage.9db12377': '数据表',
    'pages.welcomepage.a10996b3': '已就绪',
    'pages.welcomepage.ae21054e': '产出，验证前端 →\n              后端 → 数据库链路通。',
    'pages.welcomepage.afb54d57': '字段级安全 (FSP) Interceptor',
    'pages.welcomepage.c58a36e5': '→ 进入登录页（占位）',
    'pages.welcomepage.eba17c75': '权限规则',
    'pages.welcomepage.f70b45ba':
      'EventBus + CollectionService +\n              AgentTool（Aion 借鉴）',
    'pages.salesorder.salesorderdetailpage.active': '活动',
    'pages.salesorder.salesorderdetailpage.amount': '金额',
    'pages.salesorder.salesorderdetailpage.amounts': '金额',
    'pages.salesorder.salesorderdetailpage.basicInfo': '基本信息',
    'pages.salesorder.salesorderdetailpage.canceled': '已取消',
    'pages.salesorder.salesorderdetailpage.delivery': '交付与条款',
    'pages.salesorder.salesorderdetailpage.fulfilled': '已完成',
    'pages.salesorder.salesorderdetailpage.fulfillment': '履约',
    'pages.salesorder.salesorderdetailpage.invoiced': '已开票',
    'pages.salesorder.salesorderdetailpage.lineNo': '行号',
    'pages.salesorder.salesorderdetailpage.lines': '订单产品',
    'pages.salesorder.salesorderdetailpage.noLines': '该订单暂无产品行',
    'pages.salesorder.salesorderdetailpage.product': '产品',
    'pages.salesorder.salesorderdetailpage.quantity': '数量',
    'pages.salesorder.salesorderdetailpage.statusOwner': '状态与负责人',
    'pages.salesorder.salesorderdetailpage.submitted': '已提交',
    'pages.salesorder.salesorderdetailpage.summary': '概要',
    'pages.worklist.worklistpage.0a9112a5': '报价单',
    'pages.worklist.worklistpage.1a0cfcd1': '刷新',
    'pages.worklist.worklistpage.276e0240': '共',
    'pages.worklist.worklistpage.2def98a3': '编号 / 备注',
    'pages.worklist.worklistpage.41934218': '标题',
    'pages.worklist.worklistpage.480dd1c4': '共 {{v0}} 条',
    'pages.worklist.worklistpage.60da3722': '全部',
    'pages.worklist.worklistpage.62825ff9': '客户',
    'pages.worklist.worklistpage.6c1fb958': '金额',
    'pages.worklist.worklistpage.9a2e77e7': '潜在客户',
    'pages.worklist.worklistpage.a0b836cf': '状态',
    'pages.worklist.worklistpage.ae8579ce': '类型',
    'pages.worklist.worklistpage.b69062d0': '待审批',
    'pages.worklist.worklistpage.d61e2077': '商机',
    'pages.worklist.worklistpage.e64e5c73': '修改时间',
    'pages.worklist.worklistpage.edd642af': '条',
  },
  en: {
    'opportunity_close.action': 'Close',
    'opportunity_close.title': 'Close opportunity project',
    'opportunity_close.subtitle':
      'After closing, this opportunity project will no longer appear in OA.',
    'opportunity_close.remark': 'Close remark',
    'opportunity_close.remark_placeholder': 'Enter the close reason or additional notes',
    'opportunity_close.remark_required': 'Close remark is required',
    'opportunity_close.confirm': 'Close project',
    'opportunity_close.success': 'SAP project close request submitted',
    'opportunity_close.failed': 'Failed to close project',
    'opportunity_close.no_sap_code': 'No SAP project code yet',
    'opportunity_close.partial_warning':
      'The project was closed, but the remark could not be recorded. Contact an administrator.',
    'opportunity_close.info_title': 'Close information',
    'opportunity_close.closed_by': 'Closed by',
    'opportunity_close.closed_on': 'Closed on',
    'api.auth.provider.8f243339': 'PasswordError',
    'api.auth.provider.df7d98cc': 'Login failed',
    'api.auth.provider.serviceUnavailable':
      'The authentication service is temporarily unavailable. Please try again later.',
    'api.use.can.a9dd1e49':
      '[useCan] capability "{{v0}}" is not registered in CAPABILITY_PRIVILEGE_MAP; defaulting to allow. Please add a mapping in use-can.ts.',
    'app.707cf2ac': 'Lead',
    'app.8de44d6e': 'Opportunity',
    'app.94022906': 'Sinosure',
    'app.94fed782': 'Delivery Project',
    'app.salesorder': 'Order',
    'app.b61a1e83': 'Contact',
    'app.contracts': 'Sales Contracts',
    'app.contractTemplates': 'Contract Templates',
    'app.d19594fe': 'Account',
    'app.e11951f6': 'Quote',
    'common.create_draft_failed': 'Failed to save draft',
    'common.create_draft_saved': 'Saved to drafts',
    'common.create_drafts': 'Drafts',
    'common.save_create_draft': 'Save Draft',
    'components.activity.activitypanel.014da488': 'Activities ({{v0}})',
    'components.activity.activitypanel.1b6b3ee7': 'Field Comments',
    'components.activity.activitypanel.1c3342ec': 'Reply',
    'components.activity.activitypanel.28e4e6f9': 'Activities',
    'components.activity.activitypanel.2a1ff916': 'Comment',
    'components.activity.activitypanel.2dd898a7': 'User',
    'components.activity.activitypanel.2e1907f0': 'Reply to @{{v0}}...',
    'components.activity.activitypanel.2e6e5f91': 'Reply failed',
    'components.activity.activitypanel.4688262e': 'Email',
    'components.activity.activitypanel.4692c439': 'Cancel',
    'components.activity.activitypanel.4771d02a': 'Just now',
    'components.activity.activitypanel.5f9409a6': 'No activity records',
    'components.activity.activitypanel.6dcd89c2': 'Note',
    'components.activity.activitypanel.72ac8940': 'Task',
    'components.activity.activitypanel.76365814': 'Call',
    'components.activity.activitypanel.76f90518': 'More',
    'components.activity.activitypanel.77f33797': 'Expand',
    'components.activity.activitypanel.7e9082b9': '{{v0}} days ago',
    'components.activity.activitypanel.86ed5e7d': 'Send',
    'components.activity.activitypanel.8d8e324c': 'Refresh',
    'components.activity.activitypanel.93967614': 'Meeting',
    'components.activity.activitypanel.9789668a': 'No comments for this field',
    'components.activity.activitypanel.a1201945': 'Task ()',
    'components.activity.activitypanel.a7ea49c9': '{{v0}} minutes ago',
    'components.activity.activitypanel.aafe6fa2': 'System',
    'components.activity.activitypanel.abcd3ea2': ' · Field: {{v0}}',
    'components.activity.activitypanel.aeac7026': 'Delete failed',
    'components.activity.activitypanel.b5e63ca3': '{{v0}} hours ago',
    'components.activity.activitypanel.b83acbc1': '{{v0}} content...',
    'components.activity.activitypanel.c03fde6f': 'Pin',
    'components.activity.activitypanel.c1d301b4': 'System records ({{v0}})',
    'components.activity.activitypanel.c6211f8f': 'Send failed',
    'components.activity.activitypanel.e11a5abb': 'Delete',
    'components.activity.activitypanel.e9a417ac': 'Content cannot be empty',
    'components.activity.activitypanel.f34624c6': 'System records',
    'components.activity.activitypanel.fd70b176': 'Field:',
    'components.activity.activitypanel.read_only': 'Read-only',
    'components.activity.fieldcommenticon.172a8220': '{{v0}} comments',
    'components.activity.fieldcommenticon.1d2b9f98': 'Field comments - {{v0}}',
    'components.activity.fieldcommenticon.26ddd607': 'Add comment',
    'components.admincrudpage.129b37d5': '{{v0}} is required',
    'components.admincrudpage.1417a090': 'items',
    'components.admincrudpage.1a2c9d1e': 'Cancel',
    'components.admincrudpage.31df53a6': 'Edit',
    'components.admincrudpage.31fcda51': 'Total {{v0}} items',
    'components.admincrudpage.44943c2d': 'Delete failed',
    'components.admincrudpage.50f9534c': 'Save failed',
    'components.admincrudpage.9f199bf7': 'Delete',
    'components.admincrudpage.a0a0ea31': 'KeySearch',
    'components.admincrudpage.b013b4d4': 'Yes',
    'components.admincrudpage.b4acc92f': 'No',
    'components.admincrudpage.cda58363': 'Total',
    'components.admincrudpage.d3f1c527': 'Refresh',
    'components.admincrudpage.eee8b8b4': 'Actions',
    'components.attachment.categories.01279540': 'Requirement',
    'components.attachment.categories.12504de1': 'Bid document',
    'components.attachment.categories.138d6083': 'Resume',
    'components.attachment.categories.29fd4889': 'Solution',
    'components.attachment.categories.384598ed': 'Contract',
    'components.attachment.categories.3e1c4312': 'Other',
    'components.attachment.categories.4b84ceb6': 'Company presentation',
    'components.attachment.categories.576df17c': 'Product brochure',
    'components.attachment.categories.5e8f1f3d': 'Company profile',
    'components.attachment.categories.6eec46f3': 'Account profile',
    'components.attachment.categories.70a7f7dd': 'Avatar',
    'components.attachment.categories.84668ef4': 'Proposal',
    'components.attachment.categories.b0261104': 'Certificates',
    'components.attachment.categories.dce38cbf': 'Business card',
    'components.attachment.categories.f7a669b1': 'Agreement',
    'components.attachmentlist.052f9822': 'PowerPoint demo (.ppt)',
    'components.attachmentlist.05c546a9': 'Download now',
    'components.attachmentlist.0635039f': 'PreviewFailed',
    'components.attachmentlist.095e9359': 'CommentsSubmitFailed',
    'components.attachmentlist.0e3db995': 'Delete failed',
    'components.attachmentlist.12f8513b':
      'CommentsAutomatic"Activities"Time; CommentsLinkAttachments, .',
    'components.attachmentlist.1c68c1e0': 'Preview, ClickViewDetails',
    'components.attachmentlist.2410fefb': 'Preview...',
    'components.attachmentlist.27858f72': 'Word (.docx)',
    'components.attachmentlist.29cccdd9': '{{v0}} file',
    'components.attachmentlist.2e798da5': ' comments',
    'components.attachmentlist.32457deb': 'Word (.doc)',
    'components.attachmentlist.392fba2f': 'PowerPoint demo (.pptx)',
    'components.attachmentlist.4a353ea3': ' files)',
    'components.attachmentlist.548335a6': 'Preview, Download.',
    'components.attachmentlist.5c6e3570': 'Comments on attachment {{v0}} - {{v1}}',
    'components.attachmentlist.644d586b': '{{v0}} uploads failed',
    'components.attachmentlist.683a791f': 'Unknown format',
    'components.attachmentlist.6fe83bb3': 'Close',
    'components.attachmentlist.71ced9b4': 'Post comment',
    'components.attachmentlist.754ad042': 'Attachmentlist',
    'components.attachmentlist.79457e52': 'Attachment comments',
    'components.attachmentlist.7c7e8489': 'Upload: {{v0}} succeeded / {{v1}} failed',
    'components.attachmentlist.7fe9a9c7': 'Excel (.xls)',
    'components.attachmentlist.87ba29e8': 'Deleted',
    'components.attachmentlist.8816c7a7': 'Cancel',
    'components.attachmentlist.92b86c26': 'Download failed',
    'components.attachmentlist.9420b428': 'Upload...',
    'components.attachmentlist.99d7bdc0': 'Attachmentlist',
    'components.attachmentlist.9b9d6908': 'Download',
    'components.attachmentlist.9df1e88b': 'Delete',
    'components.attachmentlist.a8865368': 'Confirm delete?',
    'components.attachmentlist.a8a9800a': 'No files in the {{v0}} category',
    'components.attachmentlist.a8d9badd': 'Comment',
    'components.attachmentlist.ae3e23a5': '.{{v0}} File',
    'components.attachmentlist.bb4d25f1': 'Previewable',
    'components.attachmentlist.c22fb256': 'Attachmentlist',
    'components.attachmentlist.c45edfe5': 'Online preview',
    'components.attachmentlist.c5dee85b': 'Comments',
    'components.attachmentlist.c8f11ff5': 'Uploaded {{v0}} files -> {{v1}}',
    'components.attachmentlist.ca7d6281': 'CommentsAddTime',
    'components.attachmentlist.cc19bcc5': 'Please enterAttachments comments / / Recommended...',
    'components.attachmentlist.cd51a27b': 'Excel (.xlsx)',
    'components.attachmentlist.d34f31bd': 'Attachmentlist',
    'components.attachmentlist.ee3ca748': 'Word document rendering failed: {{v0}}',
    'components.attachmentlist.f23e42ab': 'All',
    'components.attachmentlist.f704202f': 'Preview',
    'components.attachmentlist.fc10e2cc': 'Cancel(Discard',
    'components.createdraftlist.actions': 'Actions',
    'components.createdraftlist.continue_edit': 'Continue',
    'components.createdraftlist.delete_content': 'This draft cannot be restored after deletion.',
    'components.createdraftlist.delete_success': 'Draft deleted',
    'components.createdraftlist.delete_title': 'Delete draft',
    'components.createdraftlist.empty_description':
      'Drafts saved from the create form will appear here.',
    'components.createdraftlist.empty_title': 'No drafts',
    'components.createdraftlist.error': 'Error',
    'components.createdraftlist.modifiedon': 'Updated At',
    'components.createdraftlist.search': 'Search drafts',
    'components.createdraftlist.source': 'Source',
    'components.createdraftlist.source_failed': 'Auto-saved after create failure',
    'components.createdraftlist.source_manual': 'Manual',
    'components.createdraftlist.subtitle': '{{v0}} drafts',
    'components.createdraftlist.title': 'Title',
    'components.entitylookup.44b8f1f6': 'No matches',
    'components.entitylookup.60330e73': 'Select or search',
    'components.exportbutton.e45f482a': 'Export failed',
    'components.fullnamepreview.df723bc9': 'Please first Last Name First Name',
    'components.languageswitcher.aa336229': 'Simplified Chinese',
    'components.languageswitcher.c1b0f4d2': 'Switch Language',
    'components.roleavatarswitcher.08d325f3': 'Current Attribute',
    'components.roleavatarswitcher.16f0f25a': 'Overseas User',
    'components.roleavatarswitcher.39f48843': 'Domestic User',
    'components.roleavatarswitcher.4c1b0b4e': 'Change Password',
    'components.roleavatarswitcher.4f30b6b7': 'Password updated',
    'components.roleavatarswitcher.5aa12dc8': 'New password must be at least 8 characters',
    'components.roleavatarswitcher.5ab42f91': 'Name',
    'components.roleavatarswitcher.5c7ed106': 'Account',
    'components.roleavatarswitcher.61b2d2d4': 'User Attributes',
    'components.roleavatarswitcher.6d2ea9a6': 'Interface Language',
    'components.roleavatarswitcher.75f2cba9': 'Please enter a new password',
    'components.roleavatarswitcher.7d77d073': 'Default Currency',
    'components.roleavatarswitcher.7f6173b9': 'New Password',
    'components.roleavatarswitcher.87c1d6f7': 'Roles',
    'components.roleavatarswitcher.88e84432': 'Please enter your current password',
    'components.roleavatarswitcher.8cbf162d':
      'Switch domestic or overseas attributes from the avatar menu; the interface language updates at the same time.',
    'components.roleavatarswitcher.91dbb767': 'Business Unit',
    'components.roleavatarswitcher.9d8c7e31': 'Profile Center',
    'components.roleavatarswitcher.a7f4c2d0': 'Personal Settings',
    'components.roleavatarswitcher.b62cb8b4': 'Save Password',
    'components.roleavatarswitcher.c53254c8': 'Confirm New Password',
    'components.roleavatarswitcher.c53cec6e': 'Please enter the new password again',
    'components.roleavatarswitcher.e0a98aa3': 'Current Password',
    'components.roleavatarswitcher.f020f65a': 'Failed to update password',
    'components.roleavatarswitcher.fab8c53c': 'The two passwords do not match',
    'components.multientitychecklist.4c2f97ed': 'Selected',
    'components.multientitychecklist.5ece769c': 'No data',
    'components.multientitychecklist.69184c16': 'Search name...',
    'components.multientitychecklist.a4bb060d': 'Multientitychecklist',
    'components.multientitychecklist.a68761b6': 'Clear',
    'components.multientitychecklist.b195cfe4': 'No matches',
    'components.multientitylookup.6698fd0b': 'SearchSelect ...',
    'components.multientitylookup.80f289c4': 'No matches',
    'components.multipresalessubgrid.00ea88d7': 'Add user',
    'components.multipresalessubgrid.054f7181': 'No matchesUser, LostKeySearch',
    'components.multipresalessubgrid.087a7cfe': 'UserOpportunity read + quote_create Privileges',
    'components.multipresalessubgrid.1294eabc': 'Multipresalessubgrid',
    'components.multipresalessubgrid.1bd1158a': '(optional)',
    'components.multipresalessubgrid.20116f0c':
      'Sales Technical Support User, UserAutomaticOpportunityPrivilegesQuoteCreatePrivileges',
    'components.multipresalessubgrid.2cabf945': 'Refresh',
    'components.multipresalessubgrid.2cc2b4af': 'Remove failed: {{v0}}',
    'components.multipresalessubgrid.2f231f3a': 'Removed',
    'components.multipresalessubgrid.2f80117f':
      'UserViewOpportunityDetailsCreateQuote. ConfirmNone.',
    'components.multipresalessubgrid.375795da': 'Total',
    'components.multipresalessubgrid.4c52b063': 'RemoveUserOpportunityPrivileges',
    'components.multipresalessubgrid.54b39975': ' digits',
    'components.multipresalessubgrid.6f7c8822': 'Cancel',
    'components.multipresalessubgrid.9a79f896': 'Add failed: {{v0}}',
    'components.multipresalessubgrid.afaec564': 'Unknown error',
    'components.multipresalessubgrid.b658a1fb': 'Add',
    'components.multipresalessubgrid.c10f6e36': 'No Sales Technical Support User',
    'components.multipresalessubgrid.c5a8e98d': 'Please selectUser',
    'components.multipresalessubgrid.d104670c': 'Actions',
    'components.multipresalessubgrid.ddc95272': 'Remove',
    'components.multipresalessubgrid.e421d84d': 'Add Sales Technical Support User',
    'components.multipresalessubgrid.f6a38533': 'ConfirmRemove？',
    'components.multipresalessubgrid.fa27e84f': 'Search usersName / Email',
    'components.multipresalessubgrid.fffbb8a4':
      'Add Sales Technical Support User (automatic read + quote_create)',
    'components.notificationbell.09896576': 'Notification Center',
    'components.notificationbell.6e6a5318': 'Mark all read',
    'components.notificationbell.efe7b36b': 'No notifications',
    'components.pricelookup.32631649': 'Validity:',
    'components.pricelookup.5431fe18': 'Found {{v0}} matches and marked the best one',
    'components.pricelookup.6e5060e6': 'Submit a query to get prices',
    'components.pricelookup.7501f849': 'Tip: Field; Medium = Fields',
    'components.pricelookup.7b82def6': 'Unknown error',
    'components.pricelookup.7fc7a83f': 'Match Score',
    'components.pricelookup.8bb22a17': 'Gross Margin',
    'components.pricelookup.9df8132e': 'Permanent',
    'components.pricelookup.a6b1d076': 'List Price',
    'components.pricelookup.aa7a09e6': 'Select subclass',
    'components.pricelookup.ba589739': 'Authorized Price',
    'components.pricelookup.bcbba170': 'Source',
    'components.pricelookup.c08b43c7': '(Overseas / overseas)',
    'components.pricelookup.ce219cb5': 'Query failed: {{v0}}',
    'components.pricelookup.e0b11d12': 'Discounted Price',
    'components.pricelookup.ef2f013a': 'No matching price found - check subclass/country or period',
    'components.pricelookup.f79bd6a9': '(First Name)',
    'components.quickcreate.134a0258': 'Account',
    'components.quickcreate.29fe7ff8': 'Created {{v0}}',
    'components.quickcreate.4c4f8cef': '{{v0}} is required',
    'components.quickcreate.565b8f45': 'Contact',
    'components.quickcreate.66dd37f8': 'Required · Fieldafter creationdetail pageEdit',
    'components.quickcreate.80ec98b9': 'New {{v0}}',
    'components.quickcreate.94e3228a': 'Lead',
    'components.quickcreate.ab7a04d2': 'Create and Open',
    'components.quickcreate.b926d920': 'Opportunity',
    'components.quickcreate.b92eb156': 'with',
    'components.quickcreate.d8c044c6': 'Cancel',
    'components.quickcreate.e743f5f8': 'Quote',
    'components.quickcreate.f2c95e85': 'Create failed',
    'components.salesforecastsubgrid.06bb4411':
      'Product category / Subcategory / Frequency Band / QuantityOpportunity',
    'components.salesforecastsubgrid.0f39e8bd': 'New forecast',
    'components.salesforecastsubgrid.117a9e04': 'Unit price',
    'components.salesforecastsubgrid.1a8a79a3': 'New',
    'components.salesforecastsubgrid.1f295ca5': '(optional)',
    'components.salesforecastsubgrid.218410fc': 'Subcategory',
    'components.salesforecastsubgrid.21bc6c8b': 'Deleted',
    'components.salesforecastsubgrid.269af719': 'OverseasMarketOpportunity 1 items Sales Forecast',
    'components.salesforecastsubgrid.2b52b5c4': 'Refresh',
    'components.salesforecastsubgrid.2e5073ef': 'Please first',
    'components.salesforecastsubgrid.318dad42':
      'AutomaticRevenue,OpportunityEstimated revenue (manual §3.2)',
    'components.salesforecastsubgrid.48f4ac77': 'Updated',
    'components.salesforecastsubgrid.4bcc0770': 'Edit Sales Forecast',
    'components.salesforecastsubgrid.4dd192ab': 'Unit price',
    'components.salesforecastsubgrid.50a2c8a5': 'Quantity',
    'components.salesforecastsubgrid.56ac279b': 'None Sales Forecast',
    'components.salesforecastsubgrid.6b8c78d4': 'Band',
    'components.salesforecastsubgrid.6cd6d2ed': 'Added',
    'components.salesforecastsubgrid.7187485d': 'Delete failed: {{v0}}',
    'components.salesforecastsubgrid.71d3f13a': 'Actions',
    'components.salesforecastsubgrid.7593d687': 'Select subclass',
    'components.salesforecastsubgrid.82531980':
      'SubmitApprovalAddproduct classificationEstimated quantity. Overseas BU opportunities require ≥1 forecast row before submit.',
    'components.salesforecastsubgrid.82c56534': 'Please selectProduct category',
    'components.salesforecastsubgrid.8364c59e': 'New Sales Forecast',
    'components.salesforecastsubgrid.83f79f54': 'Total',
    'components.salesforecastsubgrid.84ed6d3a': 'items',
    'components.salesforecastsubgrid.8558bfac': 'Select category',
    'components.salesforecastsubgrid.87e90293': 'Notes',
    'components.salesforecastsubgrid.col_status': 'Status',
    'components.salesforecastsubgrid.col_probability': 'Probability',
    'components.salesforecastsubgrid.col_order_timing': 'Order Timing',
    'components.salesforecastsubgrid.col_product_comments': 'Product Comments',
    'components.salesforecastsubgrid.status_ongoing': 'Ongoing',
    'components.salesforecastsubgrid.status_closed_po': 'Closed - Receive PO',
    'components.salesforecastsubgrid.status_closed_lost': 'Closed as lost',
    'components.salesforecastsubgrid.status_deleted': 'Deleted due to input error',
    'components.salesforecastsubgrid.placeholder_status': 'Select status',
    'components.salesforecastsubgrid.placeholder_probability': 'Select probability',
    'components.salesforecastsubgrid.placeholder_order_timing': 'Select order timing',
    'components.salesforecastsubgrid.placeholder_band_select_sub_first': 'Select subclass first',
    'components.salesforecastsubgrid.placeholder_band_no_bands': 'No bands for this subclass',
    'components.salesforecastsubgrid.96ae7c7a': 'Save failed: {{v0}}',
    'components.salesforecastsubgrid.9e66f163': 'Estimated quantity',
    'components.salesforecastsubgrid.ac8daf5c': 'Please selectSubcategory',
    'components.salesforecastsubgrid.c541642c': 'Product category',
    'components.salesforecastsubgrid.c8e9d2ac': 'Save',
    'components.salesforecastsubgrid.cc525d7a': 'Unknown error',
    'components.salesforecastsubgrid.d4aa77f7': 'Line total',
    'components.salesforecastsubgrid.d8c46128': 'Cancel',
    'components.salesforecastsubgrid.da9fde38': 'Confirm delete?',
    'components.salesforecastsubgrid.f09bf02f': 'Edit',
    'components.salesforecastsubgrid.f2614234': 'Delete',
    'components.salesforecastsubgrid.fbebea52': 'Enter quantity',
    'components.salesforecastsubgrid.totalRevenue': 'Total Revenue',
    'components.ui.emptystate.aee82bb7': 'No data',
    'dynamic.deeplinkRedirecting': 'Redirecting to {{entity}}{{suffix}}...',
    'dynamic.deeplinkUnknownEntity': 'Unknown entity type: {{entity}}',
    'pages.account.accountcreatemodal.054d9992': 'e.g. N30',
    'pages.account.accountcreatemodal.05e1cf71': 'Language Code',
    'pages.account.accountcreatemodal.086fcd81': 'Contact Last Name',
    'pages.account.accountcreatemodal.10386d01':
      'Language code used by SAP (for example, ZH, EN, or JA)',
    'pages.account.accountcreatemodal.111b9320': 'Frequency Band',
    'pages.account.accountcreatemodal.138a6eb0': 'Contact Phone',
    'pages.account.accountcreatemodal.142b6d23': 'Contact First Name',
    'pages.account.accountcreatemodal.15c590f1': 'Unknown',
    'pages.account.accountcreatemodal.1651cc2e': 'Price list',
    'pages.account.accountcreatemodal.1679bdfa': 'Parent Account',
    'pages.account.accountcreatemodal.20bcfde8': 'Details',
    'pages.account.accountcreatemodal.22158bc9':
      "This value is saved as the account's Main Phone and appears under Account Information on the detail page.",
    'pages.account.accountcreatemodal.2237066f': 'Employees',
    'pages.account.accountcreatemodal.23213926': 'Website',
    'pages.account.accountcreatemodal.23b31c51': 'Account Contact',
    'pages.account.accountcreatemodal.2b119f7d':
      'Account was created, but contact creation/linking failed: {{v0}} - please create the contact manually on the account detail page',
    'pages.account.accountcreatemodal.2b557047':
      '💡 Keep these SAP fields consistent with the Summary tab. They will be used for SAP synchronization.',
    'pages.account.accountcreatemodal.parent_account_placeholder':
      'Select or search for a parent account',
    'pages.account.accountcreatemodal.sales_office_placeholder':
      'Select or search for a sales office',
    'pages.account.accountcreatemodal.priceListDisabled':
      'The price list is assigned automatically after the account is created',
    'pages.account.accountcreatemodal.ship_to_account_placeholder':
      'Select or search for a ship-to account',
    'pages.account.accountcreatemodal.invoice_account_placeholder':
      'Select or search for an invoice account',
    'pages.account.accountcreatemodal.2b6a0afd': 'Country phone code is required',
    'pages.account.accountcreatemodal.2e22cf77': 'Country code is required',
    'pages.account.accountcreatemodal.2ee91687': '- Save',
    'pages.account.accountcreatemodal.3075b21e':
      'ZSDIF004.ZREFE - Account profile name (Sinosure/)',
    'pages.account.accountcreatemodal.32556db7': 'Signing entity is required',
    'pages.account.accountcreatemodal.34ecc64b': 'Description',
    'pages.account.accountcreatemodal.358d3e18': 'Signing Entity',
    'pages.account.accountcreatemodal.387b6cc6': 'Fax',
    'pages.account.accountcreatemodal.3992ceaa': 'Contact Full Name',
    'pages.account.accountcreatemodal.3b4352e7': 'Basic Information',
    'pages.account.accountcreatemodal.3bf5e346': 'Sales Mode is required',
    'pages.account.accountcreatemodal.3bf86e51': 'Summary',
    'pages.account.accountcreatemodal.3cbd1d86': 'Referrer (%)',
    'pages.account.accountcreatemodal.3e266e5a': 'SAP Extended Fields',
    'pages.account.accountcreatemodal.40e3a821': 'Account profile /',
    'pages.account.accountcreatemodal.447876be': 'Contact phone is required',
    'pages.account.accountcreatemodal.4a31228f': 'Invalid email format',
    'pages.account.accountcreatemodal.4d0a6588': 'Attachments',
    'pages.account.accountcreatemodal.4de28365': '(Synced to SAP automatically)',
    'pages.account.accountcreatemodal.4f5f7ddb': 'Account · Account',
    'pages.account.accountcreatemodal.4faaf2e3':
      'Failed to link {{v0}} opportunities. You can link them manually on the detail page.',
    'pages.account.accountcreatemodal.4fd8bde8': 'Currency',
    'pages.account.accountcreatemodal.50ef489f': 'Customer category is required',
    'pages.account.accountcreatemodal.5133c121': 'Office',
    'pages.account.accountcreatemodal.5141059d': 'Accountcreatemodal',
    'pages.account.accountcreatemodal.535e79bf': 'Create and Open',
    'pages.account.accountcreatemodal.546dad2a': 'Remove',
    'pages.account.accountcreatemodal.5a58be55': 'Account department is required',
    'pages.account.accountcreatemodal.5c9d7e4a': 'Referrer',
    'pages.account.accountcreatemodal.631fe0f1': 'Company Profile',
    'pages.account.accountcreatemodal.63d21408': 'Customer GL Group',
    'pages.account.accountcreatemodal.63f4f0a9': 'Parent company account',
    'pages.account.accountcreatemodal.64702bd8': 'Create failed: {{v0}}',
    'pages.account.accountcreatemodal.66caf8ec': 'Contact Job Title',
    'pages.account.accountcreatemodal.ownership_public': 'Public',
    'pages.account.accountcreatemodal.ownership_private': 'Private Company',
    'pages.account.accountcreatemodal.ownership_subsidiary': 'Subsidiary',
    'pages.account.accountcreatemodal.ownership_other': 'Other',
    'pages.account.accountcreatemodal.68292149':
      'Attachments: {{v0}} succeeded / {{v1}} failed. Failed files can be uploaded again on the detail page.',
    'pages.account.accountcreatemodal.7462bde8': 'Invoice account',
    'pages.account.accountcreatemodal.74fdb74d': 'Street 2',
    'pages.account.accountcreatemodal.7f6de2eb': 'Created account {{v0}}',
    'pages.account.accountcreatemodal.7f9e6f50': 'City/County',
    'pages.account.accountcreatemodal.817891b1': 'Click or drag files to upload',
    'pages.account.accountcreatemodal.8422aa40': 'Country/Region is required',
    'pages.account.accountcreatemodal.857756e1': 'Country Calling Code',
    'pages.account.accountcreatemodal.860c38ca': 'Street 1',
    'pages.account.accountcreatemodal.8872c163': 'Search opportunity name...',
    'pages.account.accountcreatemodal.8aeec920': 'Account Department',
    'pages.account.accountcreatemodal.923ebef1': 'Ownership',
    'pages.account.accountcreatemodal.92a9bb06': 'Contact first name is required',
    'pages.account.accountcreatemodal.947964f3': 'Please check required fields',
    'pages.account.accountcreatemodal.9551c4db':
      'Pending upload - submitted automatically when the account is created',
    'pages.account.accountcreatemodal.9c8363c7': 'Country/Region',
    'pages.account.accountcreatemodal.a0760676': 'Account Address',
    'pages.account.accountcreatemodal.a3f55288': 'Industry',
    'pages.account.accountcreatemodal.a6650858':
      'Generated automatically from Contact Last Name and Contact First Name',
    'pages.account.accountcreatemodal.a98218f3': 'SAP Required Fields',
    'pages.account.accountcreatemodal.ab6b8692': 'State/Province',
    'pages.account.accountcreatemodal.ac7a1e0d': 'ZSDIF004.ZREBL - Referrer 0-100',
    'pages.account.accountcreatemodal.acda9c03': 'Account Short Name',
    'pages.account.accountcreatemodal.ae5150c8': 'Company email',
    'pages.account.accountcreatemodal.af8bb269': 'Cancel',
    'pages.account.accountcreatemodal.b0897c60': 'e.g. B41, B42',
    'pages.account.accountcreatemodal.b0c74a83': 'Ship-to account',
    'pages.account.accountcreatemodal.b1438c2a': 'Customer Category',
    'pages.account.accountcreatemodal.b2ec5d7c':
      'Optional: Select opportunities for this account. After creation, their Account field will be linked automatically. You can also link them later from the Opportunities tab on the account detail page.',
    'pages.account.accountcreatemodal.b66620ae': 'Created contact {{v0}}',
    'pages.account.accountcreatemodal.b792506e': 'Uploaded {{v0}} attachments',
    'pages.account.accountcreatemodal.bef84603': 'Primary Contact (New)',
    'pages.account.accountcreatemodal.primary_contact': 'Primary Contact',
    'pages.account.accountcreatemodal.bf5c2e00': 'Account Number',
    'pages.account.accountcreatemodal.c2ad3e70': 'Linked {{v0}} opportunities',
    'pages.account.accountcreatemodal.c2ec3557': '{{v0}} exceeds the 10 MB limit',
    'pages.account.accountcreatemodal.c33de2cc': 'Unknown error',
    'pages.account.accountcreatemodal.duplicate_account': 'Account Already Exists',
    'pages.account.accountcreatemodal.duplicate_record': 'Record Already Exists',
    'pages.account.accountcreatemodal.c3893a9a': 'Account Name',
    'pages.account.accountcreatemodal.c38e673e': 'Notes',
    'pages.account.accountcreatemodal.c41d34fa':
      'Link opportunities: {{v0}} succeeded / {{v1}} failed',
    'pages.account.accountcreatemodal.c4873189': 'Contact Email',
    'pages.account.accountcreatemodal.c4c823e5': 'Tax Type',
    'pages.account.accountcreatemodal.c552da02': 'Payment Terms',
    'pages.account.accountcreatemodal.c5d2aea2': ': CFO /',
    'pages.account.accountcreatemodal.c5f4cca3': 'Account name is required',
    'pages.account.accountcreatemodal.c841e7ad': 'Related Opportunities',
    'pages.account.accountcreatemodal.ca1f4565': 'Bank account',
    'pages.account.accountcreatemodal.cb2f69c7': 'Account assignment group is required',
    'pages.account.accountcreatemodal.cbcfd022': 'Business Information',
    'pages.account.accountcreatemodal.ccbba4af': 'Country Code',
    'pages.account.accountcreatemodal.country.iso2_label': 'ISO Code:',
    'pages.account.accountcreatemodal.country.continent_label': 'Continent:',
    'pages.account.accountcreatemodal.country.phonecode_hint':
      'Auto-linked from selected country/region — no separate input needed',
    'pages.account.accountcreatemodal.country.phonecode_placeholder':
      'Select a country/region first',
    'pages.account.accountcreatemodal.country.phonecode_no_dict':
      'Auto-linked (no dictionary match)',
    'pages.account.accountcreatemodal.freqband_required':
      'Frequency band is required (multi-select)',
    'pages.account.accountcreatemodal.freqband_placeholder': 'Select frequency band(s)',
    'pages.account.accountcreatemodal.freqband_tooltip':
      'Pick from product frequency band dictionary; multi-band customers can check several',
    'pages.account.accountcreatemodal.language_required': 'Language Code is required',
    'pages.account.accountcreatemodal.currency_required': 'Currency is required',
    'pages.account.accountcreatemodal.stateprovince_required':
      'Address 1: State/Province is required',
    'pages.account.accountcreatemodal.main_phone_label': 'Main Phone',
    'pages.account.accountcreatemodal.main_phone_required': 'Main Phone is required',
    'pages.account.accountcreatemodal.taxcode_label': 'Tax Code',
    'pages.account.accountcreatemodal.taxcode_tooltip':
      'Optional: tax registration number / unified social credit code',
    'pages.account.accountcreatemodal.industry_required': 'Industry is required',
    'pages.account.accountcreatemodal.country_placeholder': 'Select Country/Region',
    'pages.account.accountcreatemodal.country.address_autosync_hint':
      'Auto-synced from country/region above — no need to re-enter',
    'pages.account.accountcreatemodal.d59aec34':
      'The account is created together with a new primary contact. The contact is linked automatically and can be managed later from the Contacts module.',
    'pages.account.accountcreatemodal.d5c0b3f2': 'Opportunity',
    'pages.account.accountcreatemodal.d6dffc81': 'Postal Code',
    'pages.account.accountcreatemodal.d75a9fe7':
      'Files are stored temporarily and uploaded automatically after the account is created. Maximum file size: 10 MB.',
    'pages.account.accountcreatemodal.d84c9441': 'Credit limit',
    'pages.account.accountcreatemodal.deab07f9': 'New account',
    'pages.account.accountcreatemodal.e109fa01': 'Contact last name is required',
    'pages.account.accountcreatemodal.e9c1f273':
      'Attachment upload failed ({{v0}}). You can upload again from the Attachments tab on the detail page.',
    'pages.account.accountcreatemodal.efe9dc1d': 'e.g. 50',
    'pages.account.accountcreatemodal.f637e2d3': 'e.g. Bai Wei',
    'pages.account.accountcreatemodal.fd3c98c7': 'Sales Mode',
    'pages.account.accountdetailpage.01459302': 'SAP sync failed',
    'pages.account.accountdetailpage.04724602': 'Details',
    'pages.account.accountdetailpage.08824d4e': 'Modified On',
    'pages.account.accountdetailpage.0b0d2aac': 'Contact Phone',
    'pages.account.accountdetailpage.0ebd10e6': 'Won',
    'pages.account.accountdetailpage.10c29a20': 'In progress',
    'pages.account.accountdetailpage.12b68dc8': 'Submission cancelled',
    'pages.account.accountdetailpage.1c772ba2': 'Unknown',
    'pages.account.accountdetailpage.2704cbd9': 'Not submitted',
    'pages.account.accountdetailpage.4e866b85': 'Probability',
    'pages.account.accountdetailpage.5a1a0148': 'Cancel submission failed',
    'pages.account.accountdetailpage.62f818ec': 'Opportunity',
    'pages.account.accountdetailpage.7faeac7a': 'Lost',
    'pages.account.accountdetailpage.7ff3c5f2':
      'This account is under review. Submitted fields are locked; cancel the submission to continue editing.',
    'pages.account.accountdetailpage.80253b36': 'SAP Account Fields',
    'pages.account.accountdetailpage.sap_required_customer_fields': 'SAP Required Customer Fields',
    'pages.account.accountdetailpage.country_derived':
      'Phone code and language auto-linked from country',
    'pages.account.accountdetailpage.delete_btn': 'Delete',
    'pages.account.accountdetailpage.delete_confirm_title': 'Confirm Delete',
    'pages.account.accountdetailpage.delete_confirm_desc':
      'This action cannot be undone. Are you sure you want to delete this account?',
    'pages.account.accountdetailpage.delete_confirm_ok': 'Delete',
    'pages.account.accountdetailpage.delete_confirm_cancel': 'Cancel',
    'pages.account.accountdetailpage.delete_success': 'Account deleted',
    'pages.account.accountdetailpage.delete_failed': 'Delete failed',
    'pages.account.accountdetailpage.8595449b': '(First Name)',
    'pages.account.accountdetailpage.88217e52': 'None',
    'pages.account.accountdetailpage.90745255': 'Opportunity name',
    'pages.account.accountdetailpage.94edc43a': 'Number',
    'pages.account.accountdetailpage.999df343': 'Estimated amount',
    'pages.account.accountdetailpage.a21900cb': 'Queued SAP sync (job={{v0}})',
    'pages.account.accountdetailpage.b86627df': 'Approved',
    'pages.account.accountdetailpage.bbff8d52': 'Create opportunity',
    'pages.account.accountdetailpage.bf01382e': 'Submit failed',
    'pages.account.accountdetailpage.c21288c4': 'Submitted',
    'pages.account.accountdetailpage.c501a462': 'Contact',
    'pages.account.accountdetailpage.c6b59259': 'Under review',
    'pages.account.accountdetailpage.caab5a09': 'No opportunities linked to this account',
    'pages.account.accountdetailpage.e9069ebc': 'SAP Language Code',
    'pages.account.accountdetailpage.ea7dfa47': 'Owner:',
    'pages.account.accountdetailpage.f35d5a7c': 'Status',
    'pages.account.accountlistpage.17b0a102': 'Company',
    'pages.account.accountlistpage.b3b56e47': 'Baicells Shenzhen Technology Co., Ltd.',
    'pages.account.accountlistpage.cb128e3a': 'Baicells Technologies Co. Ltd',
    'pages.account.accountlistpage.d8399a86': 'Nanjing Bailian Information Technology Co., Ltd.',
    'pages.account.accountlistpage.dacd50db': 'Jiangxi Baicai Smart Technology Co., Ltd.',
    'pages.account.accountlistpage.e02f33ca': 'Jiangsu Bangdian Communication Technology Co., Ltd.',
    'pages.account.accountlistpage.fdfcb8b3': 'Jiangxi Baicells Technology Co., Ltd.',
    'pages.admin.adminuserspage.01112768': 'Actions',
    'pages.admin.adminuserspage.06b6ea06': 'User',
    'pages.admin.adminuserspage.0ea0db04': 'Total',
    'pages.admin.adminuserspage.12a61341': 'Disable',
    'pages.admin.adminuserspage.184aa36f': 'Role management - {{v0}}',
    'pages.admin.adminuserspage.19687226': 'Refresh',
    'pages.admin.adminuserspage.1f9ac7d0': 'Total {{v0}} users',
    'pages.admin.adminuserspage.2230b375': 'Bulk assignRole (',
    'pages.admin.adminuserspage.246e580d': '(First Name)',
    'pages.admin.adminuserspage.24f969ee': 'Revoke failed',
    'pages.admin.adminuserspage.255237ca': 'No roles',
    'pages.admin.adminuserspage.2e477ecb': 'Search Name / Domain / Email',
    'pages.admin.adminuserspage.3ab20da5': '{{v0}} completed',
    'pages.admin.adminuserspage.3fd3da56': 'Search roles',
    'pages.admin.adminuserspage.5e543ce4': 'Enabled',
    'pages.admin.adminuserspage.7aef16ae': 'Status',
    'pages.admin.adminuserspage.8916ca8a': 'Assign failed',
    'pages.admin.adminuserspage.8c99ec9f': '{{v0}} will be {{v1}}',
    'pages.admin.adminuserspage.90a80c76': 'Disable, Unable toSign in',
    'pages.admin.adminuserspage.9e0f6563': 'Revoked',
    'pages.admin.adminuserspage.a85b3556': 'Role',
    'pages.admin.adminuserspage.bc86ba7c': 'Assign',
    'pages.admin.adminuserspage.cc6bb5c7': 'Operation failed',
    'pages.admin.adminuserspage.da4d04c1': 'Enabled, Sign in',
    'pages.admin.adminuserspage.dbf9e4de': 'UserNo roles',
    'pages.admin.adminuserspage.e7af6578': 'Assigned',
    'pages.admin.adminuserspage.f6651e17': 'New User',
    'pages.admin.adminuserspage.delete.btn': 'Delete',
    'pages.admin.adminuserspage.delete.title': 'Delete user "{{v0}}"?',
    'pages.admin.adminuserspage.delete.body':
      'This permanently deletes the user, role bindings and credentials. Irreversible.',
    'pages.admin.adminuserspage.delete.warn':
      'If the user owns business records (account/lead/opportunity/...), delete will be rejected — transfer them first, or use "Disable" instead.',
    'pages.admin.adminuserspage.delete.ok': 'Delete',
    'pages.admin.adminuserspage.delete.success': 'User deleted',
    'pages.admin.adminuserspage.delete.fail': 'Delete failed',
    'pages.admin.adminuserspage.reset': 'Reset',
    'pages.admin.adminuserspage.resetPasswordDescription':
      'Resetting clears failed sign-in count and lock status; the user should sign in with the new password and change it immediately.',
    'pages.admin.adminuserspage.resetPasswordFailed': 'Reset failed',
    'pages.admin.adminuserspage.resetPasswordPlaceholder': 'Leave blank to use default Crest@2026',
    'pages.admin.adminuserspage.resetPasswordSuccess': 'Reset password for {{v0}} to: {{v1}}',
    'pages.admin.adminuserspage.resetPasswordTitle': 'Reset Password - {{v0}}',
    'pages.admin.agentconfigpage.37b01c16': 'Other',
    'pages.admin.agentconfigpage.8f266297': 'Operations Center',
    'pages.admin.agentconfigpage.f07ef5d0': 'System Settings',
    'pages.admin.agentconfigpage.ffa74ffc': 'Sales Center',
    'pages.admin.appcenterpage.0a1b4864': 'Phase 4 (9-12 month)',
    'pages.admin.appcenterpage.0da6eb4c': 'Phase 5 (12+ month)',
    'pages.admin.appcenterpage.1c44ff4e': 'Data',
    'pages.admin.appcenterpage.277db141': 'Planned',
    'pages.admin.appcenterpage.4c4c3d19': 'Live',
    'pages.admin.appcenterpage.567ff3c1': 'Internal',
    'pages.admin.appcenterpage.5a761676': 'Office',
    'pages.admin.appcenterpage.5a82ca6b': 'Governance',
    'pages.admin.appcenterpage.6af9d645': 'Mobile',
    'pages.admin.appcenterpage.70c5be29': 'Core',
    'pages.admin.appcenterpage.865ddfe8': 'Phase 3 (6-9 month)',
    'pages.admin.appcenterpage.9b3cfe76': 'Productivity',
    'pages.admin.appcenterpage.a0409176': 'Beta',
    'pages.admin.appcenterpage.b4747a9c': 'Collaboration',
    'pages.admin.appcenterpage.cb64714b': 'Operations',
    'pages.admin.appcenterpage.e26f3471': 'Phase 2 (3-6 month)',
    'pages.admin.appcenterpage.ff778dc6': 'Integration',
    'pages.admin.auditlogpage.19528a7f': 'By Event (Last 7 Days)',
    'pages.admin.auditlogpage.3df01b3f': 'Event Type (e.g. crm.account.updated)',
    'pages.admin.auditlogpage.3f69daf0': 'Entity',
    'pages.admin.auditlogpage.41fa603b': 'Total {{v0}} items',
    'pages.admin.auditlogpage.4f9249cb': 'Entity ID (UUID)',
    'pages.admin.auditlogpage.60c79690': 'Changed fields',
    'pages.admin.auditlogpage.61e64833': 'By Entity (Last 7 Days)',
    'pages.admin.auditlogpage.7b61a3fd': 'Result',
    'pages.admin.auditlogpage.85a232f3': 'No data',
    'pages.admin.auditlogpage.9221d699': 'Refresh',
    'pages.admin.auditlogpage.9438cf9a': 'Time',
    'pages.admin.auditlogpage.bcc23db9': 'Event',
    'pages.admin.auditlogpage.c2706623': 'Operator',
    'pages.admin.auditlogpage.system_actor': 'System',
    'pages.admin.auditlogpage.e082e176': 'Actions',
    'pages.admin.auditlogpage.f2a9b278': 'Auditlogpage',
    'pages.admin.auditlogpage.f7de5d40': 'items',
    'pages.admin.auditlogpage.actor': 'Search operator',
    'pages.admin.auditlogpage.after': 'After evidence',
    'pages.admin.auditlogpage.before': 'Before evidence',
    'pages.admin.auditlogpage.detail': 'View',
    'pages.admin.auditlogpage.detail_failed': 'Unable to load audit details',
    'pages.admin.auditlogpage.detail_failed_help':
      'Close the drawer and retry. If the problem persists, contact an administrator with the request ID.',
    'pages.admin.auditlogpage.detail_title': 'Audit evidence details',
    'pages.admin.auditlogpage.entity': 'Search entity',
    'pages.admin.auditlogpage.export': 'Export current results',
    'pages.admin.auditlogpage.export_failed':
      'Export failed. Check the filters or try again later.',
    'pages.admin.auditlogpage.load_failed': 'Unable to load audit logs',
    'pages.admin.auditlogpage.load_failed_help':
      'The audit service is temporarily unavailable. Retry, or ask an administrator to check the API and database.',
    'pages.admin.auditlogpage.request': 'Request',
    'pages.admin.auditlogpage.request_id': 'Request ID',
    'pages.admin.auditlogpage.correlation_id': 'Correlation ID',
    'pages.admin.auditlogpage.retry': 'Reload',
    'pages.admin.auditlogpage.source': 'Source',
    'pages.admin.auditlogpage.target': 'Target',
    'pages.admin.bulkassignrolesmodal.03658706': 'Bulk Role Assignment',
    'pages.admin.bulkassignrolesmodal.0973e5a1': 'replace (= ClearRole)',
    'pages.admin.bulkassignrolesmodal.0b01769f': '1 Role',
    'pages.admin.bulkassignrolesmodal.0dd11ea2': 'RoleUser (Skipped)',
    'pages.admin.bulkassignrolesmodal.18cee0d0': 'Please select',
    'pages.admin.bulkassignrolesmodal.30bc4611': 'Affected:',
    'pages.admin.bulkassignrolesmodal.396c4e8e': 'Please first UserListMediumUser',
    'pages.admin.bulkassignrolesmodal.3985ead8': 'Link',
    'pages.admin.bulkassignrolesmodal.429f2829': 'Target users',
    'pages.admin.bulkassignrolesmodal.43e5e8b5': 'Select 1 Role',
    'pages.admin.bulkassignrolesmodal.53864891': ' ',
    'pages.admin.bulkassignrolesmodal.559be071': 'Bulk operation failed: {{v0}}',
    'pages.admin.bulkassignrolesmodal.5607a12c': 'Run',
    'pages.admin.bulkassignrolesmodal.5f223241': 'Actions',
    'pages.admin.bulkassignrolesmodal.63f5a997': '⚠️ RoleUserAllRole (RoleAll)',
    'pages.admin.bulkassignrolesmodal.64a36cdb': 'RoleListFailed',
    'pages.admin.bulkassignrolesmodal.66b1390e': 'UserRemoveRole',
    'pages.admin.bulkassignrolesmodal.6c510d70': '{{v0}} users selected',
    'pages.admin.bulkassignrolesmodal.8e2d53b3':
      '{{v0}}Complete - Affected {{v1}} items, Skipped {{v2}} items',
    'pages.admin.bulkassignrolesmodal.97e3fd32': '⚠️ ClearUserAllRole, AssignRole - , Confirm',
    'pages.admin.bulkassignrolesmodal.999246c3': ' times',
    'pages.admin.bulkassignrolesmodal.9c57daed': 'Bulkassignrolesmodal',
    'pages.admin.bulkassignrolesmodal.9ef082a0': 'Unknown error',
    'pages.admin.bulkassignrolesmodal.a412165c': 'User ×',
    'pages.admin.bulkassignrolesmodal.ceef8c45': 'Role =',
    'pages.admin.bulkassignrolesmodal.d5362acd': 'Cancel',
    'pages.admin.bulkassignrolesmodal.fdd82f9a': 'Revoke',
    'pages.admin.butreepage.0358fd8b': 'Save',
    'pages.admin.butreepage.0b8cdb69': '(Optional) : Overseas',
    'pages.admin.butreepage.0e87cb03': '· Medium:',
    'pages.admin.butreepage.27ccad61': 'Delete failed: {{v0}}',
    'pages.admin.butreepage.2e46e1d7': 'EditBusiness unit',
    'pages.admin.butreepage.30ff1bc3': 'Delete organization?',
    'pages.admin.butreepage.37a55e33': 'Parent department: {{v0}}',
    'pages.admin.butreepage.498dc9fe': 'Cancel',
    'pages.admin.butreepage.4ca71995': 'DepartmentFirst Name / DivisionSearch',
    'pages.admin.butreepage.57de3c65': 'ActionsRevoke',
    'pages.admin.butreepage.57e40395': 'Quick CreateBusiness unit',
    'pages.admin.butreepage.5d44cb3f':
      'Cannot delete - {{v0}} users and {{v1}} child organizations exist',
    'pages.admin.butreepage.62383842': ': Overseas',
    'pages.admin.butreepage.63747a2a': 'User',
    'pages.admin.butreepage.642ff02a': 'Selected:',
    'pages.admin.butreepage.6728fc7e': 'Saved',
    'pages.admin.butreepage.693aaa67': 'Disabled',
    'pages.admin.butreepage.6f5aaaf9': 'Add child organization',
    'pages.admin.butreepage.782038e5': 'DepartmentFirst Name',
    'pages.admin.butreepage.83ff334a': 'NoneBusiness unitData',
    'pages.admin.butreepage.85f815ae': 'Department',
    'pages.admin.butreepage.88ea321c': 'Delete',
    'pages.admin.butreepage.9898034d': '(Optional) DepartmentEmail',
    'pages.admin.butreepage.9e98e306': '(Optional) Financesystem',
    'pages.admin.butreepage.a23f572c': 'Edit',
    'pages.admin.butreepage.a28c2e74': 'Unknown error',
    'pages.admin.butreepage.aae952bb': 'Organization created',
    'pages.admin.butreepage.c65bc733': 'Deselect',
    'pages.admin.butreepage.cc2215e9': 'Create',
    'pages.admin.butreepage.d2376308': 'Deleted',
    'pages.admin.butreepage.d2e8ff50': 'Organization details',
    'pages.admin.butreepage.dd64fab5': 'Collapse all',
    'pages.admin.butreepage.e57094c9': 'Save failed: {{v0}}',
    'pages.admin.butreepage.e774bae3': 'Department ·',
    'pages.admin.butreepage.ebc76f6b': 'Refresh',
    'pages.admin.butreepage.f204a62b': 'Expand all',
    'pages.admin.butreepage.f82dfdfb': 'Create root organization',
    'pages.admin.butreepage.fc045536': 'Create as a root organization',
    'pages.admin.butreepage.purge_disabled': 'Clean disabled organizations',
    'pages.admin.butreepage.purge_disabled_confirm_desc':
      'Deletes disabled organizations that have no enabled children or enabled user references, and clears old disabled-user assignments. This cannot be undone.',
    'pages.admin.butreepage.purge_disabled_confirm_ok': 'Clean',
    'pages.admin.butreepage.purge_disabled_confirm_title':
      'Clean all safely removable disabled organizations?',
    'pages.admin.butreepage.purge_disabled_failed': 'Cleanup failed: {{v0}}',
    'pages.admin.butreepage.purge_disabled_none': 'No disabled organizations can be deleted',
    'pages.admin.butreepage.purge_disabled_partial':
      'Deleted {{v0}} disabled organizations; skipped {{v1}} still referenced by business data',
    'pages.admin.butreepage.purge_disabled_skipped':
      '{{v0}} disabled organizations are still referenced by business data and were skipped',
    'pages.admin.butreepage.purge_disabled_success': 'Deleted {{v0}} disabled organizations',
    'pages.admin.createrolemodal.205229d8':
      '⚠️ Use with caution - row-level filtering, Account/OpportunityData',
    'pages.admin.createrolemodal.2408649d': 'ViewAllData',
    'pages.admin.createrolemodal.27646332': 'RoleDescription',
    'pages.admin.createrolemodal.2be34631': 'Please selectType',
    'pages.admin.createrolemodal.4b6a039f': 'GeneralPrivileges',
    'pages.admin.createrolemodal.5c7d2e34': 'Created role {{v0}}',
    'pages.admin.createrolemodal.6d90294d': 'DefaultVisible',
    'pages.admin.createrolemodal.6df541db': 'Cancel',
    'pages.admin.createrolemodal.7275e549': 'Role name',
    'pages.admin.createrolemodal.75b719b2': 'Unknown error',
    'pages.admin.createrolemodal.7c94d3ed':
      'system, RecommendedEnglish/ (: SalesManager, OverseasReviewer)',
    'pages.admin.createrolemodal.7cfa7655': 'e.g. SalesManager',
    'pages.admin.createrolemodal.aa7700a6': 'UI MediumChinese Name ( name)',
    'pages.admin.createrolemodal.becbf2a8': 'Createrolemodal',
    'pages.admin.createrolemodal.bf56ba39':
      'after creationRoleDetailsconfigurationMenu permissions App Access',
    'pages.admin.createrolemodal.c7e088de': 'Create',
    'pages.admin.createrolemodal.cb382e1c': 'Create failed: {{v0}}',
    'pages.admin.createrolemodal.d491493d': 'Createrolemodal',
    'pages.admin.createrolemodal.ee6e430f': 'CloseNewManualRole (denylist )',
    'pages.admin.createrolemodal.fdf94d37': 'New Role',
    'pages.admin.createusermodal.003cac72': 'Recommended: Crest@2026 (DefaultdemoPassword)',
    'pages.admin.createusermodal.02203f53': 'Create',
    'pages.admin.createusermodal.0977723f': 'Create failed: {{v0}}',
    'pages.admin.createusermodal.0d9a67f3': 'Createusermodal',
    'pages.admin.createusermodal.1029a3bf': '(Optional) Email',
    'pages.admin.createusermodal.21febb7a': 'Unknown error',
    'pages.admin.createusermodal.2385b10d': 'with',
    'pages.admin.createusermodal.312aa610': 'Cancel',
    'pages.admin.createusermodal.34778a61': 'Enter name',
    'pages.admin.createusermodal.55bb6f98':
      'UserNonePassword, ApprovedOther; RecommendedUser timesSign in',
    'pages.admin.createusermodal.74fe3875': 'Failed (BU Role)',
    'pages.admin.createusermodal.8b8211a3': 'e.g. zhangsan@baicells.com',
    'pages.admin.createusermodal.9155ed1f': 'New User',
    'pages.admin.createusermodal.923cbde8': '(Optional) 8 digits',
    'pages.admin.createusermodal.960ff639': '(Optional) Select 1 Role',
    'pages.admin.createusermodal.af259b5f': 'Role; ApprovedRoleAdmin',
    'pages.admin.createusermodal.b5d272ae': '(Optional) SelectDepartment',
    'pages.admin.createusermodal.cc45e1bd': 'Created user {{v0}}',
    'pages.admin.createusermodal.e0789d1e': 'Domain Name',
    'pages.admin.createusermodal.e48adac7': 'Required · OptionalPasswordRole',
    'pages.admin.createusermodal.e4f8ac79': 'UserSign in - email (zhangsan@baicells.com)',
    'pages.admin.notifyhistorypage.06d9d163': 'AccountReviewSubmit',
    'pages.admin.notifyhistorypage.08b75843':
      'Business functionNotification. iws_mailconfig configurationRecipientsSendtestemail, Recipient Send.',
    'pages.admin.notifyhistorypage.0ca96d3d': 'OpportunityApproval passed',
    'pages.admin.notifyhistorypage.21fc280a': 'Refresh',
    'pages.admin.notifyhistorypage.3158a551': 'items',
    'pages.admin.notifyhistorypage.47cf6374': 'Recipients',
    'pages.admin.notifyhistorypage.4adf2228': 'Recipients (Optional):',
    'pages.admin.notifyhistorypage.512ab8b8': 'OverseasLeadCreate',
    'pages.admin.notifyhistorypage.569c721d': 'Failed',
    'pages.admin.notifyhistorypage.5f429edf': 'Sinosure ApproveApproved',
    'pages.admin.notifyhistorypage.88da907b': 'No configuration',
    'pages.admin.notifyhistorypage.8a133be4': 'All',
    'pages.admin.notifyhistorypage.90c09034': 'Business function:',
    'pages.admin.notifyhistorypage.9aeab22f':
      'Business function + iws_mailconfig configurationRecipientsSendNotification history(M19 PG). Business function; 200 itemsSearchAutomatic DB.',
    'pages.admin.notifyhistorypage.smtp_disabled_title':
      'No available SMTP config — notifications logged only',
    'pages.admin.notifyhistorypage.smtp_disabled_desc':
      'No enabled and verified mail configuration was found. The notification history below is not actually emailed and is only persisted to PG. Save and verify an SMTP account in Mail Configuration to enable real delivery.',
    'pages.admin.notifyhistorypage.smtp_unhealthy_title': 'SMTP enabled but health check failed',
    'pages.admin.notifyhistorypage.smtp_unhealthy_desc':
      'SMTP connection or authentication failed. Outgoing emails will most likely not arrive. Check SMTP config + server network.',
    'pages.admin.notifyhistorypage.smtp_ok_title':
      'SMTP enabled and healthy — notifications are emailed in real time',
    'pages.admin.notifyhistorypage.a6b97298': 'Cancel',
    'pages.admin.notifyhistorypage.ad9c0394': 'LeadCreate',
    'pages.admin.notifyhistorypage.bce9502b': 'Total {{v0}} items',
    'pages.admin.notifyhistorypage.c34c6ae4': 'Business function',
    'pages.admin.notifyhistorypage.c9da7c7c': 'Test SendFailed',
    'pages.admin.notifyhistorypage.d43f2815': 'Succeeded',
    'pages.admin.notifyhistorypage.f00b33af': 'Subject',
    'pages.admin.notifyhistorypage.f8304a0f': 'Business function:',
    'pages.admin.notifyhistorypage.f8a13e81': 'AccountApprove',
    'pages.admin.notifyhistorypage.fcc756e6': 'Opportunity won',
    'pages.admin.roledetaildrawer.015b4e1a': 'DefaultVisible',
    'pages.admin.roledetaildrawer.03b44829':
      'Saved - {{v0}} added, {{v1}} removed, {{v2}} apps total',
    'pages.admin.roledetaildrawer.0a5f8e01': 'Save failed: {{v0}}',
    'pages.admin.roledetaildrawer.24676144': 'Loading...',
    'pages.admin.roledetaildrawer.3f0f6ece': 'None sitemap',
    'pages.admin.roledetaildrawer.3f6426b6': 'system - None',
    'pages.admin.roledetaildrawer.44670a40': 'Role type',
    'pages.admin.roledetaildrawer.5223e794': 'Unknown error',
    'pages.admin.roledetaildrawer.5a9914a5': 'digits( 100)',
    'pages.admin.roledetaildrawer.634fb4d7':
      'Role 4 Depth, Account/OpportunityData; AffectedQuick Create/EditPrivileges',
    'pages.admin.roledetaildrawer.7c1a4c3c': 'Automatic; SettingsRoleUser',
    'pages.admin.roledetaildrawer.7c798529': 'RoleNone',
    'pages.admin.roledetaildrawer.7e86b2f1':
      'Saved - {{v0}} added, {{v1}} removed, {{v2}} visible items total',
    'pages.admin.roledetaildrawer.86a879fb': 'General',
    'pages.admin.roledetaildrawer.89e51c36': 'RoleVisible',
    'pages.admin.roledetaildrawer.8b062df8': "App Yes; App 'menu permission'",
    'pages.admin.roledetaildrawer.8c00d4e1': 'Role name',
    'pages.admin.roledetaildrawer.8d9f844d': '🔒 Builtin',
    'pages.admin.roledetaildrawer.8eb2e7af': 'GeneralPrivileges',
    'pages.admin.roledetaildrawer.9f71a7e5': 'CloseNewManualRole',
    'pages.admin.roledetaildrawer.a436e5ce': 'Description',
    'pages.admin.roledetaildrawer.a43c7b9b': 'Role App',
    'pages.admin.roledetaildrawer.ae15ecb9': 'Menu permissions',
    'pages.admin.roledetaildrawer.b59b85ec': 'ViewAllData (row-level filtering)',
    'pages.admin.roledetaildrawer.ccdeb106': 'Roledetaildrawer',
    'pages.admin.roledetaildrawer.cf4015a0': 'Role name',
    'pages.admin.roledetaildrawer.d98101bb': 'Use with caution',
    'pages.admin.roledetaildrawer.dca3e62f': 'Roledetaildrawer',
    'pages.admin.roledetaildrawer.e2c12cee':
      'BuiltinRole - systemCreate, UpdateDescriptionDelete/First Name',
    'pages.admin.roledetaildrawer.ea54592a': ' members',
    'pages.admin.roledetaildrawer.f4dfefe7': 'Saved',
    'pages.admin.roledetaildrawer.fa85b8aa': 'RoleDescription (BusinessVisible)',
    'pages.admin.roledetaildrawer.fc0f31d5': 'Failed to load role details',
    'pages.admin.roledetaildrawer.member_add': 'Add member',
    'pages.admin.roledetaildrawer.member_added': 'Member added',
    'pages.admin.roledetaildrawer.member_cancel': 'Cancel',
    'pages.admin.roledetaildrawer.member_remove': 'Remove',
    'pages.admin.roledetaildrawer.member_remove_confirm': 'Remove this member from the role?',
    'pages.admin.roledetaildrawer.member_removed': 'Member removed',
    'pages.admin.roledetaildrawer.member_save_failed': 'Failed to update member: {{v0}}',
    'pages.admin.roledetaildrawer.member_select_placeholder': 'Select a user to add',
    'pages.admin.roledetaildrawer.menu_count_apps': 'Apps',
    'pages.admin.roledetaildrawer.menu_count_missing': 'Unchecked menus',
    'pages.admin.roledetaildrawer.menu_count_missing_short': 'Unchecked {{v0}}',
    'pages.admin.roledetaildrawer.menu_count_selected': 'Checked menus',
    'pages.admin.roledetaildrawer.menu_count_selected_short': 'Checked {{v0}}',
    'pages.admin.roledetaildrawer.menu_count_title': 'Menu permission counts',
    'pages.admin.roledetaildrawer.menu_count_total': 'All menus',
    'pages.admin.roledetaildrawer.menu_count_total_short': 'Total {{v0}}',
    'pages.admin.settingshubpage.105502cb': 'Sinosure Approvepersonnel',
    'pages.admin.settingshubpage.12cdd3ff': 'LeadSource',
    'pages.admin.settingshubpage.132b450f': '-Frequency Band',
    'pages.admin.settingshubpage.1d5e3b2e': 'Currency',
    'pages.admin.settingshubpage.2164eced': 'Country Code',
    'pages.admin.settingshubpage.311c3b16': 'Language code',
    'pages.admin.settingshubpage.34acc0ad': 'Numberconfiguration',
    'pages.admin.settingshubpage.4669cfc0': 'Business unit / BU',
    'pages.admin.settingshubpage.577506ab': 'Product category',
    'pages.admin.settingshubpage.752ca5fc': 'Product group',
    'pages.admin.settingshubpage.79315b52': 'Shared accounts',
    'pages.admin.settingshubpage.9d369ec6': 'Country Phone Code',
    'pages.admin.settingshubpage.a1e1d6cc': 'POC Review',
    'pages.admin.settingshubpage.a86d79bc': 'Band configuration',
    'pages.admin.settingshubpage.b2bb4f90': 'Recipientsconfiguration',
    'pages.admin.settingshubpage.ca12754f': 'Approval Settings',
    'pages.admin.settingshubpage.d62a1fab': 'Product subclass',
    'pages.admin.settingshubpage.d9ab26b3': 'Part type',
    'pages.admin.settingshubpage.fc383dc0': 'Settingshubpage',
    'pages.admin.settingspages.0156374f': 'Band configuration',
    'pages.admin.settingspages.0622dd1c': 'OverseasLeadCreate',
    'pages.admin.settingspages.0a333a99': 'Currency symbol',
    'pages.admin.settingspages.108eed87': 'Business Units - BU (AffectedPrivileges)',
    'pages.admin.settingspages.10b59e6d': 'Sinosure Approvepersonnel',
    'pages.admin.settingspages.194253e1': 'Opportunity won',
    'pages.admin.settingspages.1b89a64f': 'Country name',
    'pages.admin.settingspages.1f562b10': 'Numberconfiguration',
    'pages.admin.settingspages.20e89d32':
      'Business function (1=lead_created, 2=lead_created_overseas, 3=account_submitted, 4=account_approved, 5=opportunity_won, 6=opp_over_1m_approved, 7=sinosure_approved)',
    'pages.admin.settingspages.2828de48': 'with (MHz)',
    'pages.admin.settingspages.2d47de0f': 'Product group',
    'pages.admin.settingspages.3172a218':
      'UserTimeAccountView/ActionsPrivileges (M32 Sales Technical Support)',
    'pages.admin.settingspages.3d5bd117': 'Product subclass',
    'pages.admin.settingspages.3f8c9ad8': 'RecipientsEmail ( ; )',
    'pages.admin.settingspages.3f9e749d': 'ApprovalDomain (Email)',
    'pages.admin.settingspages.4135c27b': 'LeadSource',
    'pages.admin.settingspages.41f8a067': 'Settingspages',
    'pages.admin.settingspages.4272c594': 'Recipientsconfiguration',
    'pages.admin.settingspages.4380ba69': 'Language - Contact/Account"Preferred language"Field',
    'pages.admin.settingspages.43bb00cc': 'Name',
    'pages.admin.settingspages.47a45a31': 'Dialing code',
    'pages.admin.settingspages.4def1f40': 'Country',
    'pages.admin.settingspages.4ef82317': 'Language code',
    'pages.admin.settingspages.50582ca6': 'List Price',
    'pages.admin.settingspages.51357f4e': 'Code (ISO 2 )',
    'pages.admin.settingspages.51edfc00':
      'Domestic/Overseas(manual §8.8) - 5-tuple Key: Model / Frequency Band / Country / / Quantity. Sale Price Lowauthorized price BAP red banner',
    'pages.admin.settingspages.55959526': 'Currency name',
    'pages.admin.settingspages.5c5621a6':
      'Business functionconfigurationemailNotificationRecipients(manual §8.5) - "LeadCreateemail" / "OpportunityAmount 100 Approval passed"',
    'pages.admin.settingspages.602fb9a6': 'Signing Entity',
    'pages.admin.settingspages.6417939c':
      'product classification 2 ( Group) - : Base Station / CPE / Antenna',
    'pages.admin.settingspages.682c4f04': 'Business unit (BU)',
    'pages.admin.settingspages.6aee8c1c': '-Frequency Band',
    'pages.admin.settingspages.709b7562': 'Exchange rate to USD',
    'pages.admin.settingspages.71820169': 'Sinosure ApproveApproved',
    'pages.admin.settingspages.76b08c86': 'Gross Margin',
    'pages.admin.settingspages.7d7c8ad9': 'Approval Settings',
    'pages.admin.settingspages.7f03e150': 'Countryconfiguration',
    'pages.admin.settingspages.7fa2c0d8':
      'product classification 3 ( Class) - Model Series + Part Number',
    'pages.admin.settingspages.82ae612f': 'Currency configuration',
    'pages.admin.settingspages.88f2163b': 'Model',
    'pages.admin.settingspages.8ffb1141': 'configurationNoneFrequency Band//with(manual §8.2)',
    'pages.admin.settingspages.938d062a': 'Margin (%)',
    'pages.admin.settingspages.958918b2':
      'Sinosure 4-stage BPF approval configuration - separate from general approval settings',
    'pages.admin.settingspages.97c7718e': 'International(manual §8.3)',
    'pages.admin.settingspages.9a0a8f57': 'Signing Entity',
    'pages.admin.settingspages.9c0ef365':
      'product classification hierarchy 1 - Group -> Class -> Sub Class -> Subclass-Band',
    'pages.admin.settingspages.9dfefea9': 'AccountApprove',
    'pages.admin.settingspages.9ef60ad6': 'AccountReviewSubmit',
    'pages.admin.settingspages.approver_user': 'Approver',
    'pages.admin.settingspages.approver_user_placeholder': 'Select an approver',
    'pages.admin.settingspages.business_unit': 'Business Unit',
    'pages.admin.settingspages.business_unit_placeholder':
      'Select a business unit (leave empty for global routing)',
    'pages.admin.settingspages.a32a76bd': '(MHz)',
    'pages.admin.settingspages.a3fef110': 'Product category',
    'pages.admin.settingspages.a86dc52c':
      'Domestic/OverseasGeography digits + Manager + Contact info',
    'pages.admin.settingspages.abd7122c':
      'Account number / OpportunityNumberBusinessNumber key-value',
    'pages.admin.settingspages.ae8da9b0': 'POC ApplicationReview',
    'pages.admin.settingspages.b2146fb7': 'LeadCreate',
    'pages.admin.settingspages.b2929da0': 'Region',
    'pages.admin.settingspages.b31898e0': 'ISO Code',
    'pages.admin.settingspages.b5702552': 'Part type',
    'pages.admin.settingspages.b9c4116a': 'Currency (ISO)',
    'pages.admin.settingspages.c6f3a224': 'Notes',
    'pages.admin.settingspages.cc5d3ba9': 'Sub Class × Frequency Band - ModelFrequency Band',
    'pages.admin.settingspages.cd921b9e':
      'USD is the base currency with default rate 1.0; other rates are exchange rates to USD.',
    'pages.admin.settingspages.cfdd8cf6': 'ApprovalDomain',
    'pages.admin.settingspages.d425f256':
      'Business unit × TypeconfigurationApprovers(manual §8.6) - Data, ForbiddenCodeFirst Name',
    'pages.admin.settingspages.d6400b24': 'OpportunityApproval passed',
    'pages.admin.settingspages.e62e1539': 'Lead Medium"Source"FieldOptionalValue (: / / / )',
    'pages.admin.settingspages.e6b3ed0d': 'Cost price',
    'pages.admin.settingspages.ee73246e': 'Shared accounts',
    'pages.admin.settingspages.f0181941': 'Band',
    'pages.admin.settingspages.f10f1c27':
      'Opportunity POC Stage"testRequest"Reviewpersonnel (Role + Country)',
    'pages.admin.settingspages.f32090d8': 'Country Code',
    'pages.admin.settingspages.f68a0af9': 'ISO Code (3 )',
    'pages.admin.settingspages.fa81088f': 'Approval Type',
    'pages.admin.settingspages.fb4d5736': 'Configuration name',
    'pages.admin.settingspages.fc11c89f': '(MHz)',
    'pages.admin.settingspages.fd2a28fd': 'Quote base price table',
    'pages.admin.settingspages.fe7c7f48':
      'ISO Country (English Name + Chinese Name + Continent) - Opportunity/Account"Country"lookup DataSource',
    'pages.admin.settingspages.fffc01f7': 'Part type (: / / / )',
    'pages.contact.contactcreatemodal.0e20c83c': 'City',
    'pages.contact.contactcreatemodal.171b3a10': 'Last Name',
    'pages.contact.contactcreatemodal.175b03a7': 'Contact · Contact',
    'pages.contact.contactcreatemodal.190b1bf0': 'Fax',
    'pages.contact.contactcreatemodal.19b17913': 'Mr. /',
    'pages.contact.contactcreatemodal.1d844402':
      'Files are stored temporarily and uploaded automatically after the contact is created. Maximum file size: 10 MB.',
    'pages.contact.contactcreatemodal.2676d51a': 'Japanese (Japanese)',
    'pages.contact.contactcreatemodal.27064dc7': 'Created contact {{v0}}',
    'pages.contact.contactcreatemodal.2e9d20c4': 'Related Opportunities',
    'pages.contact.contactcreatemodal.2fa2527a': 'Dr. /',
    'pages.contact.contactcreatemodal.3593cfbc': '{{v0}} exceeds the 10 MB limit',
    'pages.contact.contactcreatemodal.3796483b': 'Street 1',
    'pages.contact.contactcreatemodal.39f0eb1f': 'Ms. /',
    'pages.contact.contactcreatemodal.4525d882': 'Click or drag files to upload',
    'pages.contact.contactcreatemodal.4710e6fe': 'State/Province',
    'pages.contact.contactcreatemodal.4a2acb61': 'Details',
    'pages.contact.contactcreatemodal.514d1d8a': 'Phone',
    'pages.contact.contactcreatemodal.55e50d33': 'Notes synchronized with the OA system',
    'pages.contact.contactcreatemodal.56a7e79f': '- Save',
    'pages.contact.contactcreatemodal.5a808713': 'First name is required',
    'pages.contact.contactcreatemodal.5b2b750a': 'Contactcreatemodal',
    'pages.contact.contactcreatemodal.5b433f7c': 'Email',
    'pages.contact.contactcreatemodal.email_required': 'Email is required',
    'pages.contact.contactcreatemodal.5c1230e6': 'Street 2',
    'pages.contact.contactcreatemodal.63357f5e': 'Phone 1',
    'pages.contact.contactcreatemodal.whatsapp': 'WhatsApp',
    'pages.contact.contactcreatemodal.6d038c8b': 'Free-text field in D365',
    'pages.contact.contactcreatemodal.6de2389c': 'Salutation',
    'pages.contact.contactcreatemodal.71bd6a25': 'Birthday',
    'pages.contact.contactcreatemodal.734cc1a1': 'Mobile is required',
    'pages.contact.contactcreatemodal.75473371': 'Country/Region',
    'pages.contact.contactcreatemodal.762f60a6': 'Mobile',
    'pages.contact.contactcreatemodal.784b1f00': 'Attachments',
    'pages.contact.contactcreatemodal.7f4690de': 'Uploaded {{v0}} attachments',
    'pages.contact.contactcreatemodal.82a5fba0':
      'Failed to link {{v0}} opportunities. You can link them manually on the detail page.',
    'pages.contact.contactcreatemodal.8404a896': 'Phone 2',
    'pages.contact.contactcreatemodal.8ea80f3c': 'Preferred language',
    'pages.contact.contactcreatemodal.8ee83fea': 'Basic Information',
    'pages.contact.contactcreatemodal.93509403': 'Parent account',
    'pages.contact.contactcreatemodal.97d9e791': 'Quick Create Contact',
    'pages.contact.contactcreatemodal.983f6b84': 'Linked {{v0}} opportunities',
    'pages.contact.contactcreatemodal.9b3edf39': 'Prof. /',
    'pages.contact.contactcreatemodal.9ccf0f41': 'Contact info',
    'pages.contact.contactcreatemodal.9d2a15aa': 'Traditional Chinese (Chinese, Traditional)',
    'pages.contact.contactcreatemodal.a632bcd6': 'Create and Open',
    'pages.contact.contactcreatemodal.a81f656a':
      'Pending upload - submitted automatically when the contact is created',
    'pages.contact.contactcreatemodal.ae98773d': 'Department',
    'pages.contact.contactcreatemodal.b4020d5f': 'Mrs. /',
    'pages.contact.contactcreatemodal.b900a4dc': 'Generated from last name + first name on submit',
    'pages.contact.contactcreatemodal.bb0d64d8': 'Middle name',
    'pages.contact.contactcreatemodal.bb50abe3':
      'Optional: Select opportunities for this contact. After creation, their Contact field will be linked automatically.',
    'pages.contact.contactcreatemodal.bc6ffc9b': 'Opportunity',
    'pages.contact.contactcreatemodal.bd40f910': 'Please check required fields',
    'pages.contact.contactcreatemodal.c0f153ab': 'Search opportunity name...',
    'pages.contact.contactcreatemodal.c5495119': 'Parent account is required',
    'pages.contact.contactcreatemodal.cb913f86': 'Email 1',
    'pages.contact.contactcreatemodal.cd8d2b35': '(First Name)',
    'pages.contact.contactcreatemodal.d0240b5f': 'Unknown error',
    'pages.contact.contactcreatemodal.d1183207': 'Postal code',
    'pages.contact.contactcreatemodal.d501967a': 'Last name is required',
    'pages.contact.contactcreatemodal.d6cf9136': 'OA Notes',
    'pages.contact.contactcreatemodal.d98ddff5': 'Invalid email format',
    'pages.contact.contactcreatemodal.dcefc2a2': 'Summary',
    'pages.contact.contactcreatemodal.e2bafa4a': 'Create failed: {{v0}}',
    'pages.contact.contactcreatemodal.e64d0385': 'Description',
    'pages.contact.contactcreatemodal.eb11a205':
      'AttachmentsUpload failed ({{v0}} ), detail page"Attachments"tab Upload',
    'pages.contact.contactcreatemodal.efb1e28d': 'Email 2',
    'pages.contact.contactcreatemodal.f1571e69': 'Simplified Chinese (Chinese, Simplified)',
    'pages.contact.contactcreatemodal.f4bd874f': 'Remove',
    'pages.contact.contactcreatemodal.f69ac344': 'Country/Region',
    'pages.contact.contactcreatemodal.f8dc21a6':
      'Link opportunities: {{v0}} succeeded / {{v1}} failed',
    'pages.contact.contactcreatemodal.fd122da3':
      'Attachments: {{v0}} succeeded / {{v1}} failed. Failed files can be uploaded again on the detail page.',
    'pages.contact.contactcreatemodal.fdf16f78': 'Job Title',
    'pages.contact.contactcreatemodal.fe5d66d7': 'First Name',
    'pages.contact.contactcreatemodal.feccfca3': 'Cancel',
    'pages.contact.contactdetailpage.0a1b096a': 'No opportunities linked to this contact',
    'pages.contact.contactdetailpage.20821314': 'Other Contact Information',
    'pages.contact.contactdetailpage.2e702f5d': 'Profile',
    'pages.contact.contactdetailpage.327b9bc8': 'Mobile phone',
    'pages.contact.contactdetailpage.address': 'Address',
    'pages.contact.contactdetailpage.contactDetails': 'Contact Details',
    'pages.contact.contactdetailpage.contactInformation': 'Contact Information',
    'pages.contact.contactdetailpage.3828ea66': 'Signing:',
    'pages.contact.contactdetailpage.55a20107': 'Owner:',
    'pages.contact.contactdetailpage.5ecfc254': 'Contact preferences',
    'pages.contact.contactdetailpage.5f61b450': 'Opportunity',
    'pages.contact.contactdetailpage.6670144a': 'Marketing',
    'pages.contact.contactdetailpage.74072685': 'Modified On',
    'pages.contact.contactdetailpage.95e09dc8': 'Notes',
    'pages.contact.contactdetailpage.96b6fcab': 'Parent account',
    'pages.contact.contactdetailpage.a8c030aa': '(First Name)',
    'pages.contact.contactdetailpage.a9e98947': 'Details',
    'pages.contact.contactdetailpage.bb76f918': 'System information',
    'pages.contact.contactdetailpage.d6bc9f52': 'Linked Account',
    'pages.contact.contactdetailpage.e5f62e95': 'Number',
    'pages.contact.contactdetailpage.ed7b9be4': 'Updated at',
    'pages.contact.contactdetailpage.eefc1e5b': 'Estimated amount',
    'pages.dashboard.salesdashboardpage.015167db': '{{v0}} days',
    'pages.dashboard.salesdashboardpage.03e04ef4': 'NDA',
    'pages.dashboard.salesdashboardpage.0549baa8': 'Owner',
    'pages.dashboard.salesdashboardpage.138e8a6d': 'POC Application',
    'pages.dashboard.salesdashboardpage.17b1be16': 'Lost This Month: ',
    'pages.dashboard.salesdashboardpage.1f9900f4': 'Stage',
    'pages.dashboard.salesdashboardpage.2280c058': 'Opportunity name',
    'pages.dashboard.salesdashboardpage.26afb3e7': 'None active Opportunity',
    'pages.dashboard.salesdashboardpage.44b5aaa1': 'Weighted amount',
    'pages.dashboard.salesdashboardpage.66cc98c4': 'Estimated amount',
    'pages.dashboard.salesdashboardpage.875476f1': 'POC',
    'pages.dashboard.salesdashboardpage.8d482e1f': 'Close opportunity',
    'pages.dashboard.salesdashboardpage.9242d441': 'Account',
    'pages.dashboard.salesdashboardpage.94d2d7a1': '- Historical average/max duration by stage',
    'pages.dashboard.salesdashboardpage.a10e3f87': 'Commercial negotiation',
    'pages.dashboard.salesdashboardpage.a40e76cd': 'Project approval',
    'pages.dashboard.salesdashboardpage.a4707969': 'Average duration (days)',
    'pages.dashboard.salesdashboardpage.aa7bf199': ' ',
    'pages.dashboard.salesdashboardpage.b492891f':
      '💡 Stages with an average duration > 60 days are highlighted for business attention (delay risk)',
    'pages.dashboard.salesdashboardpage.ba6df84c':
      '- Recommended follow-up with the account to analyze the reason for the lost deal',
    'pages.dashboard.salesdashboardpage.c25f1684': 'Probability',
    'pages.dashboard.salesdashboardpage.c4302da5': 'Maximum duration (days)',
    'pages.dashboard.salesdashboardpage.cafc67d0': 'Requirement collection',
    'pages.dashboard.salesdashboardpage.e81b6e57': '(First Name)',
    'pages.dashboard.salesdashboardpage.f955b8f6': 'Samples',
    'pages.dashboard.salesdashboardpage.published_opportunities': 'Published opportunities',
    'pages.dashboard.salesdashboardpage.no_published_opportunities': 'No published opportunities',
    'pages.dashboard.salesdashboardpage.published': 'Published',
    'pages.dashboard.salesdashboardpage.overdue_opportunities': 'Overdue opportunities',
    'pages.dashboard.salesdashboardpage.no_overdue_opportunities': 'No overdue opportunities',
    'pages.dashboard.salesdashboardpage.opportunity': 'Opportunity',
    'pages.dashboard.salesdashboardpage.account': 'Account',
    'pages.dashboard.salesdashboardpage.owner': 'Owner',
    'pages.dashboard.salesdashboardpage.estimated_close_date': 'Estimated close date',
    'pages.dashboard.salesdashboardpage.overdue': 'Overdue',
    'pages.dashboard.salesdashboardpage.status': 'Status',
    'pages.dashboard.salesdashboardpage.unnamed_opportunity': 'Unnamed opportunity',
    'pages.dashboard.salesdashboardpage.total': 'Total {{v0}}',
    'pages.analytics.dataanalysispage.accountId': 'Account ID',
    'pages.analytics.dataanalysispage.accountName': 'Account Name',
    'pages.analytics.dataanalysispage.accountNumber': 'Account Number',
    'pages.analytics.dataanalysispage.activeFilters': 'Active filters:',
    'pages.analytics.dataanalysispage.address': 'Address',
    'pages.analytics.dataanalysispage.amount': 'Amount',
    'pages.analytics.dataanalysispage.activeAmount': 'Open Opportunity Amount',
    'pages.analytics.dataanalysispage.activeOpportunities': 'Open Opportunities',
    'pages.analytics.dataanalysispage.clearFilters': 'Clear filters',
    'pages.analytics.dataanalysispage.comprehensivePlaceholder':
      'Comprehensive analysis will summarize key validity indicators across accounts and opportunities.',
    'pages.analytics.dataanalysispage.comprehensiveEmpty': 'No comprehensive analysis data',
    'pages.analytics.dataanalysispage.comprehensiveSubtitle': '{{v0}} view · {{v1}} owners',
    'pages.analytics.dataanalysispage.comprehensiveTitle': 'Comprehensive Analysis',
    'pages.analytics.dataanalysispage.completeness': 'Completeness',
    'pages.analytics.dataanalysispage.contacts': 'Contacts',
    'pages.analytics.dataanalysispage.customerTitle': 'Account Analysis',
    'pages.analytics.dataanalysispage.domestic': 'Domestic',
    'pages.analytics.dataanalysispage.email': 'Email',
    'pages.analytics.dataanalysispage.empty': 'No account validity data',
    'pages.analytics.dataanalysispage.mobilePhone': 'Mobile Phone',
    'pages.analytics.dataanalysispage.missingContacts': 'No Contacts',
    'pages.analytics.dataanalysispage.missingAddress': 'Missing Address',
    'pages.analytics.dataanalysispage.missingEmail': 'Missing Email',
    'pages.analytics.dataanalysispage.missingMobilePhone': 'Missing Mobile',
    'pages.analytics.dataanalysispage.missingTelephone1': 'Missing Landline',
    'pages.analytics.dataanalysispage.no': 'No',
    'pages.analytics.dataanalysispage.opportunities': 'Opportunities',
    'pages.analytics.dataanalysispage.opportunityEmpty': 'No opportunity analysis data',
    'pages.analytics.dataanalysispage.opportunityLost': 'Lost',
    'pages.analytics.dataanalysispage.opportunityName': 'Opportunity Name',
    'pages.analytics.dataanalysispage.opportunityNumber': 'Opportunity No.',
    'pages.analytics.dataanalysispage.opportunityOpen': 'Open',
    'pages.analytics.dataanalysispage.opportunityPlaceholder':
      'Opportunity analysis will show opportunity data completeness, stage distribution, and key gaps.',
    'pages.analytics.dataanalysispage.opportunitySearchPlaceholder':
      'Search opportunity no. / name',
    'pages.analytics.dataanalysispage.opportunityStatus': 'Opportunity Status',
    'pages.analytics.dataanalysispage.opportunitySubtitle': '{{v0}} view · {{v1}} opportunities',
    'pages.analytics.dataanalysispage.opportunityTitle': 'Opportunity Analysis',
    'pages.analytics.dataanalysispage.opportunityWon': 'Won',
    'pages.analytics.dataanalysispage.overseas': 'Overseas',
    'pages.analytics.dataanalysispage.owner': 'Owner',
    'pages.analytics.dataanalysispage.ownerCount': 'Owners',
    'pages.analytics.dataanalysispage.ownerFilterPlaceholder': 'Filter by owner',
    'pages.analytics.dataanalysispage.probability': 'Probability(%)',
    'pages.analytics.dataanalysispage.refresh': 'Refresh',
    'pages.analytics.dataanalysispage.searchPlaceholder': 'Search account name / number',
    'pages.analytics.dataanalysispage.statusFilterPlaceholder': 'Filter by opportunity status',
    'pages.analytics.dataanalysispage.subtitle': '{{v0}} view · {{v1}} accounts',
    'pages.analytics.dataanalysispage.estimatedCloseDate': 'Est. close date',
    'pages.analytics.dataanalysispage.telephone1': 'Landline',
    'pages.analytics.dataanalysispage.title': 'Data Analysis',
    'pages.analytics.dataanalysispage.totalAccounts': 'Accounts',
    'pages.analytics.dataanalysispage.totalRows': '{{v0}} rows',
    'pages.analytics.dataanalysispage.withAddress': 'With Address',
    'pages.analytics.dataanalysispage.withContacts': 'With Contacts',
    'pages.analytics.dataanalysispage.withEmail': 'With Email',
    'pages.analytics.dataanalysispage.withMobilePhone': 'With Mobile',
    'pages.analytics.dataanalysispage.withOpportunities': 'With Opportunities',
    'pages.analytics.dataanalysispage.withTelephone1': 'With Landline',
    'pages.analytics.dataanalysispage.withoutFilter': 'Without {{v0}}',
    'pages.analytics.dataanalysispage.wonAmount': 'Won Amount',
    'pages.analytics.dataanalysispage.wonOpportunities': 'Won Opportunities',
    'pages.analytics.dataanalysispage.yes': 'Yes',
    'pages.deeplinkpage.533d50b9': 'entity - ?entity=opportunity&id=<uuid>',
    'pages.deeplinkpage.a844a562': 'Invalid deep link parameters',
    'pages.deeplinkpage.d4e322de': 'Contact the administrator to check the link source',
    'pages.delivery.deliverydetailpage.267cac52': 'Region',
    'pages.delivery.deliverydetailpage.643f9ee9': 'Cost',
    'pages.delivery.deliverydetailpage.70156f0f': 'Notes',
    'pages.delivery.deliverydetailpage.bd98b79f': 'Budget',
    'pages.delivery.deliverydetailpage.edb9b7b5': 'Cost / Notes',
    'pages.delivery.deliverydetailpage.feb07435': 'Stage:',
    'pages.entity.entitylistpage.statecode_active': 'Active',
    'pages.entity.entitylistpage.statecode_inactive': 'Inactive',
    'pages.entity.entitylistpage.statecode_closed': 'Closed',
    'pages.entity.entitylistpage.audit_not_submitted': 'Not submitted',
    'pages.entity.entitylistpage.audit_in_review': 'In review',
    'pages.entity.entitylistpage.audit_approved': 'Approved',
    'pages.entity.entitydetailpage.18813bed': '(First Name)',
    'pages.entity.entitydetailpage.21b60411': 'No data',
    'pages.entity.entitydetailpage.23c9d7de': 'Read-onlyField(system)',
    'pages.entity.entitydetailpage.2b2e82f9': 'Back',
    'pages.entity.entitydetailpage.2f339511': 'Required field cannot be empty: {{v0}}',
    'pages.entity.entitydetailpage.2f3f1afe': 'Activities',
    'pages.entity.entitydetailpage.309ecf70': 'Read-onlyField(business ruleLocked)',
    'pages.entity.entitydetailpage.59b71d53': 'No fields changed',
    'pages.entity.entitydetailpage.81fa706c':
      'Read-onlyField(business ruleLocked, systemAutomatic/Sync)',
    'pages.entity.entitydetailpage.887d3072': 'Save failed',
    'pages.entity.entitydetailpage.895ffb82': 'Locked, FieldEdit',
    'pages.entity.entitydetailpage.8a937f19': 'Activities',
    'pages.entity.entitydetailpage.9cb4dac9': 'Read-onlyField(, )',
    'pages.entity.entitydetailpage.b78aaa9a': 'Saved {{v0}} fields',
    'pages.entity.entitydetailpage.c3db33f5': '{{v0}} required fields',
    'pages.entity.entitydetailpage.c4e45c5d': 'Not configured picker - picker.service.ts target',
    'pages.entity.entitydetailpage.d721ff7d': 'Please select',
    'pages.entity.entitydetailpage.e3a4828d': 'Read-onlyField(D365 IsValidForUpdate=false)',
    'pages.entity.entitydetailpage.f77865c9': 'Required',
    'pages.entity.relatedtable.02acb50f': 'Total',
    'pages.entity.relatedtable.110a75f0': 'NoneLink',
    'pages.entity.relatedtable.3c39becf': 'Refresh',
    'pages.entity.relatedtable.90081763': 'items',
    'pages.entity.relatedtable.bf1fa984': 'Total {{v0}} items',
    'pages.inbox.inboxpage.141b5bf9': 'Cancel',
    'pages.inbox.inboxpage.351bfb52': 'Unrecognized entity: {{v0}}',
    'pages.inbox.inboxpage.3e106440': 'No tasks',
    'pages.inbox.inboxpage.416de046': 'Deselect all',
    'pages.inbox.inboxpage.427469aa': 'View',
    'pages.inbox.inboxpage.4af3b93b': 'ViewLinkDetails',
    'pages.inbox.inboxpage.5ffe754c': '{{v0}} completed',
    'pages.inbox.inboxpage.6b4043ee': '(First NameTask)',
    'pages.inbox.inboxpage.71c83bd2': 'Reject',
    'pages.inbox.inboxpage.7707c516': 'Created at',
    'pages.inbox.inboxpage.7bd05d43': 'Total',
    'pages.inbox.inboxpage.7d675703': 'ActionsRevoke, Confirm',
    'pages.inbox.inboxpage.89615a11': 'Select all',
    'pages.inbox.inboxpage.967c40c6': 'Processing failed',
    'pages.inbox.inboxpage.a7a14971': 'Task details',
    'pages.inbox.inboxpage.ad0817e1': 'Processing failed',
    'pages.inbox.inboxpage.adf20619': 'Approve',
    'pages.inbox.inboxpage.dc80a70f': 'Bulk {{v0}} {{v1}} tasks?',
    'pages.inbox.inboxpage.deleted_target_cancelled':
      'The approval target has been deleted, and this pending item was automatically cancelled',
    'pages.inbox.inboxpage.ed8cb1fa': 'Selected',
    'pages.inbox.inboxpage.f1c3fd08': 'Bulk {{v0}} completed: {{v1}} succeeded, {{v2}} failed',
    'pages.inbox.inboxpage.f6c58473': 'Refresh',
    'pages.inbox.inboxpage.notification_tab_title': 'Notifications',
    'pages.inbox.inboxpage.f6cfa783': 'Please first Task',
    'pages.inbox.inboxpage.pending_filter_account': 'Account pending',
    'pages.inbox.inboxpage.pending_filter_all': 'All pending',
    'pages.inbox.inboxpage.pending_filter_opportunity': 'Opportunity pending',
    'pages.inbox.inboxpage.pending_filter_poc': 'POC request approval',
    'pages.inbox.inboxpage.target_detail_forbidden':
      'You do not have permission to view the approval target details, but you can still process this approval',
    'pages.inbox.inboxpage.unavailable_target_cancelled':
      'The approval target does not exist or is no longer accessible, and this pending item was automatically cancelled',
    'pages.integration.integrationlogpage.08da3e0a': 'Failed',
    'pages.integration.integrationlogpage.125f8111': 'Time',
    'pages.integration.integrationlogpage.1e443b0c': 'System',
    'pages.integration.integrationlogpage.226e4d3c': 'entityId, Unable to retry',
    'pages.integration.integrationlogpage.2f55b506': 'Duration',
    'pages.integration.integrationlogpage.4c4cde56': 'Result',
    'pages.integration.integrationlogpage.58c2db8a': 'retry Failed',
    'pages.integration.integrationlogpage.61eb9b87': 'Succeeded',
    'pages.integration.integrationlogpage.64e77a0e': 'Error',
    'pages.integration.integrationlogpage.66d47dad': 'Try',
    'pages.integration.integrationlogpage.69a93b6d': 'Actions',
    'pages.integration.integrationlogpage.8880f75e': 'Refresh',
    'pages.integration.integrationlogpage.9146bdac': 'Integration logs',
    'pages.integration.integrationlogpage.a0b23b1a': 'items',
    'pages.integration.integrationlogpage.b652a6a1': 'Entity',
    'pages.integration.integrationlogpage.bf5a39ca': 'Total {{v0}} items',
    'pages.integration.integrationlogpage.direction.title': 'Interface Direction',
    'pages.integration.integrationlogpage.direction.outbound': 'Outbound',
    'pages.integration.integrationlogpage.direction.inbound': 'Inbound',
    'pages.integration.integrationlogpage.direction.outboundDesc':
      'Outbound: CREST calls an external system API, such as SAP, OA, or DingTalk.',
    'pages.integration.integrationlogpage.direction.inboundDesc':
      'Inbound: an external system calls CREST, or external data is pulled/synchronized into CREST.',
    'pages.integration.integrationlogpage.business.type': 'Business Type',
    'pages.integration.integrationlogpage.business.object': 'Business Object',
    'pages.integration.integrationlogpage.business.material': 'Material Query',
    'pages.integration.integrationlogpage.business.accountSync': 'Account Sync',
    'pages.integration.integrationlogpage.business.approval': 'Approval Integration',
    'pages.integration.integrationlogpage.business.orgSync': 'Org Sync',
    'pages.integration.integrationlogpage.business.interfaceCall': 'Interface Call',
    'pages.integration.integrationlogpage.business.sapMaterial': 'SAP Material Master',
    'pages.integration.integrationlogpage.business.dingtalkOrg': 'DingTalk Organization',
    'pages.integration.integrationlogpage.d55cee17': 'SAP Queue Status',
    'pages.integration.integrationlogpage.e2f4f25d': 'Retrying',
    'pages.integration.integrationlogpage.ec50273c': 'Retry',
    'pages.integration.integrationlogpage.ef81d8d7': 'Queued (job={{v0}})',
    'pages.lead.leadcreatemodal.1bdb2e39': 'Account Group',
    'pages.lead.leadcreatemodal.28e7beca':
      'Project background and account requirements are copied to the account description automatically when the lead is qualified.',
    'pages.lead.leadcreatemodal.2c37493c': 'Country/Region',
    'pages.lead.leadcreatemodal.3bb200a4': 'Uploaded {{v0}} attachments',
    'pages.lead.leadcreatemodal.3d66bf14': 'Company',
    'pages.lead.leadcreatemodal.3ee9c6d8': 'Account name is required',
    'pages.lead.leadcreatemodal.40e56463': 'State/Province',
    'pages.lead.leadcreatemodal.47fc8148': 'City/County',
    'pages.lead.leadcreatemodal.48cc9f54': 'Business Phone',
    'pages.lead.leadcreatemodal.4abdab44': 'Contact',
    'pages.lead.leadcreatemodal.4ea42305':
      'Pending upload - submitted automatically when the lead is created',
    'pages.lead.leadcreatemodal.4fda7684': 'Remove',
    'pages.lead.leadcreatemodal.506f79b6': 'Description',
    'pages.lead.leadcreatemodal.5073b0fc': 'Quick Create Lead',
    'pages.lead.leadcreatemodal.51b90ac2': 'Account Name',
    'pages.lead.leadcreatemodal.5524b99e': '- Save',
    'pages.lead.leadcreatemodal.56a54e2c': 'Mobile Phone',
    'pages.lead.leadcreatemodal.57ff3d46': 'Street 1',
    'pages.lead.leadcreatemodal.5a593f72': 'Account Budget',
    'pages.lead.leadcreatemodal.5a96ddea': 'Invalid email format',
    'pages.lead.leadcreatemodal.62c3c818': 'Create and Open',
    'pages.lead.leadcreatemodal.63f6a905': 'Country Phone Code',
    'pages.lead.leadcreatemodal.6619b484': 'Cancel',
    'pages.lead.leadcreatemodal.66e71f6d': '{{v0}} exceeds the 10 MB limit',
    'pages.lead.leadcreatemodal.673c8316': 'Click or drag files to upload',
    'pages.lead.leadcreatemodal.6c102440': 'Employees',
    'pages.lead.leadcreatemodal.7e59b733': 'Customer Category',
    'pages.lead.leadcreatemodal.807a63b8': 'First name is required',
    'pages.lead.leadcreatemodal.817fc5bc': 'Estimated Close Date',
    'pages.lead.leadcreatemodal.857c1fc2': 'Create failed: {{v0}}',
    'pages.lead.leadcreatemodal.88dcaa36': 'Country Code',
    'pages.lead.leadcreatemodal.8904d671': 'Subject',
    'pages.lead.leadcreatemodal.8b099f9d': 'Sales mode is required',
    'pages.lead.leadcreatemodal.908ac344': 'Summary',
    'pages.lead.leadcreatemodal.913c2551': 'Details',
    'pages.lead.leadcreatemodal.92b5e249': 'Website',
    'pages.lead.leadcreatemodal.99ee878c': 'Interested Products',
    'pages.lead.leadcreatemodal.9b03d025': 'Job Title',
    'pages.lead.leadcreatemodal.9b66b273': 'Project Background',
    'pages.lead.leadcreatemodal.9cdfbf16': 'Please check required fields',
    'pages.lead.leadcreatemodal.a0b9c552': 'Last Name',
    'pages.lead.leadcreatemodal.a7aae82c': 'Customer category is required',
    'pages.lead.leadcreatemodal.a7b5033d': 'Attachments',
    'pages.lead.leadcreatemodal.a9f4f9ed': 'Brand',
    'pages.lead.leadcreatemodal.aa380778':
      'AttachmentsUpload failed ({{v0}} ), detail page"Attachments"tab Upload',
    'pages.lead.leadcreatemodal.ae4ae720': 'Country phone code is required',
    'pages.lead.leadcreatemodal.b04f3273': 'Subject is required',
    'pages.lead.leadcreatemodal.b2784509': 'Opportunity Information',
    'pages.lead.leadcreatemodal.b47e4d38': 'Lead · Sales Insights',
    'pages.lead.leadcreatemodal.b4b03b03': 'Project background, account needs, pain points, etc.',
    'pages.lead.leadcreatemodal.b69d58a6':
      'Attachments: {{v0}} succeeded / {{v1}} failed. Failed files can be uploaded again on the detail page.',
    'pages.lead.leadcreatemodal.c3bd8404': 'Postal Code',
    'pages.lead.leadcreatemodal.c45f3a76': 'First Name',
    'pages.lead.leadcreatemodal.c473f5c8': 'Sales Mode',
    'pages.lead.leadcreatemodal.c6f947f4': 'Created and opened account {{v0}}{{v1}}',
    'pages.lead.leadcreatemodal.d1880555': 'Unknown error',
    'pages.lead.leadcreatemodal.d5e15f49': 'Last name is required',
    'pages.lead.leadcreatemodal.e4caf088': 'Email',
    'pages.lead.leadcreatemodal.e7ed059f': 'Generated from last name + first name on submit',
    'pages.lead.leadcreatemodal.ec9aac7a': 'Estimated Revenue',
    'pages.lead.leadcreatemodal.ed25fe98': 'Lead Source',
    'pages.lead.leadcreatemodal.f3823141':
      'Files are stored temporarily and uploaded automatically after the lead is created. Maximum file size: 10 MB.',
    'pages.lead.leadcreatemodal.f53bf832': 'Country code is required',
    'pages.lead.leaddetailpage.1c2c0745': 'Account',
    'pages.lead.leaddetailpage.3128cc14': 'Contact info',
    'pages.lead.leaddetailpage.339f9d6a': 'Interested Products',
    'pages.lead.leaddetailpage.38cdc0c4': 'Contact {{v0}}',
    'pages.lead.leaddetailpage.3b636c6e': 'Summary',
    'pages.lead.leaddetailpage.3e417b97':
      'Create an opportunity from the subject and budget, then start the BPF automatically',
    'pages.lead.leaddetailpage.3f57fea1':
      'Create a contact from the name and email, then link it to the account automatically',
    'pages.lead.leaddetailpage.45162815': 'Address',
    'pages.lead.leaddetailpage.46ad76a2': 'Opportunity forecast',
    'pages.lead.leaddetailpage.591abb1b':
      'This lead is qualified. Fields are locked by the business rule.',
    'pages.lead.leaddetailpage.5d22f4ba': 'Country Code',
    'pages.lead.leaddetailpage.64074368': 'Brand',
    'pages.lead.leaddetailpage.7b7827a4': 'Account {{v0}}',
    'pages.lead.leaddetailpage.8b7a8db9': 'Create account master data from the company information',
    'pages.lead.leaddetailpage.8cd51ba6': 'Opportunity Information',
    'pages.lead.leaddetailpage.8ee80859': 'Convert account',
    'pages.lead.leaddetailpage.940b52e1':
      'This lead is qualified. Fields are locked by the business rule.',
    'pages.lead.leaddetailpage.9ed075e2': 'Estimated revenue',
    'pages.lead.leaddetailpage.a907efcd': 'Cancel',
    'pages.lead.leaddetailpage.ab6b6484': 'Qualify failed',
    'pages.lead.leaddetailpage.acfb6610': 'Lead Disqualified, View',
    'pages.lead.leaddetailpage.ad6bd656': 'Project Background',
    'pages.lead.leaddetailpage.b77a52d6': 'Basic Information',
    'pages.lead.leaddetailpage.c30cf2b0': 'Converted: {{v0}}',
    'pages.lead.leaddetailpage.c783981a': 'Details',
    'pages.lead.leaddetailpage.d0f17e2c': 'Conversion result',
    'pages.lead.leaddetailpage.d640385b': 'Convert opportunity',
    'pages.lead.leaddetailpage.dcfc32c6': 'Company',
    'pages.lead.leaddetailpage.dda4bc4b':
      'Select an entity to create. The project background will be copied to the account description automatically:',
    'pages.lead.leaddetailpage.df9c5eb3': 'Lead',
    'pages.lead.leaddetailpage.converted_contacts_count': 'Contacts converted',
    'pages.lead.leaddetailpage.converted_contacts_title': 'Converted Contacts',
    'pages.lead.leaddetailpage.eb078d7d': 'Opportunity {{v0}}',
    'pages.lead.leaddetailpage.f4c9a387': 'Opportunity',
    'pages.lead.leaddetailpage.f84e74ff': 'System information',
    'pages.operations.operationsdashboardpage.06fde89e': 'M+3 ( MES)',
    'pages.operations.operationsdashboardpage.09fb2d23': 'M+2 ( iws_deliverproject)',
    'pages.operations.operationsdashboardpage.6fc51fb7': 'M+3 ( SAP IM)',
    'pages.operations.operationsdashboardpage.92d2fe23': 'M+3 ( SAP MM)',
    'pages.operations.operationsdashboardpage.95029e19': 'M+1 ( Sales Dashboard)',
    'pages.operations.operationsdashboardpage.bd2855ba': 'Under construction',
    'pages.operations.operationsdashboardpage.ea37940c': 'Planned',
    'pages.operations.operationsdashboardpage.f7353913': 'M+3 ( Jira / GitLab)',
    'pages.opportunity.opportunitycreatemodal.031c743c': 'Customer category is required',
    'pages.opportunity.opportunitycreatemodal.03e4387c': 'Please check required fields',
    'pages.opportunity.opportunitycreatemodal.041b03fc': 'Country/Region is required',
    'pages.opportunity.opportunitycreatemodal.select_customer_first': 'Select a customer first',
    'pages.opportunity.opportunitycreatemodal.account_placeholder':
      'Select or search for an account',
    'pages.opportunity.opportunitycreatemodal.contact_placeholder':
      'Select or search for a contact',
    'pages.opportunity.opportunitycreatemodal.sales_support_placeholder':
      'Select or search for sales technical support',
    'pages.opportunity.opportunitycreatemodal.service_pm_placeholder':
      'Select or search for a service PM',
    'pages.opportunity.opportunitycreatemodal.043c4bb2': 'Project Type',
    'pages.opportunity.opportunitycreatemodal.05db6417': 'Primary Buyer',
    'pages.opportunity.opportunitycreatemodal.086f00ea': 'Currency is required',
    'pages.opportunity.opportunitycreatemodal.09bae6df': 'Opportunity Expected Close Date',
    'pages.opportunity.opportunitycreatemodal.0f198fc0': 'Project info',
    'pages.opportunity.opportunitycreatemodal.11e87292': 'Bidding / Partners',
    'pages.opportunity.opportunitycreatemodal.18049d88': 'Create and Open',
    'pages.opportunity.opportunitycreatemodal.18daca9b': 'Sales Technical Support',
    'pages.opportunity.opportunitycreatemodal.1b6c7bd2': 'Signing Entity',
    'pages.opportunity.opportunitycreatemodal.1d94adfb': 'Time',
    'pages.opportunity.opportunitycreatemodal.1e7f8753':
      'Attachments: {{v0}} succeeded / {{v1}} failed. Failed files can be uploaded again on the detail page.',
    'pages.opportunity.opportunitycreatemodal.1ff172b9': 'Project Priority',
    'pages.opportunity.opportunitycreatemodal.22de5bd3': 'Contact information is required',
    'pages.opportunity.opportunitycreatemodal.230a16f3': 'Budget amount',
    'pages.opportunity.opportunitycreatemodal.23bd03ad':
      'Attachment upload failed ({{v0}}). You can upload again from the Attachments tab on the detail page.',
    'pages.opportunity.opportunitycreatemodal.2703a5c1': 'Estimated close date is required',
    'pages.opportunity.opportunitycreatemodal.2a4256ce': 'Probability(%)',
    'pages.opportunity.opportunitycreatemodal.2cbfce14': 'Sales Mode',
    'pages.opportunity.opportunitycreatemodal.300da871': 'Sales Forecast Amount',
    'pages.opportunity.opportunitycreatemodal.3149cace': 'Description / Note',
    'pages.opportunity.opportunitycreatemodal.35c4f7ac': 'Overseas Opportunity Fields',
    'pages.opportunity.opportunitycreatemodal.37af947d': 'Signing entity is required',
    'pages.opportunity.opportunitycreatemodal.3ad04bc0': 'Project Status',
    'pages.opportunity.opportunitycreatemodal.3ad85452': 'Geography',
    'pages.opportunity.opportunitycreatemodal.3f63ee65': 'Account',
    'pages.opportunity.opportunitycreatemodal.41363cb3': 'Opportunity · Opportunity · Sales Hub',
    'pages.opportunity.opportunitycreatemodal.44509753': 'Finance',
    'pages.opportunity.opportunitycreatemodal.4613644d': ' files)',
    'pages.opportunity.opportunitycreatemodal.46a8d839': 'Choose Document Category',
    'pages.opportunity.opportunitycreatemodal.4967857d': 'Application is required',
    'pages.opportunity.opportunitycreatemodal.4ebdcd82': 'Contact Method',
    'pages.opportunity.opportunitycreatemodal.510c75e6': 'Default RMB, USD / EUR',
    'pages.opportunity.opportunitycreatemodal.5c92f090': 'Opportunity Name',
    'pages.opportunity.opportunitycreatemodal.5cd06b91': 'Cancel',
    'pages.opportunity.opportunitycreatemodal.63ec756f': 'Name / Job Title',
    'pages.opportunity.opportunitycreatemodal.6acfd33f': 'Project type is required',
    'pages.opportunity.opportunitycreatemodal.6c0f51c5': 'Sales mode is required',
    'pages.opportunity.opportunitycreatemodal.72ba1207': 'Phone / Email /',
    'pages.opportunity.opportunitycreatemodal.72ce7c46': 'Summary',
    'pages.opportunity.opportunitycreatemodal.74390355': 'In Progress',
    'pages.opportunity.opportunitycreatemodal.77e74ae6':
      'Files are uploaded automatically after creation. Use the category dropdown to remove a file.',
    'pages.opportunity.opportunitycreatemodal.78a62d03': 'Est. close date',
    'pages.opportunity.opportunitycreatemodal.7be85174': 'Project priority is required',
    'pages.opportunity.opportunitycreatemodal.7f051d2a':
      '💡 Activity (right panel) Field, + AI Summary',
    'pages.opportunity.opportunitycreatemodal.80d90ab5': 'Project Background',
    'pages.opportunity.opportunitycreatemodal.813de902': 'Province',
    'pages.opportunity.opportunitycreatemodal.839ba8a7':
      'Calculated automatically from the sales forecast',
    'pages.opportunity.opportunitycreatemodal.861dcf62': 'Cancel(Discard',
    'pages.opportunity.opportunitycreatemodal.87acb0a8': 'Basic Information',
    'pages.opportunity.opportunitycreatemodal.88011993': 'Attachments',
    'pages.opportunity.opportunitycreatemodal.8955fbeb':
      'Status: ...&#10;Support needs: ...&#10;Risk: ...',
    'pages.opportunity.opportunitycreatemodal.8d06d914':
      'Files are uploaded automatically after the opportunity is created. Maximum file size: 10 MB.',
    'pages.opportunity.opportunitycreatemodal.8d69e675': 'Required',
    'pages.opportunity.opportunitycreatemodal.91385c3b': 'Created opportunity {{v0}}',
    'pages.opportunity.opportunitycreatemodal.92ce726e': 'Involvement of partners',
    'pages.opportunity.opportunitycreatemodal.92f5a55a': 'Status reason',
    'pages.opportunity.opportunitycreatemodal.93896b12': 'Uploaded {{v0}} attachments',
    'pages.opportunity.opportunitycreatemodal.94a9978a': 'Amount',
    'pages.opportunity.opportunitycreatemodal.95181120': 'Record Currency',
    'pages.opportunity.opportunitycreatemodal.954bbb01': 'Customer budget is required',
    'pages.opportunity.opportunitycreatemodal.97afdc8e': 'End User',
    'pages.opportunity.opportunitycreatemodal.986a345a': 'Create failed: {{v0}}',
    'pages.opportunity.opportunitycreatemodal.opp.create_with_forecast_success':
      'Created opportunity {{v0}} and saved {{v1}} sales forecast row(s)',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_create_failed':
      'Sales forecast save failed, so the opportunity was not created. A draft has been saved. Reason: {{v0}}',
    'pages.opportunity.opportunitycreatemodal.9aeb5110': 'Pending upload',
    'pages.opportunity.opportunitycreatemodal.9b82c3f9': 'Bidding involved',
    'pages.opportunity.opportunitycreatemodal.9c4a3467':
      'ZPSIF009.ZXMJE - SAP amount, based on estimated revenue',
    'pages.opportunity.probabilityTips.10.real': 'Meet customer, identify the opportunity is real',
    'pages.opportunity.probabilityTips.25.responsiblePeople':
      'Meet responsible people, understand project timeline and target size',
    'pages.opportunity.probabilityTips.50.decisionMaker':
      'Meet decision maker, understand the key factors of winning the project. Budget confirmed.',
    'pages.opportunity.probabilityTips.50.competitors':
      'Understand the competitors info, incl. product spec, pricing, payment term, etc.',
    'pages.opportunity.probabilityTips.50.technicalRequirement':
      'Got confirmation from customer about the technical requirement and matches with Baicells offering',
    'pages.opportunity.probabilityTips.75.trialSuccess':
      'Proof concept / Trial successful and get confirmation from customer',
    'pages.opportunity.probabilityTips.75.commercialOffering':
      'Commercial offering meet customer expectation',
    'pages.opportunity.probabilityTips.90.contractReview':
      'Reviewing contract with term and conditions almost agreed',
    'pages.opportunity.probabilityTips.100.contractSigned':
      'Contract signed and down payment received if any',
    'pages.opportunity.opportunitycreatemodal.a31b60d0': 'Account is required',
    'pages.opportunity.opportunitycreatemodal.a4e78b48': 'Customer budget status is required',
    'pages.opportunity.opportunitycreatemodal.a542a0ce': 'Brand',
    'pages.opportunity.opportunitycreatemodal.a5acad4a': '- Save',
    'pages.opportunity.opportunitycreatemodal.a6979ccb': 'Customer Budget',
    'pages.opportunity.opportunitycreatemodal.a85ebbb9': 'Domestic sales type - select a province',
    'pages.opportunity.opportunitycreatemodal.ab0f691a':
      'Overseas sales type - select a country. The opportunity name is generated automatically.',
    'pages.opportunity.opportunitycreatemodal.ab6dae2c': 'Contact',
    'pages.opportunity.opportunitycreatemodal.b028d616':
      'manual §3.2 sales weekly report - Update"Status/Support needs/Risk"',
    'pages.opportunity.opportunitycreatemodal.b23e5207': 'Customer Category',
    'pages.opportunity.opportunitycreatemodal.b3967cb9': 'Details',
    'pages.opportunity.opportunitycreatemodal.b52c6181': 'Remove',
    'pages.opportunity.opportunitycreatemodal.b939e5d3': 'Project Details',
    'pages.opportunity.opportunitycreatemodal.b9cb0314':
      'Project background, account needs, pain points, etc.',
    'pages.opportunity.opportunitycreatemodal.bc8b9962': 'Primary buyer is required',
    'pages.opportunity.opportunitycreatemodal.bef7038d': 'Estimated revenue is required',
    'pages.opportunity.opportunitycreatemodal.bfbe2f15': 'Unknown error',
    'pages.opportunity.opportunitycreatemodal.c18aeac9':
      'Add files, select a category for each file, then add them to the list:',
    'pages.opportunity.opportunitycreatemodal.c3dfbd6a': 'Quick Create Opportunity',
    'pages.opportunity.opportunitycreatemodal.c659f59d': 'Opportunity name is required',
    'pages.opportunity.opportunitycreatemodal.c902bd03': 'Sales Technical Support is required',
    'pages.opportunity.opportunitycreatemodal.ca23d7e6': 'Opportunity Contact (Account Contact)',
    'pages.opportunity.opportunitycreatemodal.ca36c91d':
      'Copied automatically from the lead description when the lead is qualified',
    'pages.opportunity.opportunitycreatemodal.cfc77d20': 'Country/Region',
    'pages.opportunity.opportunitycreatemodal.d128188c':
      'Province is required for domestic opportunities',
    'pages.opportunity.opportunitycreatemodal.d20c9575': 'Application',
    'pages.opportunity.opportunitycreatemodal.d32aee7f': 'Lead Source',
    'pages.opportunity.opportunitycreatemodal.d7d6c66b':
      'Click or drag files to upload, then select a category',
    'pages.opportunity.opportunitycreatemodal.dbf0109a': 'Opportunity(Optional)',
    'pages.opportunity.opportunitycreatemodal.dfc942e4': 'Service PM',
    'pages.opportunity.opportunitycreatemodal.e8c14868': 'Total',
    'pages.opportunity.opportunitycreatemodal.f2d7b8bd': 'Project status is required',
    'pages.opportunity.opportunitycreatemodal.fb518628': 'Sales Info',
    'pages.opportunity.opportunitycreatemodal.feebfbe9': ' files',
    'pages.opportunity.opportunitycreatemodal.ff24b05a': 'Contact is required',
    'pages.opportunity.opportunitycreatemodal.opp.account_tooltip':
      'After selecting Account, Country/Region / Sales Mode / Signing Entity / Currency / Customer Category are inherited; Customer Category can still be overridden below',
    'pages.opportunity.opportunitycreatemodal.opp.marketseg_tooltip':
      'Inherited from selected Account by default; adjustable per-opportunity',
    'pages.opportunity.opportunitycreatemodal.opp.decision_maker_label': 'Decision Maker',
    'pages.opportunity.opportunitycreatemodal.opp.decision_maker_required':
      'Decision Maker is required',
    'pages.opportunity.opportunitycreatemodal.opp.decision_maker_placeholder':
      'Enter decision maker name / role / contact',
    'pages.opportunity.opportunitycreatemodal.opp.yes': 'Yes',
    'pages.opportunity.opportunitycreatemodal.opp.no': 'No',
    'pages.opportunity.opportunitycreatemodal.opp.background_required':
      'Project Background is required',
    'pages.opportunity.opportunitycreatemodal.opp.leadsource_required': 'Lead Source is required',
    'pages.opportunity.opportunitycreatemodal.opp.status_reason_label': 'Status Reason',
    'pages.opportunity.opportunitycreatemodal.opp.status_reason_required':
      'Status Reason is required',
    'pages.opportunity.opportunitycreatemodal.opp.status_reason_in_progress': 'In Progress',
    'pages.opportunity.opportunitycreatemodal.opp.status_reason_on_hold': 'On Hold',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_tab': 'Sales Forecast',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_section_title': 'Forecast Lines',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_section_hint':
      'Rows are batch-saved to the Sales Forecast subgrid after the opportunity is created; overseas teams should enter at least one row',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_add_row': 'Add Forecast Row',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_edit_row': 'Edit Forecast Row',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_empty':
      'No forecast rows yet — click "Add Forecast Row" on the top right',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_class': 'Class',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_subclass': 'Subclass',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_band': 'Frequency Band',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_qty': 'Quantity',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_unit_price': 'Unit Price',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_revenue': 'Estimated Revenue',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_total_price': 'Total Price',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_total_price_placeholder':
      'Auto-calculated from quantity × unit price',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_comments': 'Comments',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_status': 'Status',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_probability': 'Probability',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_order_timing': 'Order Timing',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_product_comments': 'Product Comments',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_status_placeholder': 'Select status',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_probability_placeholder':
      'Select probability',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_order_timing_placeholder':
      'Select order timing',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_product_comments_placeholder':
      'Enter product comments',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_subclass_first': 'Select subclass first',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_no_bands': 'No bands for this subclass',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_status_ongoing': 'Ongoing',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_status_closed_po': 'Closed - Receive PO',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_status_closed_lost': 'Closed as lost',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_status_deleted':
      'Deleted due to input error',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_class_required': 'Class is required',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_subclass_required':
      'Subclass is required',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_qty_required': 'Quantity is required',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_subclass_disabled': 'Select Class first',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_class_placeholder':
      'Select product class',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_subclass_placeholder':
      'Select product subclass',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_band_placeholder': 'Optional',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_qty_placeholder':
      'Enter expected quantity',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_unit_price_placeholder':
      'Optional (used to compute estimated revenue)',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_comments_placeholder': 'Optional',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_save_btn': 'Save to List',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_count_summary': '{{v0}} row(s) staged',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_total_amount': 'Est. Amount',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_batch_success':
      'Forecast batch saved ({{v0}} rows)',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_batch_partial':
      'Forecast partially saved: {{v0}} ok / {{v1}} failed',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_batch_failed':
      'All forecast rows failed to save ({{v0}})',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_auto_saved':
      'Unsaved forecast row auto-saved',
    'pages.opportunity.opportunitycreatemodal.opp.forecast_unsaved_error':
      'Forecast row incomplete, please complete or clear it: {{v0}}',
    'pages.opportunity.opportunitydetailpage.0327b416': 'Cancel',
    'pages.opportunity.opportunitydetailpage.04ef7602': 'Country Code',
    'pages.opportunity.opportunitydetailpage.1149cd5e': 'Overseas',
    'pages.opportunity.opportunitydetailpage.121c5894': 'Team / Stage /',
    'pages.opportunity.opportunitydetailpage.1676875b': '{{v0}} days',
    'pages.opportunity.opportunitydetailpage.1de24c9a': 'Open for {{v0}}',
    'pages.opportunity.opportunitydetailpage.31b372e4': 'POC {{v0}} failed',
    'pages.opportunity.opportunitydetailpage.32db6524': '{{v0}} minutes',
    'pages.opportunity.opportunitydetailpage.3dbef334': 'Operation failed',
    'pages.opportunity.opportunitydetailpage.40fcbc48': ': Low / AccountBudget',
    'pages.opportunity.opportunitydetailpage.4330440d': '{{v0}} hours',
    'pages.opportunity.opportunitydetailpage.476c5438':
      'The opportunity BPF has not started (created by data import or SQL)',
    'pages.opportunity.opportunitydetailpage.47ed29df': 'Approval passed',
    'pages.opportunity.opportunitydetailpage.52ce1ccd': 'Amount',
    'pages.opportunity.opportunitydetailpage.5d9066a1':
      'POC process: Request -> Review -> Complete; email + OA notification',
    'pages.opportunity.opportunitydetailpage.6084f401': 'Owner',
    'pages.opportunity.opportunitydetailpage.67791459': 'System information',
    'pages.opportunity.opportunitydetailpage.67d5e10c': 'Business Details',
    'pages.opportunity.opportunitydetailpage.693aee6c':
      'The project is approved. Advance the BPF to the next stage.',
    'pages.opportunity.opportunitydetailpage.6cad28f4': '{{v0}} months',
    'pages.opportunity.opportunitydetailpage.6e037130': '🎉 Won',
    'pages.opportunity.opportunitydetailpage.70965927': 'Est. close date',
    'pages.opportunity.opportunitydetailpage.7ac9837a': 'Opportunitydetailpage',
    'pages.opportunity.opportunitydetailpage.84a0c30b': 'Project approval failed',
    'pages.opportunity.opportunitydetailpage.85c29c9a': 'Account',
    'pages.opportunity.opportunitydetailpage.8e0e101e': 'Submit notification for OA review',
    'pages.opportunity.opportunitydetailpage.8ff613bc': 'POC {{v0}} completed',
    'pages.opportunity.opportunitydetailpage.9bb57e81': 'Basic Information',
    'pages.opportunity.opportunitydetailpage.a158491e': 'Probability',
    'pages.opportunity.opportunitydetailpage.a94ee3e4': 'Approval passed',
    'pages.opportunity.opportunitydetailpage.b37feac7': 'Click a stage to advance',
    'pages.opportunity.opportunitydetailpage.b5f674f9': 'Mark as Lost',
    'pages.opportunity.opportunitydetailpage.ba4511a9': 'Amount / Time',
    'pages.opportunity.opportunitydetailpage.cd38882c': 'Completed at',
    'pages.opportunity.opportunitydetailpage.d3bbf417': 'Opportunity(statecode=Won)',
    'pages.opportunity.opportunitydetailpage.e4ebdafc': 'Click to advance the stage',
    'pages.opportunity.opportunitydetailpage.f1db8e93': 'Stage:',
    'pages.opportunity.opportunitydetailpage.f5176dd3': 'Request',
    'pages.opportunity.opportunitydetailpage.f71663cd': 'Top 5 Opportunities',
    'pages.opportunity.opportunitydetailpage.submit.btn': 'Submit',
    'pages.opportunity.opportunitydetailpage.submit.title': 'Submit for project approval?',
    'pages.opportunity.opportunitydetailpage.submit.desc':
      'Submit the opportunity to approver (iws_audit_status 0→1), assign approval task and send OA todo',
    'pages.opportunity.opportunitydetailpage.submit.ok_text': 'Submit',
    'pages.opportunity.opportunitydetailpage.submit.ok': 'Submitted for project approval',
    'pages.opportunity.opportunitydetailpage.submit.fail': 'Submit failed',
    'pages.opportunity.opportunitydetailpage.cancel_submission.btn': 'Cancel Submission',
    'pages.opportunity.opportunitydetailpage.cancel_submission.ok': 'Submission cancelled',
    'pages.opportunity.opportunitydetailpage.cancel_submission.fail': 'Cancel submission failed',
    'pages.opportunity.opportunitydetailpage.publish.btn': 'Publish opportunity',
    'pages.opportunity.opportunitydetailpage.publish.title': 'Publish this opportunity?',
    'pages.opportunity.opportunitydetailpage.publish.desc':
      'After publication, domestic sales users can view this opportunity from the sales dashboard, but cannot edit it.',
    'pages.opportunity.opportunitydetailpage.publish.ok_text': 'Publish',
    'pages.opportunity.opportunitydetailpage.publish.ok': 'Opportunity published',
    'pages.opportunity.opportunitydetailpage.publish.fail': 'Publication failed',
    'pages.opportunity.opportunitydetailpage.publish.overdue_disabled':
      'Overdue opportunities cannot be published',
    'pages.opportunity.opportunitydetailpage.publish.closed_disabled':
      'Closed opportunities cannot be published',
    'pages.opportunity.opportunitydetailpage.unpublish.btn': 'Withdraw publication',
    'pages.opportunity.opportunitydetailpage.unpublish.title': 'Withdraw this publication?',
    'pages.opportunity.opportunitydetailpage.unpublish.desc':
      'After withdrawal, only users with the original opportunity permissions can continue to view it.',
    'pages.opportunity.opportunitydetailpage.unpublish.ok_text': 'Withdraw',
    'pages.opportunity.opportunitydetailpage.unpublish.ok': 'Publication withdrawn',
    'pages.opportunity.opportunitydetailpage.unpublish.fail': 'Withdrawal failed',
    'pages.opportunity.opportunitydetailpage.sap_sync.idle': 'SAP not synced',
    'pages.opportunity.opportunitydetailpage.sap_sync.retry': 'Sync SAP',
    'pages.opportunity.opportunitydetailpage.sap_sync.syncing': 'Syncing SAP',
    'pages.opportunity.opportunitydetailpage.sap_sync.done': 'SAP sync complete',
    'pages.opportunity.opportunitydetailpage.sap_sync.start.ok': 'SAP project sync started',
    'pages.opportunity.opportunitydetailpage.sap_sync.start.fail':
      'Failed to start SAP project sync',
    'pages.opportunity.opportunitydetailpage.poc.awaiting_inbox': '· OA approval flow in progress',
    'pages.opportunity.opportunitydetailpage.poc.button_locked_until_stage':
      'Available once the opportunity reaches the POC Application stage; the dialog offers both "Apply" and "Skip POC"',
    'pages.opportunity.opportunitydetailpage.poc.button_locked_status':
      'The POC flow has started. Check the approval or OA progress.',
    'pages.opportunity.opportunitydetailpage.poc.preapproval_required':
      'Click POC Apply to submit POC approval first.',
    'pages.opportunity.opportunitydetailpage.poc.preapproval_pending':
      'POC approval is in progress. The OA POC flow will start automatically after approval.',
    'pages.opportunity.opportunitydetailpage.poc.preapproval_rejected':
      'CREST POC approval was rejected. Re-advance the process or contact the approver.',
    'pages.opportunity.opportunitydetailpage.poc.preapproval_pending_short':
      '· CREST POC approval in progress',
    'pages.opportunity.pocactionmodal.title': 'POC Testing — Apply or Skip',
    'pages.opportunity.pocactionmodal.cancel': 'Cancel',
    'pages.opportunity.pocactionmodal.ok_apply': 'Submit POC approval',
    'pages.opportunity.pocactionmodal.ok_skip': 'Skip POC and move to Negotiation',
    'pages.opportunity.pocactionmodal.intro_title': 'POC testing is optional',
    'pages.opportunity.pocactionmodal.intro_desc':
      'If the customer requires a POC, submit an application for approval. Otherwise, you may skip POC and the BPF will jump past "POC" directly to "Negotiation".',
    'pages.opportunity.pocactionmodal.opt_apply': 'Apply for POC testing',
    'pages.opportunity.pocactionmodal.opt_apply_desc':
      'Submits CREST POC approval first. After approval, the system automatically starts the OA POC flow.',
    'pages.opportunity.pocactionmodal.apply_notify_title': 'Submit POC approval',
    'pages.opportunity.pocactionmodal.apply_notify_desc':
      'Only "Apply for POC testing" submits POC approval. "Skip POC" does not start approval or notify OA.',
    'pages.opportunity.pocactionmodal.opt_skip': 'Skip POC',
    'pages.opportunity.pocactionmodal.opt_skip_desc':
      'Do not apply for POC. The BPF jumps over "POC" and advances to "Negotiation". After skipping, a new POC application cannot be raised on this opportunity.',
    'pages.opportunity.pocactionmodal.deadline_label': 'Target completion date (optional)',
    'pages.opportunity.pocactionmodal.deadline_placeholder': 'Pick a target date',
    'pages.opportunity.pocactionmodal.remark_label': 'Remark (optional)',
    'pages.opportunity.pocactionmodal.remark_placeholder':
      'Add POC configuration / requirement notes',
    'pages.opportunity.pocactionmodal.skip_warn_title': 'Confirm skipping POC',
    'pages.opportunity.pocactionmodal.skip_warn_desc':
      'The opportunity will jump directly to "Negotiation", bypassing POC testing. Reversal requires an admin to reset the BPF.',
    'pages.opportunity.pocactionmodal.apply_ok':
      'POC approval submitted. The OA POC flow will start automatically after approval.',
    'pages.opportunity.pocactionmodal.apply_success_title': 'POC approval submitted',
    'pages.opportunity.pocactionmodal.apply_success_desc':
      'After approval, the system will automatically start the OA POC flow.',
    'pages.opportunity.pocactionmodal.apply_error_title': 'Failed to submit POC approval',
    'pages.opportunity.pocactionmodal.success_ok': 'Got it',
    'pages.opportunity.pocactionmodal.skip_ok': 'POC skipped — opportunity is now in "Negotiation"',
    'pages.opportunity.pocactionmodal.error': 'Operation failed',
    'pages.opportunity.opportunitydetailpage.bpf.rollback_blocked':
      'Opportunities are locked once advanced — rolling back to an earlier stage is not supported',
    'pages.opportunity.opportunitydetailpage.bpf.advance_blocked_unapproved':
      'Opportunity is not approved — submit it for project approval and wait for approval before advancing; once approved you can jump across multiple stages',
    'pages.opportunity.stageadvancemodal.02a754fd': 'Please select',
    'pages.opportunity.stageadvancemodal.0480878c': 'Advance failed: {{v0}}',
    'pages.opportunity.stageadvancemodal.0eedb546':
      '💡 Tip: "Main progress / Risk / Decision chain"',
    'pages.opportunity.stageadvancemodal.36532716': 'Unknown error',
    'pages.opportunity.stageadvancemodal.4d5007f4': 'Select date',
    'pages.opportunity.stageadvancemodal.poc.yes': 'Yes',
    'pages.opportunity.stageadvancemodal.poc.no': 'No',
    'pages.opportunity.stageadvancemodal.504f02ee': 'Add items for team collaboration (M40 ready)',
    'pages.opportunity.stageadvancemodal.a7aa4a94':
      'The current stage has no required fields. You can advance.',
    'pages.opportunity.stageadvancemodal.a954b51e': 'Advanced to {{v0}}',
    'pages.opportunity.stageadvancemodal.becc9ba5': 'Activities',
    'pages.opportunity.stageadvancemodal.c9912179':
      'Next stage expected end date cannot be earlier than today',
    'pages.opportunity.stageadvancemodal.d2288c73':
      'D365 business rule (Section 3.5): Enter the estimated completion date before advancing the stage.',
    'pages.opportunity.stageadvancemodal.d3d94dc9': 'Please fill in: {{v0}}',
    'pages.opportunity.stageadvancemodal.dd6f0a00': 'Not configured picker target',
    'pages.opportunity.stageadvancemodal.f5968d9c': '(Data)',
    'pages.pricing.pricingpages.02ef634d': 'List Price (USD)',
    'pages.pricing.pricingpages.0a99c718': 'Gross Margin',
    'pages.pricing.pricingpages.0bc172ab': 'Inactive',
    'pages.pricing.pricingpages.1568d874': '- LowApproval',
    'pages.pricing.pricingpages.18defa4c': 'Province',
    'pages.pricing.pricingpages.1931bd67': 'No matching domestic price records',
    'pages.pricing.pricingpages.1d998702': 'No matching overseas price records',
    'pages.pricing.pricingpages.26420e68': 'Band',
    'pages.pricing.pricingpages.3b55111f': 'Model',
    'pages.pricing.pricingpages.3e2aae21': 'Effective From',
    'pages.pricing.pricingpages.5ae00389': 'items',
    'pages.pricing.pricingpages.5ccdb26d': 'Name',
    'pages.pricing.pricingpages.73cfe830': 'Overseas Pricing',
    'pages.pricing.pricingpages.7785ef82': 'Refresh',
    'pages.pricing.pricingpages.7f42a267': 'Validity',
    'pages.pricing.pricingpages.83613fa3': 'Country',
    'pages.pricing.pricingpages.85a38efe': 'items · Country / (USD)',
    'pages.pricing.pricingpages.86156536': 'Base Price',
    'pages.pricing.pricingpages.9229bd37': 'Cost Price 🔒',
    'pages.pricing.pricingpages.a574d9e8': 'Quote Base Price',
    'pages.pricing.pricingpages.a7c2abe6': 'Domestic Pricing',
    'pages.pricing.pricingpages.b2952938': 'List Price',
    'pages.pricing.pricingpages.bd00b6d7': 'Sales Price',
    'pages.pricing.pricingpages.bd2de7d8': 'No expiry',
    'pages.pricing.pricingpages.cad5863b': 'items · Province × 5-tuple',
    'pages.pricing.pricingpages.cb34b4f0': 'No matching price records',
    'pages.pricing.pricingpages.cbad5dee': 'Active',
    'pages.pricing.pricingpages.df8b2f04': 'Related Model',
    'pages.pricing.pricingpages.e1b1e8ad': 'Authorized 🚨',
    'pages.pricing.pricingpages.e8d11724': 'Field-level security - RoleVisible',
    'pages.pricing.pricingpages.fd23f9d4': 'Product Subclass',
    'pages.quote.quotecreatemodal.008009d8': 'Created quote {{v0}}',
    'pages.quote.quotecreatemodal.0101ccbe': 'Quote name is required',
    'pages.quote.quotecreatemodal.0b35046c': 'Freight Terms',
    'pages.quote.quotecreatemodal.0b63e91f': 'Effective date is required',
    'pages.quote.quotecreatemodal.149c1be0':
      'Overseas BPF (Drafting -> Freight Quote -> Double Check -> Overseas VP)',
    'pages.quote.quotecreatemodal.181cb14c': 'City',
    'pages.quote.quotecreatemodal.19ed6cb1': 'Discount Amount',
    'pages.quote.quotecreatemodal.1a713759': 'Signing Entity',
    'pages.quote.quotecreatemodal.200105d0': '- Save',
    'pages.quote.quotecreatemodal.24ad2d75': 'Quote · Quote ·',
    'pages.quote.quotecreatemodal.29d6fdad': 'Street',
    'pages.quote.quotecreatemodal.3fd1bf19': 'Expires On',
    'pages.quote.quotecreatemodal.456bbb91': 'Authorized Amount (BAP Red Line)',
    'pages.quote.quotecreatemodal.47a6f980': 'Price List',
    'pages.quote.quotecreatemodal.4bbb6d6d': 'Attachments',
    'pages.quote.quotecreatemodal.4e1325fb': 'Description / Terms',
    'pages.quote.quotecreatemodal.4fe74945': 'Unknown error',
    'pages.quote.quotecreatemodal.52c2c490': 'Opportunity',
    'pages.quote.quotecreatemodal.586105da': 'Create and Open',
    'pages.quote.quotecreatemodal.591437d8': 'Please check required fields',
    'pages.quote.quotecreatemodal.5d94d51b': 'Account',
    'pages.quote.quotecreatemodal.5e2aef0b': 'Contact Name',
    'pages.quote.quotecreatemodal.5f82641f': 'Overseas Business',
    'pages.quote.quotecreatemodal.63e39cad': 'Logistics & Freight',
    'pages.quote.quotecreatemodal.6bc09fc5': 'Country',
    'pages.quote.quotecreatemodal.743016c1': 'Cancel',
    'pages.quote.quotecreatemodal.780e76ce': 'Quote Name',
    'pages.quote.quotecreatemodal.7f287eab': 'New Quote',
    'pages.quote.quotecreatemodal.88dca3ae':
      '💡 after creationquote detail pageApproved BOQ SyncProduct + Attachments tab Upload',
    'pages.quote.quotecreatemodal.9ce163af': 'Discount %',
    'pages.quote.quotecreatemodal.9e34deca': 'Details',
    'pages.quote.quotecreatemodal.a5df2048': 'Billing Address',
    'pages.quote.quotecreatemodal.b1740255': 'Related Opportunities',
    'pages.quote.quotecreatemodal.b711b561': '(Price List), AffectedQuote LinesDefault',
    'pages.quote.quotecreatemodal.bca8fd69': 'Effective To',
    'pages.quote.quotecreatemodal.be6fb7aa': 'Pricing & Discount',
    'pages.quote.quotecreatemodal.c297f473': 'Create failed: {{v0}}',
    'pages.quote.quotecreatemodal.c7b34093': '{{v0}} - Quote',
    'pages.quote.quotecreatemodal.ca5f50fd': 'Payment Terms',
    'pages.quote.quotecreatemodal.d0f7465f': 'Currency',
    'pages.quote.quotecreatemodal.d1bf470f': 'Summary',
    'pages.quote.quotecreatemodal.d5a9a711': 'Payment / Delivery / Warranty / Other notes...',
    'pages.quote.quotecreatemodal.db45d7a7': 'Account is required',
    'pages.quote.quotecreatemodal.e1fae0b6': 'Shipping Method',
    'pages.quote.quotecreatemodal.e47865ad': 'Validity',
    'pages.quote.quotecreatemodal.e4fe27d9': 'Terms & Conditions - after creationdetail pageEdit',
    'pages.quote.quotecreatemodal.eaac39e6': 'Signing entity is required',
    'pages.quote.quotecreatemodal.ee5d9aec': 'Effective From',
    'pages.quote.quotecreatemodal.f1a59137': 'Basic Information',
    'pages.quote.quotecreatemodal.fad34eaa': 'Freight Amount',
    'pages.quote.quotedetailpage.state_vs_bpf_tooltip':
      'This is the D365 "document state" (Draft / Active / Won / Lost) and is independent from the BPF stage. The quote may still be "Draft" while the BPF has advanced to "Price Review"; the document state only changes on explicit Activate / Win / Lose actions. Use the BPF stage bar as the source of truth for workflow position.',
    'pages.quote.quotedetailpage.0d262424': 'Subtotal',
    'pages.quote.quotedetailpage.0d6ffb87': 'Synced {{v0}} rows from BOQ{{v1}}',
    'pages.quote.quotedetailpage.1d6bad47': '{{v0}} months',
    'pages.quote.quotedetailpage.228215ef': 'Terms / Notes',
    'pages.quote.quotedetailpage.28eebe6c': 'PDF generation failed',
    'pages.quote.quotedetailpage.2b753d6b': 'Automatically advanced to {{v0}}',
    'pages.quote.quotedetailpage.3183a88a': 'BackOpportunityList',
    'pages.quote.quotedetailpage.43f84e7d': 'Quantity',
    'pages.quote.quotedetailpage.458e9c60': 'Number',
    'pages.quote.quotedetailpage.47b7c08f':
      'BOQ Website 3-5 Baicells 5G Product; 30% Unit priceLowauthorized price -> BAP banner',
    'pages.quote.quotedetailpage.4ac12af7': 'Terms',
    'pages.quote.quotedetailpage.57c46603':
      'LinkOpportunityClickSummaryMedium"LinkOpportunity"OpportunityDetails.',
    'pages.quote.quotedetailpage.57c9a08b': 'Cancel',
    'pages.quote.quotedetailpage.5bbea251': 'Related Opportunities',
    'pages.quote.quotedetailpage.63aad8b2': 'Not Started BPF(Data / SQL Create)',
    'pages.quote.quotedetailpage.6750108d':
      'BOQ Website (Mock) - BOQ system. Click "Refresh from BOQ" Product.',
    'pages.quote.quotedetailpage.67eb4511': 'Description',
    'pages.quote.quotedetailpage.6950b19e': 'Overseasprocess()',
    'pages.quote.quotedetailpage.7442bfe3': '{{v0}} hours',
    'pages.quote.quotedetailpage.83c474bc': 'Market, None VAT',
    'pages.quote.quotedetailpage.89450afb': 'Activate failed',
    'pages.quote.quotedetailpage.96fba303': 'Push failed',
    'pages.quote.quotedetailpage.97e5b019': 'BOQ sync failed',
    'pages.quote.quotedetailpage.9a9f122e': 'Unit price',
    'pages.quote.quotedetailpage.aa3a4697': 'Product',
    'pages.quote.quotedetailpage.b2d5598e': 'Auto advance failed',
    'pages.quote.quotedetailpage.b502912d': 'OverseasMarket',
    'pages.quote.quotedetailpage.bapWarningsSuffix': ' ({{count}} rows triggered BAP warnings)',
    'pages.quote.quotedetailpage.be769473': '{{v0}} minutes',
    'pages.quote.quotedetailpage.c46ed399': '{{v0}} days',
    'pages.quote.quotedetailpage.c665d6c3': 'Overseasprocess()',
    'pages.quote.quotedetailpage.c7093d85': 'NoneQuote Lines - Click BOQ Website Refresh from BOQ',
    'pages.quote.quotedetailpage.ce3ae1c7': 'Completed at',
    'pages.quote.quotedetailpage.cfa50868': 'Baicells China (Chinese)',
    'pages.quote.quotedetailpage.d0b373e3': 'DomesticMarket, VAT 13%',
    'pages.quote.quotedetailpage.e5bb0ba0': 'Domesticprocess',
    'pages.quote.quotedetailpage.ed97db61': 'Advance failed',
    'pages.quote.quotedetailpage.f4d0c250': 'Advanced to {{v0}}',
    'pages.quote.quotedetailpage.f62b8ba2': 'Quote activated',
    'pages.sales.weeklyreportpage.12f03af7': 'Nonesales weekly report',
    'pages.sales.weeklyreportpage.1d091eea': 'Quick Select',
    'pages.sales.weeklyreportpage.22c50231': 'manual §3.2 -',
    'pages.sales.weeklyreportpage.28a9e388': 'Weekly Report',
    'pages.sales.weeklyreportpage.48e1b1df': 'Last month',
    'pages.sales.weeklyreportpage.5878920a': 'Last week',
    'pages.sales.weeklyreportpage.67dd1767': 'OtherKey',
    'pages.sales.weeklyreportpage.7d0bda83': 'Failed to load weekly report',
    'pages.sales.weeklyreportpage.8428f9b8': 'Expand',
    'pages.sales.weeklyreportpage.8a2c25b1':
      'Salespersonopportunity detail page Activity Add note Type + weekly-update',
    'pages.sales.weeklyreportpage.9789196b': 'Refresh',
    'pages.sales.weeklyreportpage.b0e5bd0e': 'Weeklyreportpage',
    'pages.sales.weeklyreportpage.b9d85025': 'This month',
    'pages.sales.weeklyreportpage.bab04a8c': 'updates ·',
    'pages.sales.weeklyreportpage.c1e942d1': 'digitsSalesperson ·',
    'pages.sales.weeklyreportpage.c72e44ab': 'Salesperson "{{v0}}" was not found',
    'pages.sales.weeklyreportpage.d045d393':
      'Activities (OpportunityTime / Status / Risk), SalespersonUpdate. opportunity detail page Activity right panelQuick Create',
    'pages.sales.weeklyreportpage.d5f2b687': 'Weeklyreportpage',
    'pages.sales.weeklyreportpage.d87de868': ' updates',
    'pages.sales.weeklyreportpage.da054840': 'This week',
    'pages.sales.weeklyreportpage.e29107f4': 'Filter by salesperson',
    'pages.sinosure.sinosurecreatemodal.04940c69': 'Rejected',
    'pages.sinosure.sinosurecreatemodal.04defe01': 'RequestNameRequired',
    'pages.sinosure.sinosurecreatemodal.0530b2c8': 'Summary',
    'pages.sinosure.sinosurecreatemodal.0625e320': 'Request',
    'pages.sinosure.sinosurecreatemodal.09235a3a': 'Attachments',
    'pages.sinosure.sinosurecreatemodal.0edfe979': 'RiskStatus',
    'pages.sinosure.sinosurecreatemodal.106cec16': 'Finance',
    'pages.sinosure.sinosurecreatemodal.19930d1f': 'Currency',
    'pages.sinosure.sinosurecreatemodal.214b7a60': '- Save',
    'pages.sinosure.sinosurecreatemodal.2ca856c8': 'Create and Open',
    'pages.sinosure.sinosurecreatemodal.2e72a882': 'Pending acceptance',
    'pages.sinosure.sinosurecreatemodal.35688ef0': 'Unknown error',
    'pages.sinosure.sinosurecreatemodal.357cc44f': 'RequestNotes',
    'pages.sinosure.sinosurecreatemodal.38ef6afc': 'Low',
    'pages.sinosure.sinosurecreatemodal.3a35a8f8': 'Created Sinosure record {{v0}}',
    'pages.sinosure.sinosurecreatemodal.3b5b346a': 'Notes',
    'pages.sinosure.sinosurecreatemodal.47b3ed3e': 'RequestName',
    'pages.sinosure.sinosurecreatemodal.4b8f0771': 'High',
    'pages.sinosure.sinosurecreatemodal.4fbd23a2': 'Create failed: {{v0}}',
    'pages.sinosure.sinosurecreatemodal.605ca80d': 'Baicells Technologies Co. Ltd',
    'pages.sinosure.sinosurecreatemodal.62ebed32': 'Link',
    'pages.sinosure.sinosurecreatemodal.63b04175': 'Signing Entity',
    'pages.sinosure.sinosurecreatemodal.748debe6': ', 0.85% 0.0085',
    'pages.sinosure.sinosurecreatemodal.7659f734': 'Risk',
    'pages.sinosure.sinosurecreatemodal.7745f37e': 'Credit limitRequired',
    'pages.sinosure.sinosurecreatemodal.776a8002': 'Sinosure · Sinosure · Overseas',
    'pages.sinosure.sinosurecreatemodal.7ce15c1c': 'Medium',
    'pages.sinosure.sinosurecreatemodal.8729db71': 'Baicells Shenzhen Technology Co., Ltd.',
    'pages.sinosure.sinosurecreatemodal.8a818141': 'Sinosurecreatemodal',
    'pages.sinosure.sinosurecreatemodal.8cf57b46': 'Sinosurecreatemodal',
    'pages.sinosure.sinosurecreatemodal.99a90b8a': 'Basic Information',
    'pages.sinosure.sinosurecreatemodal.9aaa3db9': 'Cancel',
    'pages.sinosure.sinosurecreatemodal.9b4680f6': '(month)',
    'pages.sinosure.sinosurecreatemodal.9f4ad722': 'Accepted',
    'pages.sinosure.sinosurecreatemodal.a3c12030': 'Request',
    'pages.sinosure.sinosurecreatemodal.a4a744fc': 'Effective From',
    'pages.sinosure.sinosurecreatemodal.a9f2cbe2': 'RequestRequired',
    'pages.sinosure.sinosurecreatemodal.acee8b7d': 'Related Opportunities',
    'pages.sinosure.sinosurecreatemodal.bda7c31a': 'Status',
    'pages.sinosure.sinosurecreatemodal.bee3205a': 'month',
    'pages.sinosure.sinosurecreatemodal.c3053387': 'Premium',
    'pages.sinosure.sinosurecreatemodal.cc4b29ac': 'Sinosurecreatemodal',
    'pages.sinosure.sinosurecreatemodal.d53a27c1': 'Payment Terms',
    'pages.sinosure.sinosurecreatemodal.de4c11f1': 'Details',
    'pages.sinosure.sinosurecreatemodal.e25b3f19': 'Account',
    'pages.sinosure.sinosurecreatemodal.e30806f2': 'Please check required fields',
    'pages.sinosure.sinosurecreatemodal.e73cdcf7':
      '💡 after creationSinosuredetail page"Attachments"tab UploadRequest / Finance /',
    'pages.sinosure.sinosurecreatemodal.ee734c07': 'Low / Medium / High Risk',
    'pages.sinosure.sinosurecreatemodal.ef9dbb22': 'Credit limit',
    'pages.sinosure.sinosurecreatemodal.f51b988d': 'Account is required',
    'pages.sinosure.sinosurecreatemodal.f6eb3731': 'Quick CreateSinosure',
    'pages.sinosure.sinosuredetailpage.37c03bad': 'Finance',
    'pages.sinosure.sinosuredetailpage.40623c2d': 'SinosureNot Started BPF',
    'pages.sinosure.sinosuredetailpage.5c2516a6': 'Advance failed',
    'pages.sinosure.sinosuredetailpage.602d57dc': '{{v0}} minutes',
    'pages.sinosure.sinosuredetailpage.6818603e': 'Completed at',
    'pages.sinosure.sinosuredetailpage.7331544a': 'Advanced to {{v0}}',
    'pages.sinosure.sinosuredetailpage.7f997f32': 'Credit limit',
    'pages.sinosure.sinosuredetailpage.97826dd5': 'Amount',
    'pages.sinosure.sinosuredetailpage.ab849957': '{{v0}} months',
    'pages.sinosure.sinosuredetailpage.bb7b038c': '{{v0}} days',
    'pages.sinosure.sinosuredetailpage.d26ee839': '{{v0}} hours',
    'pages.sinosure.sinosuredetailpage.e46ceafe': 'Finance',
    'pages.welcomepage.0025c1af': 'items',
    'pages.welcomepage.18b4a6c2': 'M0 Stage(Basic)',
    'pages.welcomepage.1d9193c6': 'App + Sitemap + AdminScope(3 App )',
    'pages.welcomepage.3bc33906': 'Identity Module + JWT + 4 DepthPrivileges',
    'pages.welcomepage.41711f61': 'Next: M1 Backend Infrastructure',
    'pages.welcomepage.43f2439e': 'Baicells D365 - Welcome',
    'pages.welcomepage.6136eb7d': 'M0 Stage',
    'pages.welcomepage.6e770e76': 'Prisma db pull -> 70 type-safe client',
    'pages.welcomepage.71420b89': 'Business Rows',
    'pages.welcomepage.7b0f421c': 'API Endpoints',
    'pages.welcomepage.7f4a8867': '🎉 M0 KickoffSucceeded',
    'pages.welcomepage.98bdff0b': 'Monorepo Ready. Yes v5 Medium',
    'pages.welcomepage.9db12377': 'Tables',
    'pages.welcomepage.a10996b3': 'Ready',
    'pages.welcomepage.ae21054e': ', frontend -> backend -> databaseflow.',
    'pages.welcomepage.afb54d57': 'Field-level security (FSP) Interceptor',
    'pages.welcomepage.c58a36e5': '-> Sign in( digits)',
    'pages.welcomepage.eba17c75': 'Privilege Rules',
    'pages.welcomepage.f70b45ba': 'EventBus + CollectionService + AgentTool(Aion )',
    'pages.salesorder.salesorderdetailpage.active': 'Active',
    'pages.salesorder.salesorderdetailpage.amount': 'Amount',
    'pages.salesorder.salesorderdetailpage.amounts': 'Amounts',
    'pages.salesorder.salesorderdetailpage.basicInfo': 'Basic Information',
    'pages.salesorder.salesorderdetailpage.canceled': 'Canceled',
    'pages.salesorder.salesorderdetailpage.delivery': 'Delivery & Terms',
    'pages.salesorder.salesorderdetailpage.fulfilled': 'Fulfilled',
    'pages.salesorder.salesorderdetailpage.fulfillment': 'Fulfillment',
    'pages.salesorder.salesorderdetailpage.invoiced': 'Invoiced',
    'pages.salesorder.salesorderdetailpage.lineNo': 'Line No.',
    'pages.salesorder.salesorderdetailpage.lines': 'Order Products',
    'pages.salesorder.salesorderdetailpage.noLines': 'No order products yet',
    'pages.salesorder.salesorderdetailpage.product': 'Product',
    'pages.salesorder.salesorderdetailpage.quantity': 'Quantity',
    'pages.salesorder.salesorderdetailpage.statusOwner': 'Status & Owner',
    'pages.salesorder.salesorderdetailpage.submitted': 'Submitted',
    'pages.salesorder.salesorderdetailpage.summary': 'Summary',
    'pages.worklist.worklistpage.0a9112a5': 'Quote',
    'pages.worklist.worklistpage.1a0cfcd1': 'Refresh',
    'pages.worklist.worklistpage.276e0240': 'Total',
    'pages.worklist.worklistpage.2def98a3': 'Number / Notes',
    'pages.worklist.worklistpage.41934218': 'Title',
    'pages.worklist.worklistpage.480dd1c4': 'Total {{v0}} items',
    'pages.worklist.worklistpage.60da3722': 'All',
    'pages.worklist.worklistpage.62825ff9': 'Account',
    'pages.worklist.worklistpage.6c1fb958': 'Amount',
    'pages.worklist.worklistpage.9a2e77e7': 'Lead',
    'pages.worklist.worklistpage.a0b836cf': 'Status',
    'pages.worklist.worklistpage.ae8579ce': 'Type',
    'pages.worklist.worklistpage.b69062d0': 'Pending approval',
    'pages.worklist.worklistpage.d61e2077': 'Opportunity',
    'pages.worklist.worklistpage.e64e5c73': 'Modified On',
    'pages.worklist.worklistpage.edd642af': 'items',
  },
} as const;
